(function() {
  'use strict';
  window.slate = window.slate || {};
  window.polaroid = window.polaroid || {};

  /*================ Slate ================*/
  /**
   * A11y Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help make your theme more accessible
   * to users with visual impairments.
   *
   *
   * @namespace a11y
   */
  
  slate.a11y = {
  
    /**
     * For use when focus shifts to a container rather than a link
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects if focusing a link, just $link.focus();
     *
     * @param {JQuery} $element - The element to be acted upon
     */
    pageLinkFocus: function($element) {
      var focusClass = 'js-focus-hidden';
  
      $element.first()
        .attr('tabIndex', '-1')
        .focus()
        .addClass(focusClass)
        .one('blur', callback);
  
      function callback() {
        $element.first()
          .removeClass(focusClass)
          .removeAttr('tabindex');
      }
    },
  
    /**
     * If there's a hash in the url, focus the appropriate element
     */
    focusHash: function() {
      var hash = window.location.hash;
  
      // is there a hash in the url? is it an element on the page?
      if (hash && document.getElementById(hash.slice(1))) {
        this.pageLinkFocus($(hash));
      }
    },
  
    /**
     * When an in-page (url w/hash) link is clicked, focus the appropriate element
     */
    bindInPageLinks: function() {
      $('a[href*=#]').on('click', function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this));
    },
  
    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function(options) {
      var eventName = options.eventNamespace
        ? 'focusin.' + options.eventNamespace
        : 'focusin';
  
      if (!options.$elementToFocus) {
        options.$elementToFocus = options.$container;
      }
  
      options.$container.attr('tabindex', '-1');
      options.$elementToFocus.focus();
  
      $(document).on(eventName, function(evt) {
        if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
          options.$container.focus();
        }
      });
    },
  
    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (options.$container && options.$container.length) {
        options.$container.removeAttr('tabindex');
      }
  
      $(document).off(eventName);
    }
  };
  
  /**
   * Cart Template Script
   * ------------------------------------------------------------------------------
   * A file that contains scripts highly coupled to the Cart template.
   *
   * @namespace cart
   */
  
  slate.cart = {
  
    /**
     * Browser cookies are required to use the cart. This function checks if
     * cookies are enabled in the browser.
     */
    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;
  
      if (!cookieEnabled){
        document.cookie = 'testcookie';
        cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
      }
      return cookieEnabled;
    }
  };
  
  /**
   * Utility helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions for dealing with arrays and objects
   *
   * @namespace utils
   */
  
  slate.utils = {
  
    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    findInstance: function(array, key, value) {
      for (var i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
          return array[i];
        }
      }
    },
  
    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    removeInstance: function(array, key, value) {
      var i = array.length;
      while(i--) {
        if (array[i][key] === value) {
          array.splice(i, 1);
          break;
        }
      }
  
      return array;
    },
  
    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    compact: function(array) {
      var index = -1;
      var length = array == null ? 0 : array.length;
      var resIndex = 0;
      var result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
  };
  
  /**
   * Rich Text Editor
   * -----------------------------------------------------------------------------
   * Wrap videos in div to force responsive layout.
   *
   * @namespace rte
   */
  
  slate.rte = {
  
    wrapTable: function() {
      $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
    },
  
    iframeReset: function() {
      var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
      var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');
  
      $iframeVideo.each(function() {
        // Add wrapper to make video responsive
        $(this).wrap('<div class="rte__video-wrapper"></div>');
      });
  
      $iframeReset.each(function() {
        // Re-set the src attribute on each iframe after page load
        // for Chrome's "incorrect iFrame content on 'back'" bug.
        // https://code.google.com/p/chromium/issues/detail?id=395791
        // Need to specifically target video and admin bar
        this.src = this.src;
      });
    }
  };
  
  slate.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    $(document)
      .on('shopify:section:load', this._onSectionLoad.bind(this))
      .on('shopify:section:unload', this._onSectionUnload.bind(this))
      .on('shopify:section:select', this._onSelect.bind(this))
      .on('shopify:section:deselect', this._onDeselect.bind(this))
      .on('shopify:section:reorder', this._onReorder.bind(this))
      .on('shopify:block:select', this._onBlockSelect.bind(this))
      .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
    _createInstance: function(container, constructor) {
      var $container = $(container);
      var id = $container.attr('data-section-id');
      var type = $container.attr('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      var instance = $.extend(new constructor(container), {
        id: id,
        type: type,
        container: container
      });
  
      this.instances.push(instance);
    },
  
    _onSectionLoad: function(evt) {
      var container = $('[data-section-id]', evt.target)[0];
      if (container) {
        this._createInstance(container);
      }
    },
  
    _onSectionUnload: function(evt) {
      var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
  
      if (!instance) {
        return;
      }
  
      if (typeof instance.onUnload === 'function') {
        instance.onUnload(evt);
      }
  
      this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
    },
  
    _onSelect: function(evt) {
      var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
  
      if (instance && typeof instance.onSelect === 'function') {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
  
      if (instance && typeof instance.onDeselect === 'function') {
        instance.onDeselect(evt);
      }
    },
  
    _onReorder: function(evt) {
      var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
  
      if (instance && typeof instance.onReorder === 'function') {
        instance.onReorder(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
  
      if (instance && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
  
      if (instance && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(evt);
      }
    },
  
    register: function(type, constructor) {
      this.constructors[type] = constructor;
  
      $('[data-section-type=' + type + ']').each(function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this));
    }
  });
  
  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *
   */
  
  slate.Currency = (function() {
    var moneyFormat = '${{amount}}';
  
    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = slate.utils.defaultTo(precision, 2);
        thousands = slate.utils.defaultTo(thousands, ',');
        decimal = slate.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    return {
      formatMoney: formatMoney
    };
  })();
  
  /**
   * Image Helper Functions
   * -----------------------------------------------------------------------------
   * A collection of functions that help with basic image operations.
   *
   */
  
  slate.Image = (function() {
  
    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */
  
    function preload(images, size) {
      if (typeof images === 'string') {
        images = [images];
      }
  
      for (var i = 0; i < images.length; i++) {
        var image = images[i];
        this.loadImage(this.getSizedImageUrl(image, size));
      }
    }
  
    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path) {
      new Image().src = path;
    }
  
    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  
      if (match) {
        return match[1];
      } else {
        return null;
      }
    }
  
    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
      if (size === null) {
        return src;
      }
  
      if (size === 'master') {
        return this.removeProtocol(src);
      }
  
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
      if (match) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
  
        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      } else {
        return null;
      }
    }
  
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
  
    return {
      preload: preload,
      loadImage: loadImage,
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol
    };
  })();
  
  /**
   * Variant Selection scripts
   * ------------------------------------------------------------------------------
   *
   * Handles change events from the variant inputs in any `cart/add` forms that may
   * exist. Also updates the master select and triggers updates when the variants
   * price or image changes.
   *
   * @namespace variants
   */
  
  slate.Variants = (function() {
  
    /**
     * Variant constructor
     *
     * @param {object} options - Settings from `product.js`
     */
    function Variants(options) {
      this.$container = options.$container;
      this.product = options.product;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();
  
      $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }
  
    Variants.prototype = $.extend({}, Variants.prototype, {
  
      /**
       * Get the currently selected options from add-to-cart form. Works with all
       * form input elements.
       *
       * @return {array} options - Values of currently selected variants
       */
      _getCurrentOptions: function() {
        var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};
  
          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');
  
              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
  
            return currentOption;
          }
        });
  
        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = slate.utils.compact(currentOptions);
  
        return currentOptions;
      },
  
      /**
       * Find variant based on selected values.
       *
       * @param  {array} selectedValues - Values of variant inputs
       * @return {object || undefined} found - Variant object from product.variants
       */
      _getVariantFromOptions: function() {
        var selectedValues = this._getCurrentOptions();
        var variants = this.product.variants;
        var found = false;
  
        variants.forEach(function(variant) {
          var satisfied = true;
  
          selectedValues.forEach(function(option) {
            if (satisfied) {
              satisfied = (option.value === variant[option.index]);
            }
          });
  
          if (satisfied) {
            found = variant;
          }
        });
  
        return found || null;
      },
  
      /**
       * Event handler for when a variant input changes.
       */
      _onSelectChange: function() {
        var variant = this._getVariantFromOptions();
  
        this.$container.trigger({
          type: 'variantChange',
          variant: variant
        });
  
        if (!variant) {
          return;
        }
  
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this.currentVariant = variant;
  
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },
  
      /**
       * Trigger event when variant image changes
       *
       * @param  {object} variant - Currently selected variant
       * @return {event}  variantImageChange
       */
      _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};
  
        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantImageChange',
          variant: variant
        });
      },
  
      /**
       * Trigger event when variant price changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantPriceChange
       */
      _updatePrice: function(variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantPriceChange',
          variant: variant
        });
      },
  
      /**
       * Update history state for product deeplinking
       *
       * @param  {variant} variant - Currently selected variant
       * @return {k}         [description]
       */
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }
  
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      },
  
      /**
       * Update hidden master select of variant change
       *
       * @param  {variant} variant - Currently selected variant
       */
      _updateMasterSelect: function(variant) {
        $(this.originalSelectorId, this.$container)[0].value = variant.id;
      }
    });
  
    return Variants;
  })();
  

  /*================ Polaroid Utils ================*/
  polaroid.state = (function() {
    var currentScreenSize = 'xs';
    var windowHeight = 0;
    var iosBottomNavBarHeight = 69;
    var screenLocked = false;
    var isIos = false;
    var cleanUi = false;
  
    /**
     * These values are used for the media queries inside CSS. As some browsers include and other
     * exclude the scrollbar in calculation, we use Modernizr.mq to set the current "size" of the view,
     * the actual pixel width might be slightly different but it follows the rules inside CSS in the
     * current browser.
     */
    var SCREEN_SIZES = {
      sm : 768,
      md : 940,
      lg : 1200,
      xl : 1440
    };
  
    function init() {
      // Adds ios class to <html>
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        document.documentElement.className = document.documentElement.className + ' ios';
        isIos = true;
      }
  
      // Hides part of the UI when coming from the App
      if ( typeof URLSearchParams !== 'undefined') {
        var urlParams = new URLSearchParams(window.location.search);
        cleanUi = urlParams.has('in_app');
      } else {
        cleanUi = window.location.search.indexOf('in_app') > -1;
      }
  
      if ( cleanUi ) {
        $('#TopBanner').remove();
      }
  
      setWindowVariables();
      $(window).on('resize', function() {
        setWindowVariables(true);
      });
    }
  
    function getState() {
      return {
        isIos: isIos,
        screenLocked: screenLocked,
        cleanUi: cleanUi,
        currentScreenSize: currentScreenSize,
        windowHeight: windowHeight
      };
    }
  
    function currentScreenSizeMatches(query) {
      if ( typeof query === 'string' ) {
        return currentScreenSize === query;
      } else {
        return _.contains(query, currentScreenSize);
      }
    }
  
    function lockScreen() {
      $('body', 'html').css('overflow', 'hidden');
      screenLocked = true;
    }
  
    function unlockScreen() {
      $('body', 'html').css('overflow', 'auto');
      screenLocked = false;
    }
  
    function toggleLockScreen() {
      if ( screenLocked ) {
        unlockScreen();
      } else {
        lockScreen();
      }
    }
  
    function setWindowVariables(trackEvent) {
      var lastScreenSize = currentScreenSize;
      windowHeight = $(window).height();
  
      if (Modernizr.mq('(max-width: ' + (SCREEN_SIZES.sm - 1) + 'px)')) {
        currentScreenSize = 'xs';
  
      } else if (Modernizr.mq('(min-width: ' + SCREEN_SIZES.sm + 'px) and (max-width: ' +  (SCREEN_SIZES.md - 1) + 'px)')) {
        currentScreenSize = 'sm';
  
      } else if (Modernizr.mq('(min-width: ' + SCREEN_SIZES.md + 'px) and (max-width: ' +  (SCREEN_SIZES.lg - 1) + 'px)')) {
        currentScreenSize = 'md';
  
      } else if (Modernizr.mq('(min-width: ' + SCREEN_SIZES.lg + 'px) and (max-width: ' +  (SCREEN_SIZES.xl - 1) + 'px)')) {
        currentScreenSize = 'lg';
      } else  {
        currentScreenSize = 'xl';
      }
  
      if ( lastScreenSize !== currentScreenSize ) {
        $(window).trigger('polaroid.breakpointUpdated');
  
        if ( trackEvent ) {
          polaroid.tracking.general('UI', 'Update Breakpoint', currentScreenSize);
        }
      }
    }
  
  
    return {
      init: init,
      lockScreen: lockScreen,
      unlockScreen: unlockScreen,
      toggleLockScreen: toggleLockScreen,
      currentScreenSizeMatches: currentScreenSizeMatches,
      getState: getState
    };
  })();
  
  // Tracking module, all tracking events should be here
  
  polaroid.tracking = (function() {
  
    $('[data-track-watch-video]').on('click', function(e) {
      var videoName = $(this).attr('data-track-watch-video');
  
      watchVideo( videoName );
    });
  
    // General tracking event
  
    $(document).on('click', '[data-po-track-event]', function(e) {
      var $this = $(this);
      var trackingData = $this.attr('data-po-track-event').split(':');
      var eventCategory = trackingData[0];
      var eventAction = trackingData[1];
      var eventLabel = trackingData[2];
  
      generalTracking( eventCategory, eventAction, eventLabel );
    });
  
  
    // View product
  
    $('.product-grid [data-po-track-view-product]').on('click', function(e) {
      var eventLabel = getProductEventLabel(this);
  
      generalTracking('Product Grid', 'View Product', eventLabel);
    });
  
    if ( window.polaroid.page.template === 'search' ) {
      $(document).on('click', '[data-po-track-view-product-alt]', function(e) {
        var eventLabel = getProductEventLabel(this);
  
        generalTracking('Product Grid', 'View Product', eventLabel);
      });
    }
  
    $('#UpsellCarouselsContainer').on('click', '[data-po-track-view-product]', function(e) {
      var eventLabel = getProductEventLabel(this);
  
      generalTracking('Upsell', 'View Product', eventLabel);
    });
  
  
    // Cart related event listeners
  
    $('.cart__inner').on('click', '[data-cart-increase-quantity]', function(e) {
      var eventLabel = getProductEventLabel(this);
  
      generalTracking('Cart', 'Increase Quantity', eventLabel);
    });
  
    $('.cart__inner').on('click', '[data-cart-decrease-quantity]', function(e) {
      var eventLabel = getProductEventLabel(this);
  
      generalTracking('Cart', 'Decrease Quantity', eventLabel);
    });
  
    $('.cart__inner').on('click', '[data-cart-remove-item]', function(e) {
      var eventLabel = getProductEventLabel(this);
  
      generalTracking('Cart', 'Remove Item', eventLabel);
    });
  
  
    // Navigation related event listeners
    $('[data-po-tracking-navigation]').on('click', function(e) {
      var trackingData = $(this).attr('data-po-tracking-navigation').split('|');
      var eventAction = trackingData[0];
      var eventLabel = trackingData[1];
  
      generalTracking('Navigation', eventAction, eventLabel);
    });
  
  
    function addToCart(item, data, quantity) {
      if ( data ) {
        generalTracking(data.category, 'Add to Cart', data.label, quantity);
      }
  
      if ( typeof pintrk === 'function' ) {
        var currency = Shopify.currency.active;
  
        pintrk('track', 'addtocart', {
          value: item.price / 100,
          order_quantity: quantity,
          currency: currency
        });
      }
    }
  
    function addBundleToCart( data ) {
      if ( data ) {
        generalTracking(data.category, 'Add Bundle to Cart', data.label);
      }
    }
  
    function watchVideo( videoName ) {
      generalTracking('Video', 'play', videoName );
  
      if ( typeof pintrk === 'function' ) {
        pintrk('track', 'watchvideo', {
          video_title: videoName
        });
      }
    }
  
    function generalTracking( eventCategory, eventAction, eventLabel, eventValue ) {
      if (!eventCategory || !eventAction) return false;
  
      try {
        ga('send', 'event', eventCategory, eventAction, eventLabel, eventValue);
      } catch(e) {
        console.log('Error tracking to google analytics');
      }
    }
  
    function getProductEventLabel( elem ) {
      var $this = $(elem);
      var productHandle = $this.attr('data-po-product-handle');
      var variantTitle = $this.attr('data-po-variant-title');
      var eventLabel = variantTitle
        ? productHandle.concat('|' + variantTitle)
        : productHandle;
  
      return eventLabel;
    }
  
    return {
      addToCart: addToCart,
      addBundleToCart: addBundleToCart,
      watchVideo: watchVideo,
      general: generalTracking,
      getProductEventLabel: getProductEventLabel
    };
  })();
  
  polaroid.images = polaroid.images || {};
  
  polaroid.images.init = function() {
    // Lazy <img> loading
    polaroid.images.imgSources.init();
  
    // Lazy + progressive loading backgrounds
    polaroid.images.bgLazyLoading.init();
  };
  
  polaroid.images.bgLazyLoading = (function() {
    var loadedClass = 'po-lazy-background__image--loaded';
    var elementAttr = 'data-po-lazy-loading-bg';
    var imgSrcAttr = 'data-po-image-src';
    var cropAttr = 'data-po-lazy-loading-crop';
    var elements;
  
    function init() {
      setImages();
      loadImages();
      $(window).on('scroll', loadImages);
      $(window).on('polaroid.breakpointUpdated', function() {
        setImages();
        $(window).on('scroll', loadImages);
      });
    }
  
    function setImages() {
      var $backgrounds = $('[' + elementAttr + ']');
      elements = $backgrounds.filter(function(index) {
        var breakpoints = $($backgrounds[index]).attr(elementAttr);
  
        return breakpoints.indexOf(polaroid.state.getState().currentScreenSize) > -1;
      });
    }
  
    function loadImages() {
      var loadedImages = false;
  
      elements.each( function( index ) {
        var $elem = $(this);
  
        if ( $(window).scrollTop() + $(window).height() >= $elem.offset().top ) {
          var elemWidth = $elem.width();
          var elemHeight = $elem.height();
  
          if ( elemWidth > 0 && elemHeight > 0 ) {
            var imgSrc = setImageSize($elem.attr(imgSrcAttr), elemWidth, elemHeight, $elem.attr(cropAttr));
            var img = new Image();
  
            img.onload = function() {
              $elem
                .css('background-image', 'url(' + imgSrc + ')')
                .addClass(loadedClass);
            };
  
            img.src = imgSrc;
          }
  
          $elem.removeAttr(elementAttr);
  
          loadedImages = true;
        }
      });
  
      if ( loadedImages ) removeLoadedImagesFromList();
    }
  
    function removeLoadedImagesFromList() {
      elements = $(_.filter(elements, function(element) {
        return element.hasAttribute(elementAttr);
      }));
  
      if ( !elements.length ) disable();
    }
  
    function disable() {
      $(window).off('scroll', loadImages);
    }
  
    function setImageSize(imageUrl, elemWidth, elemHeight, crop) {
      var isPng = imageUrl.indexOf('.png') > -1;
      var pixelRatio = window.devicePixelRatio ? Math.floor(window.devicePixelRatio) : 1;
      var width = pixelRatio > 1 ? elemWidth : elemWidth * 1.2;
      var height = pixelRatio > 1 ? elemHeight : elemHeight * 1.2;
      var size = Math.floor(width) + 'x' + Math.floor(height) + '_crop_';
      var formattedUrl = imageUrl.split('?')[0];
      var timestamp = imageUrl.split('?')[1];
  
      if ( crop ) {
        size += crop;
      } else {
        size += 'center';
      }
  
      if ( pixelRatio > 1 && !isPng ) {
        size += '@' + pixelRatio + 'x';
      }
  
      return slate.Image.getSizedImageUrl(formattedUrl, size) + '?' + timestamp;
    }
  
    return {
      init: init,
      setImages: setImages,
      loadImages: loadImages
    };
  })();
  
  polaroid.images.imgSources = (function() {
    var loadedClass = 'img-loaded';
    var imageAttr = 'data-po-lazy-loading-img';
    var imageSrcAttr = 'data-po-img-src';
    var images;
  
    function init() {
      setImages();
      loadImages();
      $(window).on('scroll', loadImages);
      $(window).on('polaroid.breakpointUpdated', function() {
        setImages();
        $(window).on('scroll', loadImages);
      });
    }
  
    function setImages() {
      images = $('[' + imageAttr + ']:visible');
    }
  
    function loadImages() {
      var loadedImages = false;
  
      images.each(function(index) {
        var $image = $(this);
  
        if ( $image.offset().top > $(window).scrollTop() + ( polaroid.state.getState().windowHeight * 1.2) ) return;
  
        var imgSrc = $image.attr(imageSrcAttr);
        var img = new Image();
  
        img.onload = function() {
          $image.attr('src', imgSrc);
  
          // Delays adding class to give time for image to
          // occupy space so it transitions
          setTimeout(function() {
            $image.addClass(loadedClass);
  
            setTimeout(function() {
              $image.removeAttr(imageSrcAttr);
            }, 310);
          }, 10);
        };
  
        $image.removeAttr(imageAttr);
        img.src = imgSrc;
  
        loadedImages = true;
      });
  
      if ( loadedImages ) removeLoadedImagesFromList();
    }
  
    function removeLoadedImagesFromList() {
      images = $(_.filter(images, function(image) {
        return image.hasAttribute(imageAttr);
      }));
  
      if ( !images.length ) disable();
    }
  
    function disable() {
      $(window).off('scroll', loadImages);
    }
  
    return {
      init: init,
      setImages: setImages,
      loadImages: loadImages
    };
  })();
  
  polaroid.images.replaceImage = function (imgElem, imgSrc) {
    var img = new Image();
    imgElem.src = window.polaroid.loading_spinner_url;
  
    img.onload = function() {
      imgElem.src = imgSrc;
    };
  
    img.src = imgSrc;
  };
  
  polaroid.videos = (function() {
    var loadedVideoClass = 'video-loaded';
    var videoClass = '.load-video';
    var videos;
  
    function init() {
      setVideos();
      $(window).on('scroll load', loadVideos);
      $(window).on('polaroid.breakpointUpdated', function() {
        setVideos();
        $(window).on('scroll', loadVideos);
      });
    }
  
    function setVideos() {
      if ( polaroid.state.currentScreenSizeMatches('xs') ) {
        videos = $( videoClass + '.video-mobile');
      } else {
        videos = $( videoClass + '.video-desktop');
      }
    }
  
    function loadVideos() {
      var loadedVideos = false;
  
      videos.each(function(index) {
        var $video = $(this);
  
        if ( $video.offset().top > $(window).scrollTop() + ( polaroid.state.getState().windowHeight * 1.2) ) return false;
  
        $video.attr('poster', $(this).data('poster'));
        $video.find('source').each(function(i, el) {
          el.src = $(el).data('src');
        });
  
        this.load();
        $video.addClass(loadedVideoClass);
  
        loadedVideos = true;
      });
  
      if ( loadedVideos ) removeLoadedVideosFromList();
    }
  
    function removeLoadedVideosFromList() {
      videos = $(_.filter(videos, function(video) {
        return !$(video).hasClass(loadedVideoClass);
      }));
  
      if ( !videos.length ) disable();
    }
  
    function disable() {
      $(window).off('scroll', loadVideos);
    }
  
    return {
      init: init,
      setVideos: setVideos,
      loadVideos: loadVideos
    };
  })();
  
  polaroid.cartMethods = (function () {
    return {
      addToCart: addToCart,
      addBundleToCart: addBundleToCart,
      checkVariantAvailability: checkVariantAvailability,
      checkBundleAvailability: checkBundleAvailability
    };
  
    /**
     * Adds variant to the cart
     *
     * @param {number} variantId Variant ID of the product that will be added to the cart
     * @param {number} amount Quantity
     * @param {Object} properties Custom properties for the item
     * @param {Object} options
     *
     */
    function addToCart(variantId, amount, properties, options) {
      return new Promise(function(resolve, reject) {
        CartJS.addItem(
          variantId,
          amount,
          properties,
          {
            "success": function(data, textStatus, jqXHR) {
              polaroid.tracking.addToCart(data, options.tracking, amount);
              resolve(data);
            },
            "error": function(jqXHR, textStatus, errorThrown) {
              // console.log('Error: ' + errorThrown + '!');
              reject(textStatus);
            }
          });
      });
    }
  
    /**
     * Adds bundle to the cart
     *
     * @param {Object} bundle Bundle object with name, handle, and variants
     * @param {number} amount Quantity
     * @param {Object} discounts Discount and incentive discounts
     * @param {boolean} goToCheckout Goes to checkout after adding all items of bundle to cart
     * @param {Object} callback Function to execute after adding all items to the cart
     *
     */
    function addBundleToCart( bundle, amount, discounts, goToCheckout ) {
      return new Promise(function(resolve,reject) {
        var itemsAdded = 0;
        var properties = {
          Bundle: bundle.name
        };
  
        if ( discounts && discounts.incentive_discount ) {
          properties._bundle_incentive_discount = discounts.incentive_discount;
        }
  
        if ( discounts && discounts.sale_discount > 0 ) {
          properties._bundle_sale_discount = discounts.sale_discount;
        }
  
        polaroid.goingToCheckout = goToCheckout;
  
        for ( var i = 0; i < bundle.variants.length; i++ ) {
          var variant = bundle.variants[i];
          var variantId = variant.id;
          var quantity = variant.quantity * amount;
          var data = {
            item_qty: variant.quantity,
            bundle_handle: bundle.handle
          };
  
          properties._bundle_data = JSON.stringify(data);
  
          CartJS.addItem(
            variantId,
            quantity,
            properties,
            {
              "success": function(data, textStatus, jqXHR) {
                polaroid.tracking.addToCart(data);
  
                itemsAdded++;
  
                if ( itemsAdded === bundle.variants.length ) {
                  polaroid.tracking.addBundleToCart({
                    category: 'Bundle',
                    label: bundle.name
                  });
  
                  resolve(bundle);
  
                  if ( goToCheckout ) {
                    window.location = '/checkout';
                  } else {
                    $(document).trigger('polaroid.bundleAdded', {
                      handle: bundle.handle
                    });
                  }
                }
              },
              "error": function(jqXHR, textStatus, errorThrown) {
                reject(textStatus);
              }
            });
        }
      });
    }
  
    /**
     * Adds variant to the cart
     *
     * @param {string} handle Product handle
     * @param {number} variantId Variant ID
     *
     */
    function checkVariantAvailability( handle, variantId ) {
      return new Promise( function( resolve, reject ) {
        $.getJSON('/products/' + handle + '.js',
          function onSuccess(product) {
            var variant = _.findWhere(product.variants, { id: variantId });
  
            if ( !variant.available ) {
              resolve('unavailable');
            } else {
              resolve('available');
            }
        });
      });
    }
  
    /**
     * Adds variant to the cart
     *
     * @param {array} variants List of variants with their handle and ids
     */
    function checkBundleAvailability( variants ) {
      return new Promise(function (resolve, reject) {
        var counter = 1;
        var quantity = variants.length;
        var available = true;
  
        for ( var i = 0; i < quantity; i++ ) {
          checkVariantAvailability( variants[i].handle, variants[i].id )
            .then( function( status ) {
              if ( status === 'unavailable' ) {
                resolve('unavailable');
              } else if ( counter === quantity ) {
                resolve('available');
              } else {
                counter++;
              }
            });
        }
      });
    }
  
    function getBundleFromHandle( bundleHandle ) {
  
    }
  })();
  
  polaroid.helpers = polaroid.helpers || {};
  
  polaroid.helpers.init = function() {
    polaroid.helpers.updatePoLinks();
  
    var $frameButtonsContainer = $('.index-links');
  
    // TODO: Rewrite function
    $(window).on('scroll', function() {
      if (!Modernizr.touchevents) return;
      var scrollTop = $(window).scrollTop();
  
      $('.in-view-hover, .frame-btn').each(function() {
        if (!Modernizr.touchevents) return;
        var $this = $(this);
  
        var top = $this.offset().top;
        var height = $this.outerHeight();
        var buffer = 100;
  
        if ($this.data('buffer') !== undefined) {
          buffer = $this.data('buffer');
        }
  
        if (scrollTop + polaroid.state.getState().windowHeight > top + height - buffer && scrollTop < top + buffer) {
          $this.addClass('is-hover-active');
  
          if ( $frameButtonsContainer.length && $this.attr('data-module-bg-color') ) {
            $frameButtonsContainer.css({'background-color': $this.attr('data-module-bg-color')});
          }
        } else {
          $this.removeClass('is-hover-active');
        }
      });
    });
  
    // TODO: Rewrite function
    if ( polaroid.state.currentScreenSizeMatches(['md','lg','xl']) ) {
      $('.in-view-hover, .frame-btn').each(function() {
        var $this = $(this);
  
        if ( $frameButtonsContainer.length && $this.attr('data-module-bg-color') ) {
          $this.on('mouseenter', function() {
            $frameButtonsContainer.css({'background-color': $this.attr('data-module-bg-color')});
          });
  
          $this.on('mouseleave', function() {
            $frameButtonsContainer.css({'background-color': '#f7f7f7'});
          });
        }
      });
    }
  
    $('.site-footer__location-select').on('change', function() {
      window.location = $(this).val();
    });
  };
  
  polaroid.helpers.updatePoLinks = function() {
    $('a').each(function() {
      var href = $(this).attr('href');
  
      if (href === undefined) return;
  
      if (href.indexOf(polaroid.magazine_url) >= 0 || href.indexOf(polaroid.support_url) >= 0) {
        if ($(this).data('original-href') !== undefined) {
          href = $(this).data('original-href');
        }
        else {
          $(this).data('original-href', href);
        }
  
        $(this).attr('href', polaroid.helpers.addShopParams(href));
      }
    });
  };
  
  /**
   * Returns a given string with attached params for current shop status (instance and item_count). If a "?"
   * is present inside the string first connector will be an "&". If given string is empty (or no string) it
   * returns only the params. The connector can be omitted with the second argument.
   *
   * @param href
   * @param omitConnector
   * @returns {string}
   */
  polaroid.helpers.addShopParams = function(href, omitConnector) {
    var $href          = (!_.isUndefined(href) && _.isString(href)) ? href : '',
        $omitConnector = (_.isBoolean(omitConnector)) ? (!!omitConnector) : false,
        $connector     = '',
        $params        = '',
        $cart_count    = CartJS.cart.item_count;
  
    if (!$omitConnector) {
      $connector = ($href.indexOf('?') == -1) ? '?' : '&';
    }
    $params = $connector + 'shop_url=' + encodeURIComponent(polaroid.shop_url) + '&cart_count=' + $cart_count;
  
    return $href + $params;
  };
  
  polaroid.helpers.createCookie = function (name, value, days) {
    var cDate        = new Date(),
        expiresIn    = 0,
        expiresTime  = 0,
        expiresStr   = '';
  
    if (!_.isUndefined(days) && !_.isNaN(days)) {
      expiresIn = days * 1;
      // can be a date in the past (= deleting cookie), today or in the future
      expiresTime = cDate.getTime() + (expiresIn * 24 * 60 * 60 * 1000);
      cDate.setTime(expiresTime);
      expiresStr = ' expires=' + cDate.toGMTString() + ';';
    }
    // Cookiebot
    document.cookie = name + " = " + value + ";" + expiresStr + " path=/";
  };
  
  /**
   * Gives back an URL to redirect to another shop instance while keeping the
   * current product in view.
   *
   * @param string new_host (pattern "//eu.impossible-project.com")
   *
   * @returns string The URL to reload the window to.
   */
  polaroid.helpers.getRedirectPath = function(new_host) {
    var protocol  = window.location.protocol,
        pathname  = window.location.pathname,
        params    = window.location.search,
        hash      = window.location.hash;
  
    return protocol + new_host + pathname + params + hash;
  };
  
  polaroid.helpers.readCookie = function (name) {
    var nameEQ = name + "=",
        ca = document.cookie.split(';');
  
    for(var i= 0, n = ca.length; i < n; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) == 0) {
        return c.substring(nameEQ.length,c.length);
      }
    }
    return null;
  };
  
  polaroid.helpers.eraseCookie = function (name) {
    polaroid.helpers.createCookie(name, '', -1);
  };
  
  
  /**
   * Every element gets an on click event that redirects to a given web address.
   * The address is given via a data-href attribute on the element or (if unset) the first
   * <a> tag inside the element.
   * With data-target (or <a> attribute) ‘_blank’ the link is opened inside a new window.
   *
   * @param {jQuery selection} Elements that shall be clickable
   */
  polaroid.helpers.setupClickAreas = function (elements) {
    _.each(elements, function(element, index, list) {
      var el     = $(element),
          target = el.data('target') || null,
          href   = el.data('href') || null;
  
      if (href === null) {
        href = $('a', el).first().attr('href');
        // target is always taken from the defining href element!
        target = $('a', el).first().attr('target') || null;
      }
  
      if (href !== null) {
        el.click(function(event) {
          event.preventDefault();
          switch (target) {
            case '_blank':
              window.open(href);
              break;
            default:
              window.location = href;
          }
        });
        el.addClass('click_enabled');
      }
    });
  };
  
  /**
   * Sets up collapse elements. The given selector defines the elements that are used
   * as clickable elements. Each of these elements need to define a target (that is
   * un-/collapsing) via ID which is passed by a data attribute collapse_target (e.g.
   * data-collapse_target="moreInformation"). Click on one element:
   * - toggles the CSS class "triggerCollapsed" on the clicked element (class defines collapsed state)
   * - toggles the CSS class "collapsed" on the target element (class defines collapsed state)
   * - trigger window resize event
   *
   * An additional data attribute "collapse_group" can define a group (e.g. data-collapse_group="happyFamily").
   * All trigger elements with that attribute get grouped, and if one element of this group gets opened, all others get
   * closed. Be aware that the group name is added as CSS class to the target elements (in this example "happyFamily").
   *
   * An options object can be given as second argument, an optional function "preFunction" will be called
   * before and an optional function "postFunction" will be called after the click event handling. Parameters
   * are the event and the options object. Handling the result see there ...
   *
   * @param {string} selector This string is used with jQuery as selector.
   * @param {object} options Object to extend functionality.
   */
  polaroid.helpers.setupCollapseElements = function(selector, options) {
    if (_.isUndefined(selector) || !_.isString(selector) || '' === selector) {
      return;
    }
    options = options || {};
    var triggers = $(selector),
        closeGroup = function(groupClass) {
          var targetGroupEl   = $('.' + groupClass),
              triggerGroupEl  = $('*[data-collapse_group="' + groupClass + '"]');
  
          targetGroupEl.addClass('collapsed');
          triggerGroupEl.addClass('triggerCollapsed');
        };
  
    _.each(triggers, function(el, index, list) {
      var targetId       = $(el).data('collapse_target'),
          targetGroupSel = $(el).data('collapse_group'),
          groupHandling  = false,
          target         = $('#' + targetId);
  
      if (!_.isUndefined(targetGroupSel) && _.isString(targetGroupSel)) {
        groupHandling = true;
        target.addClass(targetGroupSel);
      }
  
      $(el).click(function (event) {
        if (!_.isUndefined(options.preFunction) && _.isFunction(options.preFunction)) {
          var returnPre = options.preFunction(event, options);
          if (!_.isUndefined(returnPre)) {
            // here you can define handling of the results of the called function
            switch (returnPre) {
              case 'stopEvent':
                return;
            }
          }
        }
        if (groupHandling) {
          if($(el).hasClass('triggerCollapsed')) {
            // if an element gets opened close all others of the group, don't change
            // state if element gets closed.
            closeGroup(targetGroupSel);
          }
        }
        $(el).toggleClass('triggerCollapsed');
        target.toggleClass('collapsed');
        if (!_.isUndefined(options.postFunction) && _.isFunction(options.postFunction)) {
          var returnPost = options.postFunction(event, options);
          //if (!_.isUndefined(returnPre)) {
          //    // here you can define handling of the results of the called function
          //    switch (returnPost) {
          //        case 'stopEvent':
          //            return;
          //            break;
          //    }
          //}
        }
        // in case of some sleepy browsers...
        $(window).trigger('resize');
      });
    });
  };
  
  polaroid.helpers.getPreOrderPropertyDates = function(variantId) {
    var $variants = window.polaroid.pre_order_variants;
  
    if ($variants[variantId] != undefined) {
      if (!$variants[variantId].date_expired) {
        return {
          'timestamp': $variants[variantId].in_date,
          'formatted': $variants[variantId].date_formatted
        };
      }
    }
    return null;
  };
  
  /**
   * Trims string to the last word before reaching character limit
   *
   * @param {string} text that will be trimmed
   * @param {number} maxChars max amount of characters
   *
   * @returns {string} The trimmed text with ellipsis
   */
  
  polaroid.helpers.trimText = function(text, maxChars) {
    var trimmedText = '';
    var ellipsis = '...';
    var trimPosition = 0;
  
    if ( text >= maxChars ) {
      trimmedText = text;
    } else {
      trimmedText = text.slice(0, maxChars);
      trimPosition = trimmedText.lastIndexOf(' ');
      trimmedText = text.slice(0, trimPosition);
      trimmedText += ellipsis;
    }
  
    return trimmedText;
  };
  
  polaroid.helpers.getFormData = function(form) {
    var $form = $(form),
        obj   = {},
        str, pairs, pair,
        pIndex, pValue,
        subIndex, subIndexGroup;
  
    if (!$form.is('form')) {
      return null;
    }
    // getCleanData as a string
    str = decodeURI($form.serialize());
    pairs = str.split('&');
  
    for (var i=0, n=pairs.length; i < n; i++) {
      pair = pairs[i].split('=');
      subIndexGroup = null;
      subIndex = null;
      pIndex = decodeURIComponent(pair[0]).replace(/\+/g, ' ');
      pValue = decodeURIComponent(pair[1]).replace(/\+/g, ' ');
  
      if (pIndex.indexOf('[') > -1 && pIndex.indexOf(']') > -1 && pIndex.indexOf(']') == (pIndex.length -1)) {
        subIndexGroup = pIndex.substring(0, (pIndex.indexOf('[')));
        subIndex = pIndex.substring((pIndex.indexOf('[') + 1), (pIndex.length -1));
      }
  
      if (subIndexGroup !== null) {
        if (obj[subIndexGroup] === undefined) {
          obj[subIndexGroup] = {};
          obj[subIndexGroup][subIndex] = pValue;
        }
  
        else if (_.isObject(obj[subIndexGroup])) {
          obj[subIndexGroup][subIndex] = pValue;
        }
  
      } else if (obj[pIndex] === undefined) {
        obj[pIndex] = pValue;
  
      } else {
        if (typeof obj[pIndex] == "string") {
          obj[pIndex] = [obj[pIndex]];
        }
        obj[pIndex].push(pValue);
      }
    }
  
    return obj;
  };
  
  polaroid.helpers.getUrlParamValue = function(queryParams, paramName) {
    try {
      var urlParams = new URLSearchParams(queryParams);
      return urlParams.get(paramName);
    } catch (e) {
      return false;
    }
  };
  
  jQuery.fn.reverse = [].reverse;
  
  polaroid.stacks = polaroid.stacks || {};
  
  polaroid.stacks.init = function() {
    var format_title_map = {
          'stacks_itype':   'i-Type',
          'stacks_600':     '600',
          'stacks_sx70':    'SX-70',
          'stacks_spectra': 'Spectra',
          'stacks_8x10':    '8x10',
          'stacks_st':      'i-Type'
        },
        film_title_map = {
          'stacks_bw':           'B&W',
          'stacks_color':        'Color',
          'stacks_blackpink':    'Black & Pink',
          'stacks_blackblue':    'Black & Blue',
          'stacks_silverframe':  'Silverframe',
          'stacks_goldframe':    'Goldframe',
          'stacks_deepsea':      'Deep Sea',
          'stacks_icecream':     'Ice Cream',
          'stacks_tropics':      'Tropics',
          'stacks_rosegold':     'Rose Gold',
          'stacks_gradient':     'Gradient',
          'stacks_mf':           'Mickey 600 Film',
          'stacks_st':           'Stranger Things Edition',
          'stacks_sh':           'Summer Haze',
          'stacks_sb':           'Summer Blues',
          'stacks_fr':           'Summer Fruits',
          'stacks_festivered':   'Festive Red',
          'stacks_golddust':     'Gold Dust',
          'stacks_popdeco':      'Pop Deco',
          'stacks_fragment':     'Fragment'
        },
        special_title_map = {
          'stacks_special':       'Special',
          'stacks_dc':            'Duochrome',
          'stacks_goldandsilver': 'Color', //'Gold- & Silverframe'
          'stacks_sf':            'Summer Frames',
          'stacks_rg':            'Rose Gold & Gradient',
          'stacks_mf':            'Mickey 600 Film'
        },
        special_default_format_map = {
          'stacks_special':       'stacks_600',
          'stacks_dc':            'stacks_600',
          'stacks_goldandsilver': 'stacks_600',
          'stacks_sf':            'stacks_600',
          'stacks_rg':            'stacks_itype',
          'stacks_mf':            'stacks_600'
        };
  
    $('.polaroid-stacks').each(function(index, el) {
      var $stack = $(this);
      var tags = $stack.data('tags');
      var operator = $stack.data('operator');
      var $images = $('.polaroid-stack__image', $stack);
  
      if ( $stack.data('stacks-static') ) {
        _loadImages( _.sample(polaroid.samples[$stack.data('stacks-static')], 12), $images, el);
        polaroid.images.imgSources.setImages();
      } else {
        $.ajax({
          type: 'GET',
          url: polaroid.magazine_url,
          data: {
            'stacks-json-v3': 1,
            'tags': tags,
            'operator': operator
          },
          dataType: 'jsonp',
  
          success: function(data) {
            _loadImages(data, $images, el);
            polaroid.images.imgSources.setImages();
          },
  
          error: function (e) {
            $(el).addClass('hidden');
          }
        });
      }
    });
  
    $('.polaroid-stack-static').each(function(index, el) {
  
      var $stack = $(el),
          $format = $stack.data('format'),
          $info = $('.info', $stack);
  
      $('.polaroid-stack__image', $stack).each(function(index, imgEl) {
  
        var bgColor = 'bg-cool-grey';
        imgEl = $(imgEl);
  
        imgEl.data('format', $format);
  
        switch($format) {
          case 'stacks_itype':
            bgColor = 'bg-marigold';
            break;
          case 'stacks_600':
            bgColor = 'bg-cerulean';
            break;
          case 'stacks_sx70':
            bgColor = 'bg-tomato';
            break;
          case 'stacks_spectra':
            bgColor = 'bg-emerald';
            break;
          case 'stacks_8x10':
            bgColor = 'bg-ecstasy';
        }
  
        $('.polaroid-stack__selector i', $stack)
            .eq($(this).index())
            .addClass(bgColor);
  
        $stack.addClass('is-active');
      });
      $info.on('click', function(ev) {
        if ($(ev.target).hasClass('btn')) {
          return;
        }
        _showStackImage($stack, 0);
      });
      _showStackImage($stack, 0);
    });
  
    $('.polaroid-stack__selector, .polaroid-stack__images').on('click', function(e) {
      e.preventDefault();
  
      var $stack = $(this).closest('.polaroid-stack, .polaroid-stack-static');
      var $images = $('.polaroid-stack__image', $stack);
      var $activeImage = $images.filter('.is-active');
      var $nextImage = $activeImage.next().length ? $activeImage.next() : $images.first();
  
      _showStackImage($stack, $nextImage.index());
    });
  
    function _loadImages(data, $images, el) {
      if (data.length === 0) {
        $stack.remove();
        return;
      }
  
      if (data.length < 12) {
        for (var i = 11 - data.length; i >= 0; i--) {
          data.push(data[Math.floor(Math.random() * data.length)]);
        }
      }
  
      $.each(data, function(index) {
        var $url         = this.url,
            $attribution = this.attribution,
            $film        = this.film.replace(/&amp;/g, '&'),
            $format      = this.format,
            $special     = this.special;
  
        // As we need to hide some special editions from places like the homepage,
        // some images are only tagged with a special edition tag and not with the format.
        // So here it gets a default value.
        // TODO: introduce a "hide" tag on WP, that is ignored with a special debug param
        if ($format == '' && $special.length > 0) {
          $.each($special, function(index, item) {
            // last special item will set it!
            if (special_default_format_map[item]) {
              $format = special_default_format_map[item];
            }
          });
        }
  
        $images.eq(index)
          .attr('data-po-img-src', $url)
          .data('attribution', $attribution)
          .data('film', $film)
          .data('format', $format);
      });
  
      _initStacks();
      $(el).removeClass('hidden');
    }
  
    function _initStacks() {
      $('.polaroid-stack').each(function() {
        var $stack = $(this);
        $('.polaroid-stack__image', $stack).each(function() {
          var bgColor = 'bg-cool-grey';
  
          switch($(this).data('format')) {
            case 'stacks_itype':
            case 'stacks_st':
              bgColor = 'bg-marigold';
              break;
            case 'stacks_600':
              bgColor = 'bg-cerulean';
              break;
            case 'stacks_sx70':
              bgColor = 'bg-tomato';
              break;
            case 'stacks_spectra':
              bgColor = 'bg-emerald';
              break;
            case 'stacks_8x10':
              bgColor = 'bg-ecstasy';
          }
  
          $('.polaroid-stack__selector i', $stack)
            .eq($(this).index())
            .addClass(bgColor);
        });
  
        $stack.addClass('is-active');
        _showStackImage($(this), 0);
      });
    }
  
    function _showStackImage($stack, index) {
  
      var $images              = $('.polaroid-stack__image', $stack),
          $image               = $images.eq(index),
          $selector            = $('.polaroid-stack__selector', $stack),
          $format              = $image.data('format'),
          $film                = $image.data('film'),
          $attribution         = ($image.data('attribution') !== undefined) ? $image.data('attribution') : '',
          $info_product        = $('.polaroid-stack__film', $stack),
          $info_attribution    = $('.polaroid-stack__handle', $stack),
          $product_text        = _getProductText($format, $film),
          $attribution_text    = ($product_text == '') ? polaroid.strings.shot_by : polaroid.strings.by;
  
      $images.removeClass('is-active');
      $image.addClass('is-active');
      if (index == ($images.length - 1)) {
        $('.info', $stack).addClass('is_activated');
      } else {
        $('.info', $stack).removeClass('is_activated');
      }
  
      $('i', $selector)
          .removeClass('is-active')
          .eq($image.index())
          .addClass('is-active');
  
      $info_product.html($product_text);
      $('a', $info_product).attr('data-format', format_title_map[$format]);
      $('a', $('.polaroid-stack-static__film')).attr('data-format', format_title_map[$format]);
  
      $attribution_text = ($attribution == '') ? '' : $attribution_text + ' <span href="#" class="black polaroid-stack__attribution-data">' + $attribution + '</span>';
      $info_attribution.html($attribution_text);
    }
  
    function _getProductText($format, $film) {
      var $so   = polaroid.strings.shot_on,
          $copy = '',
          $url = '/';
  
      switch ($format) {
  
        case 'stacks_st':
          $so += ' i-Type: ';
          $copy = 'Stranger Things Edition';
          $url = '/products/color-instant-film-for-itype-stranger-things';
          break;
  
        case 'stacks_itype':
  
          switch ($film) {
            case 'stacks_bw':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/bw-instant-film-for-itype';
              break;
  
            case 'stacks_color':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-itype';
              break;
  
            case 'stacks_rosegold':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-itype-rose-gold';
              break;
  
            case 'stacks_gradient':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-itype-gradient';
              break;
  
            case 'stacks_sb':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-itype-summer-blues';
              break;
  
            default:
              return '';
          }
          break;
  
  
        case 'stacks_600':
  
          switch ($film) {
            case 'stacks_bw':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/bw-instant-film-for-600';
              break;
  
            case 'stacks_color':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-600';
              break;
  
            case 'stacks_blackpink':
              $copy = special_title_map.stacks_dc + ' ' + format_title_map[$format];
              $url = '/products/pink-instant-film-for-600-duochrome';
              break;
  
            case 'stacks_blackblue':
              $copy = special_title_map.stacks_dc + ' ' + format_title_map[$format];
              $url = '/products/blue-instant-film-for-600-duochrome';
              break;
  
            case 'stacks_silverframe':
              $copy = special_title_map.stacks_goldandsilver + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-600-silver-frame';
              break;
  
            case 'stacks_goldframe':
              $copy = special_title_map.stacks_goldandsilver + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-600-gold-frame';
              break;
  
            case 'stacks_deepsea':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-600-deep-sea-dive-frame-edition';
              break;
  
            case 'stacks_icecream':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-600-ice-cream-frame-edition';
              break;
  
            case 'stacks_tropics':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-600-tropics-frame-edition';
              break;
  
            case 'stacks_mf':
              $copy = film_title_map[$film];
              $url = '/products/color-film-for-600-mickey-edition';
              break;
  
            case 'stacks_sh':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-600-summer-haze';
              break;
  
            case 'stacks_fr':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-600-summer-fruits';
              break;
  
            case 'stacks_festivered':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-600-festive-red';
              break;
  
            case 'stacks_golddust':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-600-gold-dust';
              break;
  
            case 'stacks_popdeco':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-600-pop-deco';
              break;
  
            case 'stacks_fragment':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-600-fragment';
              break;
  
            default:
              return '';
          }
          break;
  
        case 'stacks_sx70':
  
          switch ($film) {
            case 'stacks_bw':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/bw-instant-film-for-sx70';
              break;
  
            case 'stacks_color':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-sx70';
              break;
  
            default:
              return '';
          }
          break;
  
        case 'stacks_spectra':
  
          switch ($film) {
            case 'stacks_bw':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/bw-instant-film-for-spectra';
              break;
  
            case 'stacks_color':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-spectra';
              break;
  
            default:
              return '';
          }
          break;
  
        case 'stacks_8x10':
  
          switch ($film) {
            case 'stacks_bw':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/bw-instant-film-for-8x10';
              break;
            case 'stacks_color':
              $copy = film_title_map[$film] + ' ' + format_title_map[$format];
              $url = '/products/color-instant-film-for-8x10';
              break;
            default:
              return '';
          }
          break;
  
        default:
          return '';
      }
  
      return $so + ' <a href="' + $url + '" class="text-link-b polaroid-stack__film-data">' + $copy + '</a>';
    }
  };
  
  /**
   * Additional Cart Scripts
   * ------------------------------------------------------------------------------
   * A file that contains scripts coupled to the cart functionality.
   *
   *   Please don't confuse:
   *
   * - This file is written for/by PO, prepares and adds cart functionality, that gets
   *   bound to the document.
   *
   * - polaroid.cart is just a JSON dump of the cart that happens inside the theme file.
   *
   * - slate/cart.js is a slate script, that adds functionality with that the framework.
   *
   * - rivets-cart.js/rivets-cart.min.js is added as vendor script and is the more or less
   *   official Shopify cart JavaScript library: https://cartjs.org/
   *   All files above are based on that.
   *
   *
   *   GENERAL CART INFOS FOR THIS SHOP
   *
   * - The fly-out cart is filled while rendered on page load and updated with Rivets JavaScript,
   *   some custom rivets.formatters are set up inside polaroid/helpers.js
   *
   * - The shop uses the cart.js Core API to add products to cart, related methods can
   *   be found below. The Data API can't be used, because we have additional information
   *   on products, that can't be transferred without custom JavaScript (see below).
   *   The Data API is not deactivated because it is used by rivets on the fly-out cart.
   *
   * - Variant changes on a product page are implemented with custom JavaScript (based on Shopify
   *   slate JavaScript), see file product/polaroid.js
   *
   * - data-po-add-to-cart-trigger attribute is used for add-to-cart buttons on product grids etc.
   *
   * - data-po-product-submit is used on the product page form submit button
   *
   * @namespace polaroid.cart_helpers
   */
  
  polaroid.cart_helpers = (function(_) {
    $(_init);
  
    function _init() {
  
  
      /**
       * The event handler for add-to-cart-buttons. The handler gets added to all
       * elements with the attribute data-po-add-to-cart-trigger – even when they get
       * added later to the page (external additions by apps, as long they are part
       * of the same document and not part of an iframe document).
       */
      $('[data-po-add-to-cart-trigger]').on('click', _addToCart );
  
      $(document).on('click', '[data-po-add-to-cart-trigger-alt]', _addToCart );
  
      /**
       * The event handler for the submit on product pages.
       */
      $('[data-po-product-submit]').on('submit', function(e) {
        // don't leave the page ...
        e.preventDefault();
        $(this).addClass('product-hero-actions--loading');
  
        var $formData = _getProductFormData(this), // returns null if this is not a form element
            properties = {},
            tracking = {
              category: 'Product Page',
              label: $formData.product_handle
            };
  
        if ($formData === null || $formData.id === undefined || $formData.quantity === undefined) {
          // without quantity and variant id we can not add the product
          return;
        }
  
        if ($formData.id !== undefined && _.isObject($formData.properties)) {
          properties = $formData.properties;
        }
  
        polaroid.cartMethods.addToCart($formData.id, $formData.quantity, properties, { tracking: tracking });
      });
  
      $(document).on('click', '[data-po-add-bundle-to-cart-trigger-alt]', _addBundleToCart );
  
      _loadCartImages();
  
      $(document).on('cart.requestComplete', function(event, cart) {
        // trigger infos for semi-external pages
        $(window).trigger('cartRequestFinished');
        _trackCartChanged(event, cart);
  
        if ( polaroid.goToCheckout ) {
          window.location.href = '/checkout';
          return false;
        }
  
        if ( polaroid.goingToCheckout ) {
          return false;
        }
  
        polaroid.cartController.update(cart);
        polaroid.helpers.updatePoLinks();
  
        if ( polaroid.page.template === 'cart' ) {
          return false;
        }
  
        // add code to prevent this running on the /cart page
        _loadCartImages();
  
        $('[data-po-add-to-cart-trigger]').removeAttr('disabled');
  
        $('[data-po-product-submit]').removeClass('product-hero-actions--loading');
      });
  
      $(document).on('cart.requestStarted', function(event, cart) {
        $('[data-po-add-to-cart-trigger]').attr('disabled', 'disabled');
      });
  
      /**
       * If you add an item to your cart, then click Checkout, then go back using
       * the browsers back button, the cart shows the incorrect quantity.
       * This happens because CartJS loads the cart from the shopify cart object,
       * which is embedded as JSON in the HTML (theme.liquid). When you click
       * back, the browser loads the page from the cache; it doesn't reload the
       * page. However, the embedded cart object on the cached page is stale,
       * because the add-to-cart action is performed via ajax.
       *
       * So this is the hack. When the user clicks Checkout, we change the value
       * of an input field in a hidden form. When the user clicks back, the value
       * will still be there because the browser will save the form data. On page
       * load, we check for this value. If it exists, the user must have come back
       * from the cart, so we reload the page, forcing the cart to update.
       *
       * Idea taken from https://stackoverflow.com/a/5642600
       */
  
      if ($('.back-from-checkout').val() == '1') {
        $('.back-from-checkout').val(0);
        window.location.reload();
      }
    }
  
    function _addToCart(e) {
      e.preventDefault();
  
      var $triggerEl = $(this),
          variantId  = $triggerEl.attr('data-po-variant-id') ? $triggerEl.attr('data-po-variant-id') : false,
          amount     = ((_.isUndefined($triggerEl.attr('data-po-amount'))) ? 1 : $triggerEl.attr('data-po-amount')),
          properties = {},
          trackingData = $triggerEl.attr('data-po-tracking') ? $triggerEl.attr('data-po-tracking').split(':') : undefined,
          tracking = trackingData ? {
            category: trackingData[0],
            label: trackingData[1]
          } : {};
  
      if ( $triggerEl.hasClass('po-button--disabled')) {
        return false;
      }
  
      // handle additional system properties (like pre-order and subscription)
      properties = _addPropertiesForVariantId(variantId, properties);
  
      polaroid.cartMethods.addToCart(variantId, amount, properties, { tracking: tracking });
    }
  
    function _addBundleToCart(e) {
      e.preventDefault();
      var $this = $(this);
      var bundle = {
        name: $this.attr('data-po-bundle-name'),
        handle: $this.attr('data-po-bundle-handle')
      };
  
      var saleDiscount = $this.attr('data-po-bundle-sale-discount');
  
      var discounts = {
        incentive_discount: parseFloat($this.attr('data-po-bundle-incentive-discount'))
      };
  
      if ( saleDiscount ) {
        discounts.sale_discount = parseFloat(saleDiscount);
      }
  
      bundle.variants = getBundleVariantsFromHandle( bundle.handle );
  
      polaroid.cartMethods.addBundleToCart(bundle, 1, discounts, false);
    }
  
    // TODO: Move this to helper methods
    function getBundleVariantsFromHandle( bundleHandle ) {
      var variants = [];
      var bundleData = bundleHandle.split('-');
  
      for ( var i = 0; i < bundleData.length; i++ ) {
        var variant = {};
  
        if ( bundleData[i].indexOf(':') > -1 ) {
          variant.id = parseInt(bundleData[i].split(':')[0]);
          variant.quantity = parseInt(bundleData[i].split(':')[1]);
        } else {
          variant.id = parseInt(bundleData[i]);
          variant.quantity = 1;
        }
  
        variants.push(variant);
      }
  
       return variants;
    }
  
    /**
     * Enriches properties for a variant
     *
     * @param variantId  string|number
     * @param properties object Current property object, might get an update before returned.
     *
     * @returns object enriched properties object
     *
     * @private
     */
    function _addPropertiesForVariantId(variantId, properties) {
      // handle pre-order
      properties = _addPreOrderProperties(variantId, properties);
  
      // add more variant related properties here ...
  
      return properties;
    }
  
    /**
     * Adds pre-order information to a given properties object and returns it.
     *
     * @param variantId
     * @param properties
     *
     * @returns object enriched properties object
     *
     * @private
     */
    function _addPreOrderProperties(variantId, properties) {
      var $preOrderDates = polaroid.helpers.getPreOrderPropertyDates(variantId);
  
      if (_.isObject($preOrderDates)) {
        properties._shipping_date_timestamp = $preOrderDates.timestamp;
        properties.Shipping_Date = $preOrderDates.formatted;
      }
      return properties;
    }
  
    /**
     * Track changes to the cart.
     *
     * @param cart
     *
     * @private
     */
    function _trackCartChanged(event, cart) {
      var $items = [];
      _.each(cart.items, function(element, index, list) {
        try {
          // don't break because of tracking
          $items.push({
            id: element.product_id,
            price: (element.price / 100).toFixed(2),
            quantity: element.quantity
          });
        } catch (e) {
          // console.log(e);
        }
      });
  
      // -------  Criteo  ------- //
      if (window.criteo_q && window.polaroid.criteoId && Cookiebot.consented) {
        window.criteo_q.push(
            { event: "setAccount", account: window.polaroid.criteoId },
            { event: "viewBasket", item: $items }
        );
      }
    }
  
    /**
     * Returns the needed add-to-cart data from a submitted form element.
     *
     * The setup of forms differ from product to product and changes with variants etc., so
     * it gets complicated to search the whole form for relevant data. serialize/un-serialize
     * does the trick. Unfortunately there is no un-serialize function in JS or jQuery, so we
     * write our own. It would work in a wider scope, but is not complex enough to work for
     * all use cases. So this is not an extension for the helpers or jQuery itself but
     * located inside this specific use case.
     *
     * @param formElement The HTML Form element that was submitted.
     *
     * @returns object All shopify add-to-cart relevant data from the product form submit.
     *
     * @private
     */
    function _getProductFormData(formElement) {
      var $form = $(formElement),
          obj    = {},
          str, pairs, pair,
          pIndex, pValue,
          subIndex, subIndexGroup;
  
      if (!$form.is('form')) {
        return null;
      }
      // getCleanData as a string
      str = decodeURI($form.serialize());
      pairs = str.split('&');
  
      for (var i=0, n=pairs.length; i < n; i++) {
        pair = pairs[i].split('=');
        subIndexGroup = null;
        subIndex = null;
        pIndex = decodeURIComponent(pair[0]).replace(/\+/g, ' ');
        pValue = decodeURIComponent(pair[1]).replace(/\+/g, ' ');
  
        if (pIndex.indexOf('[') > -1 && pIndex.indexOf(']') > -1 && pIndex.indexOf(']') == (pIndex.length -1)) {
          subIndexGroup = pIndex.substring(0, (pIndex.indexOf('[')));
          subIndex = pIndex.substring((pIndex.indexOf('[') + 1), (pIndex.length -1));
        }
  
        if (subIndexGroup !== null) {
          if (obj[subIndexGroup] === undefined) {
            obj[subIndexGroup] = {};
            obj[subIndexGroup][subIndex] = pValue;
          }
  
          else if (_.isObject(obj[subIndexGroup])) {
            obj[subIndexGroup][subIndex] = pValue;
          }
  
        } else if (obj[pIndex] === undefined) {
          obj[pIndex] = pValue;
  
        } else {
          if (typeof obj[pIndex] == "string") {
            obj[pIndex] = [obj[pIndex]];
          }
          obj[pIndex].push(pValue);
        }
      }
      return obj;
    }
  
    /*
     * When a new item is added to the cart, Rivets clones the previous HTML
     * component, including the img tag, with the previous `src`, then replaces
     * the `src` _after_ it's been inserted into the DOM. Default browser
     * behaviour is to display the old `src` until the new `src` starts loading.
     *
     * This hack hides all cart images, then checks each one to see if it's
     * `complete`. If so, it's shown immediatly. Otherwise, it's shown after the
     * `load` event.
     */
    function _loadCartImages() {
      $('img', '.cart__item').each(function() {
        var $e = $(this);
        $e.removeClass('is-visible').off('load');
  
        if ($e.get(0).complete) {
          $e.addClass('is-visible');
        } else {
          $e.on('load', function() {
            $e.addClass('is-visible');
          });
        }
      });
    }
  
  })(window._);
  
  polaroid.cursor = polaroid.cursor || {};
  
  polaroid.cursor.init = function() {
    if (Modernizr.touchevents) return;
  
    polaroid.cursor.elem = $('.reactive-cursor');
    polaroid.cursor.active = false;
  
    $('[data-reactive-cursor]').on('mousemove', function() {
      if (!polaroid.cursor.active) {
        polaroid.cursor.active = true;
        polaroid.cursor.update($(this));
      }
    }).on('mouseleave', polaroid.cursor.hide);
  
    $(window).on('mousemove', function(e) {
      if (polaroid.cursor.active) {
        polaroid.cursor.elem.css({transform: 'translate3d(' + e.pageX + 'px, ' + e.pageY + 'px, 0)'});
      }
    });
  };
  
  polaroid.cursor.update = function($elem) {
    if (Modernizr.touchevents || !polaroid.cursor.active) return;
  
    polaroid.cursor.elem
      .addClass('is-visible')
      .attr('data-cursor', $elem.attr('data-reactive-cursor'));
  
    if ($elem.attr('data-reactive-cursor-disabled') !== undefined) {
      polaroid.cursor.elem.addClass('is-disabled');
    } else {
      polaroid.cursor.elem.removeClass('is-disabled');
    }
  };
  
  polaroid.cursor.hide = function() {
    polaroid.cursor.active = false;
    polaroid.cursor.elem.removeClass('is-visible');
  };
  
  polaroid.documentScroll = (function() {
    polaroid.lastScrollTop = 0;
  
    function init() {
      $(window).on('scroll', function(e) {
        var $this = $(this);
        var st = $this.scrollTop();
        var wh = $this.outerHeight();
        var dh = $(document).outerHeight();
  
        if (st > polaroid.lastScrollTop){
          // Scrolling down
          $(window).trigger( 'po.scroll-down', { scrollTop: st, windowHeight: wh, documentHeight: dh } );
        } else {
          // Scrolling up
          $(window).trigger( 'po.scroll-up', { scrollTop: st, windowHeight: wh, documentHeight: dh } );
        }
  
        polaroid.lastScrollTop = st;
      });
    }
  
    return {
      init: init
    };
  })();
  
  // This script prevents scrolling on iOS devices when theres an overlay
  // The solution was implemented using code from this blog post https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
  // This should only be applied to iPhones
  
  polaroid.disableScrolling = function() {
    if ( polaroid.state.getState().isIos ) {
      var _noRubberEffectitems = document.getElementsByClassName('no-rubber-effect').length ? document.getElementsByClassName('no-rubber-effect') : [];
      var _noTouchItems = document.getElementsByClassName('no-touchmove').length ? document.getElementsByClassName('no-touchmove') : [];
  
      for ( var i = 0; i < _noRubberEffectitems.length; i++ ) {
        _noRubberEffectitems[i]._clientY = null; // remember Y position on touch start
  
        _noRubberEffectitems[i].addEventListener('touchstart', function (event) {
            if (event.targetTouches.length === 1) {
                // detect single touch
                this._clientY = event.targetTouches[0].clientY;
            }
        }, true);
  
        _noRubberEffectitems[i].addEventListener('touchmove', function (event) {
            if (event.targetTouches.length === 1) {
                // detect single touch
                disableRubberBand(event, this);
            }
        }, true);
      }
  
      for ( var j = 0; j < _noTouchItems.length; j++ ) {
        _noTouchItems[j].addEventListener('touchmove', function (event) {
          event.preventDefault();
        }, { passive: false });
      }
    }
  
    function disableRubberBand(event, item) {
        var clientY = event.targetTouches[0].clientY - item._clientY;
  
        if (item.scrollTop === 0 && clientY > 0) {
            // element is at the top of its scroll
            event.preventDefault();
        }
  
        if (isOverlayTotallyScrolled(item) && clientY < 0) {
            //element is at the top of its scroll
            event.preventDefault();
        }
    }
  
    function isOverlayTotallyScrolled(item) {
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
        return item.scrollHeight - item.scrollTop <= item.clientHeight;
    }
  };
  
  (function(
    $
  ) {
    var defaults = {
      scrollSpeed: 550,
      selectors: {
      },
      attributes: {
        scrollToItem: 'data-smooth-scroll'
      },
      classes: {
      },
      tracking: {
      }
    };
  
    var SmoothScroll = function(elem, options) {
      var self = this;
      this.settings = $.extend(true, {}, defaults, options);
  
      this.$button = $(elem);
      this.$scrollToElem = $(this.$button.attr(this.settings.attributes.scrollToItem));
  
  
      // Event listeners
      this.$button.on('click', function(e) {
        self.scrollTo(this.$scrollToElem);
      });
    };
  
    SmoothScroll.prototype = $.extend({}, SmoothScroll.prototype, {
      scrollTo: function() {
        var windowScrollTop = $(window).scrollTop();
        var elemScrollTop = this.$scrollToElem.offset().top;
        var scrollOffset = polaroid.state.currentScreenSizeMatches(['xs','sm']) ? 60 : 72;
  
        if ( windowScrollTop > elemScrollTop ) {
          elemScrollTop -= scrollOffset;
        } else if ( !polaroid.state.currentScreenSizeMatches(['xs','sm']) ) {
          elemScrollTop -= scrollOffset;
        }
  
        $([document.documentElement, document.body]).animate({
          scrollTop: elemScrollTop
        }, this.settings.scrollSpeed);
  
        window.setTimeout(function() {
          $(window).trigger('po.smooth-scroll-finished');
        }, this.settings.scrollSpeed + 50);
      }
    });
  
  
    // Adds component to polaroid module
    polaroid.SmoothScroll = SmoothScroll;
  
  
    // Creates jQuery component
    $.fn.smoothScroll = function() {
      var options = arguments[0];
  
      for ( var i = 0; i < this.length; i++ ) {
        if ( this[i].smoothScroll ) {
  
        } else {
          this[i].smoothScroll = new SmoothScroll(this[i], options);
        }
      }
  
      return this;
    };
  })(
    window.jQuery
  );
  
  rivets.configure({
    // Attribute prefix in templates
    prefix: 'data-rv'
  });
  
  rivets.binders.addclass = function(el, value) {
    if( el.addedClass ) {
      $(el).removeClass(el.addedClass);
      delete el.addedClass;
    }
  
    if( value ) {
      $(el).addClass(value);
      el.addedClass = value;
    }
  };
  
  rivets.formatters.length = function (value) {
    return value.length;
  };
  
  rivets.formatters.showFilmDiscount = function (item) {
  
    // return item.product_type === 'Film' && item.quantity < 3;
    return false;
  };
  
  rivets.formatters.getFilmDiscountMessage = function (item) {
    var discountAmount = 3,
        missingAmount = 0;
  
    missingAmount = Math.ceil((discountAmount - item.quantity) * 1);
  
    if (missingAmount > 0) {
      return "Buy " + missingAmount + " more and save 5%";
    }
    return '';
  };
  
  rivets.formatters.showPropertyList = function (obj) {
    return obj && typeof obj !== 'object' && !!obj.shipping_interval_unit_type;
  };
  
  rivets.formatters.propertyList = function (obj) {
    if (typeof obj !== 'object') {
     return;
    }
    var $newArray = [],
        $key;
  
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        $key = key;
  
        if (typeof $key == "string") {
          if ($key.substring(0,1) == '_' || obj[key] == '') {
            continue;
          }
          $key = $key.replace(/_/g, " ");
        }
        $newArray.push({'key': $key, 'value': obj[key]});
      }
    }
    return $newArray;
  };
  
  rivets.formatters.formatMoney = function (money) {
    return Shopify.formatMoney(money);
  };
  
  // TODO: move this to rivets handler
  // TODO: add loading spinner
  $('.cart__items').on('click', '[data-bundle-remove]', function(e) {
    e.preventDefault();
    var $this = $(this);
    var bundleHandle = $this.attr('data-bundle-remove');
    var $itemContainer = $this.parents('.cart__item');
    var itemsRemoved = 0;
  
    var itemsToDelete = _.filter(CartJS.cart.items, function(item) {
      if ( !item.properties._bundle_data) return false;
  
      var bundleData = JSON.parse(item.properties._bundle_data);
  
      return bundleData.bundle_handle === bundleHandle;
    });
  
    for (var i = 0; i < itemsToDelete.length; i++) {
      CartJS.updateItemById(itemsToDelete[i].id, 0, itemsToDelete[i].properties);
    }
  });
  
  // TODO: move this to rivets handler
  // TODO: add loading spinner
  $('.cart__items').on('click', '[data-bundle-update]', function(e) {
    e.preventDefault();
  
    var $this = $(this);
    var bundleHandle = $this.attr('data-bundle-update');
    var bundle = _.findWhere(CartJS.cart.bundles, { handle: bundleHandle });
    var operation = $this.attr('data-cart-bundle-minus') === "true" ? 'minus' : 'plus';
    var itemsAdded = 0;
  
    var itemsToUpdate = _.filter(CartJS.cart.items, function(item) {
      if ( !item.properties._bundle_data) return false;
  
      var bundleData = JSON.parse(item.properties._bundle_data);
  
      return bundleData.bundle_handle === bundleHandle;
    });
  
    for (var i = 0; i < itemsToUpdate.length; i++) {
      var quantity = itemsToUpdate[i].quantity;
      var quantityToUpdate = JSON.parse(itemsToUpdate[i].properties._bundle_data).item_qty;
  
  
      if ( operation === 'minus' ) {
        quantity -= quantityToUpdate;
      } else {
        quantity += quantityToUpdate;
      }
  
      CartJS.updateItemById(itemsToUpdate[i].id, quantity, itemsToUpdate[i].properties);
    }
  });
  
  /*
    Bundle Factory to handle bundles to be added to the cart
    Requires bundleJson object, see 'script.bundle-json.liquid' for model
  */
  polaroid.BundleController = function( bundleJson ) {
    var amount = 1;
    var bundle = {
      name: bundleJson.name,
      handle: bundleJson.handle,
      variants: bundleJson.variants
    };
    var price = 0;
    var comparePrice = 0;
    var discounts = {
      incentive_discount: bundleJson.incentive_discount,
      sale_discount: bundleJson.sale_discount
    };
    var available = true;
  
    updatePrice();
    updateAvailability();
  
  
    // Public methods
  
    this.getVariants = function() {
      return bundle.variants;
    };
  
    this.getUnavailableVariants = function() {
      var unavailableVariants = [];
  
      for ( var i = 0; i < bundle.variants.length; i++ ) {
        if ( !bundle.variants[i].available ) {
          unavailableVariants.push(bundle.variants[i]);
        }
      }
  
      return unavailableVariants;
    };
  
    this.getPrice = function() {
      return {
        price: price,
        comparePrice: comparePrice
      };
    };
  
    this.getAvailability = function() {
      return available;
    };
  
    this.decreaseAmount = function() {
      if ( amount > 1 ) {
        amount--;
      }
  
      return this;
    };
  
    this.increaseAmount = function() {
      amount++;
  
      return this;
    };
  
    this.updateAmount = function( newAmount ) {
      amount = newAmount;
  
      return this;
    };
  
    this.addVariant = function(variant) {
      bundle.variants.push(variant);
  
      updateHandle();
      updatePrice();
  
      return this;
    };
  
    this.removeVariant = function( productHandle ) {
      bundle.variants = _.without(bundle.variants, _.findWhere(bundle.variants, {
        handle: productHandle
      }));
  
      updateHandle();
      updatePrice();
  
      return this;
    };
  
    this.updateVariant = function(variantIndex, newId, newPrice, newComparePrice, newImage, isAvailable, callbackAvailable, callbackUnavailable) {
      var variant = bundle.variants[variantIndex];
      variant.id = newId;
      variant.price = newPrice;
      variant.comparePrice = newComparePrice;
      variant.image = newImage;
      variant.available = isAvailable;
  
      updateHandle();
      updatePrice();
      updateAvailability();
  
      return this;
    };
  
    this.addBundleToCart = function(goToCheckout) {
      return polaroid.cartMethods.checkBundleAvailability( bundle.variants )
        .then( function ( status ) {
          if ( status === 'available' ) {
            return polaroid.cartMethods.addBundleToCart( bundle, amount, discounts, goToCheckout );
          } else {
            errorCallback();
          }
        });
    };
  
  
    // Private methods
  
    function updatePrice() {
      comparePrice = 0;
      price = 0;
  
      for ( var i = 0; i < bundle.variants.length; i++ ) {
        comparePrice += bundle.variants[i].comparePrice;
        price += bundle.variants[i].price;
      }
    }
  
    function updateHandle() {
      var variantIds = [];
  
      for ( var index = 0; index < bundle.variants.length; index++ ) {
        var variant = bundle.variants[index];
        var variantHandle = variant.id.toString();
  
        if ( variant.quantity > 1 ) {
          variantHandle = variantHandle.concat(':').concat(variant.quantity);
        }
  
        variantIds.push(variantHandle);
      }
  
      bundle.handle = variantIds.join('-');
    }
  
    function updateAvailability() {
      available = true;
  
      for ( var i = 0; i < bundle.variants.length; i++ ) {
        if ( bundle.variants[i].available === false ) {
          available = false;
          break;
        }
      }
    }
  };
  
  /**
   * Custom cart controller implementation to handle bundles
   *
   */
  
  polaroid.cartController = (function() {
    var polaroidCart;
    var cartView;
    var cartOverlay = $('[data-polaroid-cart-view]');
    var $cartIcon = $('.site-header__icon-cart');
    var $cartPanel = $('#NavPanelCart');
  
    function init() {
      // TODO: Restore unavailable bundles logic
      // var bundlesToRemove = [];
      // for ( var i = 0; i < bundles.length; i++ ) {
      //   if ( !checkBundleComponentsAvailability(bundles[i].handle, bundles[i].quantity) )  {
      //     bundlesToRemove.push(bundles[i].handle);
      //   }
      // }
      //
      // for ( var j = 0; j < bundlesToRemove.length; j++ ) {
      //   removeBundleItemsFromCart(bundlesToRemove[j], function() {
      //     if ( j === bundlesToRemove.length - 1 ) {
      //       updateBundles(polaroidCart);
      //       $(document).on('cart.requestComplete', function(event, cart) {
      //         updateBundles(polaroidCart);
      //       });
      //     }
      //   });
      // }
      //
      // if ( !bundlesToRemove.length ) {
      //   updateBundles(polaroidCart);
      //   $(document).on('cart.requestComplete', function(event, cart) {
      //     updateBundles(polaroidCart);
      //   });
      // }
  
      CartJS.init(polaroid.cart, {
        //debug: true,
        requestBodyClass: 'cart-js-loading',
        moneyFormat: polaroid.moneyFormat
      });
  
      updateCartView(polaroid.cart);
    }
  
    function updateCartView(cartObject) {
      cartObject = cartObject || CartJS.cart;
      polaroidCart = addBundlesToCart(cartObject);
  
      if ( !cartView ) {
        cartView = rivets.bind(
          cartOverlay,
          {
            cart: polaroidCart
          }
        );
      } else {
        cartView.update({
          cart: polaroidCart
        });
      }
  
  
      _updateCartGraphics(cartObject);
    }
  
    // TODO: Movie this to header script
    function _updateCartGraphics(cartObject) {
      var totalItems = cartObject.item_count;
  
      if ( totalItems > 0 ) {
        $cartIcon.addClass('site-header__icon-cart--has-items');
        $cartPanel.addClass('site-header__panel--cart');
      } else {
        $cartIcon.removeClass('site-header__icon-cart--has-items');
        $cartPanel.removeClass('site-header__panel--cart');
      }
    }
  
    function addBundlesToCart(cartObject) {
      var cart = $.extend({}, cartObject);
      var cartItems = cartObject.items;
      var items = [];
      var bundleItems = {};
      var bundles = [];
  
      if ( !!cartItems.length ) {
        for ( var i = 0; i < cartItems.length; i++ ) {
          if (_.isObject(cartItems[i].properties) && cartItems[i].properties._bundle_data) {
            var bundleData = JSON.parse(cartItems[i].properties._bundle_data);
            var bundleHandle = bundleData.bundle_handle;
  
            if ( bundleHandle ) {
              if ( !bundleItems[bundleHandle] ) {
                bundleItems[bundleHandle] = [];
              }
              bundleItems[bundleHandle].push(cartItems[i]);
            }
          } else {
            // Index needed to update quantity from cart overlay
            cartItems[i].index = i;
            items.push(cartItems[i]);
          }
        }
  
        for (var key in bundleItems) {
          if (!bundleItems.hasOwnProperty(key)) { continue; }
  
          var bundleDataSet = JSON.parse(bundleItems[key][0].properties._bundle_data);
          var discounts = bundleItems[key][0].discounts.length ? bundleItems[key][0].discounts : null;
  
          var bundle = {
            name: bundleItems[key][0].properties.Bundle,
            original_price: 0,
            price: 0,
            quantity: 0,
            handle: bundleDataSet.bundle_handle,
            discounts: discounts,
            products: []
          };
  
          for ( var j = 0; j < bundleItems[key].length; j++ ) {
            var bundleInfo = JSON.parse(bundleItems[key][j].properties._bundle_data);
            var incentive_discount_percentage = (100 - parseFloat(bundleItems[key][j].properties._bundle_incentive_discount)) / 100;
  
            var product = {
              name: bundleItems[key][j].title,
              quantity: bundleItems[key][j].quantity,
              image: bundleItems[key][j].image
            };
  
            if ( bundle.quantity === 0 ) {
              bundle.quantity = bundleItems[key][j].quantity / bundleInfo.item_qty;
            }
  
            bundle.original_price += Math.round(bundleItems[key][j].original_line_price * incentive_discount_percentage);
            bundle.price += bundleItems[key][j].line_price;
  
            bundle.products.push(product);
          }
  
          bundle.products.reverse();
  
          bundles.push(bundle);
        }
  
        cart.bundles = bundles;
      }
  
      cart.items = items;
  
      return cart;
    }
  
    function checkBundleComponentsAvailability( bundleHandle, bundleQuantity ) {
      var available = true;
      var variants = getBundleComponentsFromHandle(bundleHandle);
  
      for ( var i = 0; i < variants.length; i++ ) {
        if ( variants[i].quantity * bundleQuantity > window.polaroid.cart_inventory_quantity[variants[i].id] ) {
          available = false;
          break;
        }
      }
  
      return available;
    }
  
    function getBundlesFromCart(items) {
      var bundles = [];
  
      for ( var i = 0; i < items.length; i++ ) {
        if (!items[i].properties._bundle_data) { continue; }
  
        var exists = false;
        var bundleData = JSON.parse(items[i].properties._bundle_data);
        var bundleHandle = bundleData.bundle_handle;
        var bundleQuantity = items[i].quantity / bundleData.item_qty;
  
        for ( var j = 0; j < bundles.length; j++ ) {
          if ( bundleHandle === bundles[j].handle ) {
            exists = true;
            break;
          }
        }
  
        if ( !exists ) {
          bundles.push({ handle: bundleHandle, quantity: bundleQuantity});
        }
      }
  
      return bundles;
    }
  
    /**
     * Assembles bundle variant components from handle
     *
     * @param {string} bundeHandle Bundle handle
     *
     * @returns array List of variants with id and quantity
     *
     */
    function getBundleComponentsFromHandle( bundleHandle ) {
      var variants = [];
      var components = bundleHandle.split('-');
  
      for ( var i = 0; i < components.length; i++ ) {
        var componentInfo = components[i].split(':');
        var componentHandle = parseInt(componentInfo[0]);
        var componentQuantity = 1;
  
        if ( componentInfo[1] ) {
          componentQuantity = parseInt(componentInfo[1]);
        }
        variants.push({id: componentHandle, quantity: componentQuantity});
      }
  
      return variants;
    }
  
    /**
     * Removes items asociated with handle from cart
     *
     * @param {string} bundeHandle Bundle handle
     * @param {function} successCallback Callback when update has been successful
     *
     */
    function removeBundleItemsFromCart( bundleHandle, successCallback ) {
      var variants = getBundleComponentsFromHandle( bundleHandle );
      var updates = {};
  
      for ( var i = 0; i < variants.length; i++ ) {
        updates[variants[i].id] = 0;
      }
  
      CartJS.updateItemQuantitiesById(updates, {
        "success": function(cart, textStatus, jqXHR) {
          if ( successCallback ) successCallback();
        }
      });
    }
  
    return {
      init: init,
      update: updateCartView
    };
  })();
  

  /*================ Components ================*/
  (function(
    $,
    tracking,
    state
  ) {
    var defaults = {
      openCallback: null,
      closeCallback: null,
      selectors: {
        closeButton: '[modal-close]',
        content: '.po-modal__content'
      },
      attributes: {
        triggerButton: 'data-modal-trigger-button',
        trackingCategory: 'data-modal-tracking-category'
      },
      classes: {
        show: 'po-modal--show',
        bodyOpen: 'quickview-open'
      },
      tracking: {
        category: 'Modal',
        actionOpen: 'Open',
        actionClose: 'Close'
      }
    };
  
    var Modal = function(elem, options) {
      var self = this;
      this.settings = $.extend(true, {}, defaults, options);
  
      this.$modal = $(elem);
      this.$modalContent = this.$modal.find(this.settings.selectors.content);
      this.$close = this.$modal.find(this.settings.selectors.closeButton);
      this.$triggerButton = $(this.$modal.attr(this.settings.attributes.triggerButton));
  
      this.settings.tracking.category = this.$modal.attr(this.settings.attributes.trackingCategory) || this.settings.tracking.category;
  
  
      // Event listeners
      this.$close.on('click', function(e) {
        self.close(true, true);
      });
  
      this.$triggerButton.on('click', function(e) {
        self.open(true);
      });
  
      // Closes modal when hitting back/return on history
      $(window).on('popstate', function(e) {
        if ( e.originalEvent.state === 'polaroid.modalOpen' ) {
          self.close(true, true);
        }
      });
    };
  
    Modal.prototype = $.extend({}, Modal.prototype, {
      open: function(trackEvent) {
        this.$modal.addClass(this.settings.classes.show);
  
        $('body').addClass(this.settings.classes.bodyOpen);
        state.lockScreen();
  
        if ( trackEvent ) {
          tracking.general(
            this.settings.tracking.category,
            this.settings.tracking.actionOpen,
            this.settings.tracking.label
          );
        }
  
        // Pushes a new history state to enable back button closing the modal
        try {
          window.history.pushState('polaroid.modalOpen', 'Modal Opened');
        } catch(e) {
          console.log(e);
        }
      },
  
      close: function(doCallback, trackEvent) {
        this.$modal.removeClass(this.settings.classes.show);
  
        $('body').removeClass(this.settings.classes.bodyOpen);
        state.unlockScreen();
  
        if (this.settings.closeCallback && doCallback ) {
          this.settings.closeCallback();
        }
  
        if ( trackEvent ) {
          tracking.general(
            this.settings.tracking.category,
            this.settings.tracking.actionClose,
            this.settings.tracking.label
          );
        }
      },
  
      appendContent: function(elem) {
        this.$modalContent.append(elem);
      },
  
      removeContent: function() {
        this.$modalContent.empty();
      }
    });
  
    // Adds Modal to polaroid components
    polaroid.Modal = Modal;
  
    // Adds modal to jQuery
    $.fn.modal = function() {
      var options = arguments[0];
  
      for ( var i = 0; i < this.length; i++ ) {
        if ( this[i].modal ) {
  
        } else {
          this[i].modal = new Modal(this[i], options);
        }
      }
  
      return this;
    };
  })(
    window.jQuery,
    polaroid.tracking,
    polaroid.state
  );
  
  (function(
    $,
    _,
    tracking
  ) {
    var defaults = {
      state: 'enabled',
      onClick: undefined,
      states: ['enabled', 'disabled', 'loading'],
      loadingText: 'Loading...',
      loader: false,
      preventDefault: true,
      selectors: {
        text: '.po-button__text'
      },
      attributes: {
        loadingText: 'data-button-loading-text',
        trackingCategory: 'data-button-tracking-category'
      },
      classes: {
        buttonLoading: 'po-button--loading',
        buttonDisabled: 'po-button--disabled'
      },
      tracking: {}
    };
  
    var Button = function(elem, options) {
      var self = this;
      this.settings = $.extend(true, {}, defaults, options);
  
      this.$button = $(elem);
      this.$buttonText = this.$button.find(this.settings.selectors.text);
      this.originalText = this.$buttonText.text().trim();
  
      this.settings.loadingText = this.$button.attr(this.settings.attributes.loadingText) || this.settings.loadingText;
      this.settings.tracking.category = this.$button.attr(this.settings.attributes.trackingCategory) || this.settings.tracking.category;
  
      if ( this.$button.hasClass('po-button--disabled') ) {
        this.settings.state = 'disabled';
      }
  
      // Event listeners
  
      this.$button.on('click', function(e) {
        if ( self.settings.preventDefault ) {
          e.preventDefault();
        }
  
        self.click();
      });
    };
  
    Button.prototype = $.extend({}, Button.prototype, {
      click: function() {
        if ( this.settings.state !== 'enabled' ) return;
  
        if (this.settings.onClick) {
          this.settings.onClick();
        }
  
        if ( !_.isEmpty(this.settings.tracking) ) {
          tracking.general(
            this.settings.tracking.category,
            this.settings.tracking.clickAction
          );
        }
  
        if ( this.settings.loader ) {
          this.setState('loading');
        }
      },
  
      setState: function(newState) {
        if ( !this.settings.states.includes(newState) ) return false;
  
        switch (newState) {
          case 'enabled':
            this._reset();
            break;
          case 'disabled':
            this._disable();
            break;
          case 'loading':
            this._loading();
            break;
        }
  
        this.settings.state = newState;
      },
  
      setText: function(text) {
        this.$buttonText.text(text);
      },
  
      _disable: function() {
        this._reset();
  
        this.$button.addClass(this.settings.classes.buttonDisabled);
      },
  
      _loading: function() {
        this._disable();
  
        this.$button
          .addClass(this.settings.classes.buttonLoading);
  
        this.setText(this.settings.loadingText);
      },
  
      _reset: function() {
        this.$button
          .removeClass(this.settings.classes.buttonLoading)
          .removeClass(this.settings.classes.buttonDisabled);
  
        this.setText(this.originalText);
      }
     });
  
    // Creates jQuery component
    $.fn.button = function() {
      var opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          ret;
  
      for ( var i = 0; i < this.length; i++ ) {
        if ( this[i].button ) {
          ret = this[i].button[opt].apply(this[i].button, args);
          if (typeof ret != 'undefined') return ret;
        } else {
          this[i].button = new Button(this[i], opt);
        }
      }
  
      return this;
    };
  })(
    window.jQuery,
    window._,
    polaroid.tracking
  );
  
  (function(
    $,
    tracking
  ) {
    var defaults = {
      quantity: 1,
      selectors: {
        minus: '[data-quantity-adjust-minus]',
        plus: '[data-quantity-adjust-plus]',
        display: '[data-quantity-adjust-display]'
      },
      attributes: {
      },
      classes: {
      },
      tracking: {
        category: 'Quantity',
        increaseQuantityAction: 'Increase Quantity',
        decreaseQuantityAction: 'Decrease Quantity'
      }
    };
  
    var QuantityAdjust = function(elem, options) {
      var self = this;
      this.settings = $.extend(true, {}, defaults, options);
  
      this.$quantityAdjust = $(elem);
      this.$minus = this.$quantityAdjust.find(this.settings.selectors.minus);
      this.$plus = this.$quantityAdjust.find(this.settings.selectors.plus);
      this.$display = this.$quantityAdjust.find(this.settings.selectors.display);
  
  
      // Event listeners
      this.$minus.on('click', this.decreaseQuantity.bind(this));
  
      this.$plus.on('click', this.increaseQuantity.bind(this));
    };
  
    QuantityAdjust.prototype = $.extend({}, QuantityAdjust.prototype, {
      getQuantity: function() {
        return this.settings.quantity;
      },
  
      decreaseQuantity: function() {
        if ( this.settings.quantity > 1 ) {
          this.settings.quantity--;
          this.updateDisplay();
  
          tracking.general(
            this.settings.tracking.category,
            this.settings.tracking.decreaseQuantityAction,
            this.settings.tracking.label
          );
        }
      },
  
      increaseQuantity: function() {
        this.settings.quantity++;
        this.updateDisplay();
  
        tracking.general(
          this.settings.tracking.category,
          this.settings.tracking.increaseQuantityAction,
          this.settings.tracking.label
        );
      },
  
      updateDisplay: function() {
        this.$display.html(this.settings.quantity);
      }
    });
  
  
    // Adds component to polaroid module
    polaroid.QuantityAdjust = QuantityAdjust;
  
  
    // Creates jQuery component
    $.fn.quantityAdjust = function() {
      var options = arguments[0];
  
      for ( var i = 0; i < this.length; i++ ) {
        if ( this[i].quantityAdjust ) {
  
        } else {
          this[i].quantityAdjust = new QuantityAdjust(this[i], options);
        }
      }
  
      return this;
    };
  })(
    window.jQuery,
    polaroid.tracking
  );
  
  (function(
    $,
    tracking
  ){
    var defaults = {
      currentImageIndex: 0,
      imagesQuantity: 1,
      showPageDots: false,
      selectors: {
        dots: '[data-image-gallery-dots]',
        dot: '[data-image-gallery-dot]',
        imagePrev: '[data-image-gallery-prev]',
        imageNext: '[data-image-gallery-next]',
        imageSlide: '[data-image-gallery-slider]',
        image: '[data-image-gallery-image]'
      },
      attributes: {
      },
      classes: {
      },
      tracking: {
        category: 'Image Gallery',
        selectImageAction: 'Select Image',
        prevImageAction: 'Previous Image',
        nextImageAction: 'Next Image'
      }
    };
  
    var ImageGallery = function(elem, options) {
      var self = this;
  
      this.$imageGallery = $(elem);
      var dataSettings = this.$imageGallery.data('image-gallery');
  
      this.settings = $.extend(true, {}, defaults, options, dataSettings);
      this.$imageDots = this.$imageGallery.find(this.settings.selectors.dots);
      this.$imageDot = this.$imageGallery.find(this.settings.selectors.dot);
      this.$imagePrev = this.$imageGallery.find(this.settings.selectors.imagePrev);
      this.$imageNext = this.$imageGallery.find(this.settings.selectors.imageNext);
      this.settings.imagesQuantity = this.$imageDot.length;
  
      this.$imageSlider = $(this.$imageGallery.find(this.settings.selectors.imageSlide)).flickity({
        cellAlign: 'left',
        cellSelector: this.settings.selectors.image,
        contain: true,
        draggable: Modernizr.touchevents,
        dragThreshold: 10,
        pageDots: this.settings.showPageDots,
        prevNextButtons: false,
        setGallerySize: true,
        lazyLoad: true
      });
  
  
      // Event listeners
  
      this.$imageDot.on('click', function(e) {
        var index = $(this).data('index');
        self.updateImage(index, true, false, true);
      });
  
      this.$imagePrev.on('click', function(e) {
        self.prevImage(true);
      });
  
      this.$imageNext.on('click', function(e) {
        self.nextImage(true);
      });
  
      this.$imageSlider.on('change.flickity', function( e, index ) {
        self.updateImage(index, false, false, false);
      });
    };
  
    ImageGallery.prototype = $.extend({}, ImageGallery.prototype, {
      nextImage: function(trackEvent) {
        if ( this.settings.currentImageIndex < this.settings.imagesQuantity - 1 ) {
          this.settings.currentImageIndex++;
          this.updateImage(this.settings.currentImageIndex, true, false, false);
  
          if ( trackEvent ) {
            tracking.general(
              this.settings.tracking.category,
              this.settings.tracking.nextImageAction
            );
          }
        }
      },
  
      prevImage: function(trackEvent) {
        if ( this.settings.currentImageIndex > 0 ) {
          this.settings.currentImageIndex--;
          this.updateImage(this.settings.currentImageIndex, true, false, false);
  
          if ( trackEvent ) {
            tracking.general(
              this.settings.tracking.category,
              this.settings.tracking.prevImageAction
            );
          }
        }
      },
  
      updateImage: function(index, updateSlider, isInstant, trackEvent) {
        this.settings.currentImageIndex = index;
        if ( updateSlider ) this.$imageSlider.flickity('select', this.settings.currentImageIndex, false, isInstant);
        this.updateNav(index);
  
        if ( trackEvent ) {
          tracking.general(
            this.settings.tracking.category,
            this.settings.tracking.selectImageAction
          );
        }
      },
  
      updateNav: function( imageIndex ) {
        var translateNav = imageIndex > 3 ? -20 * ( imageIndex - 3 ) : 0;
  
        if ( imageIndex === 0 ) {
          this.$imagePrev.addClass('po-image-gallery__arrow--disabled');
        } else if ( imageIndex === this.settings.imagesQuantity - 1 ) {
          this.$imageNext.addClass('po-image-gallery__arrow--disabled');
        } else {
          this.$imagePrev.removeClass('po-image-gallery__arrow--disabled');
          this.$imageNext.removeClass('po-image-gallery__arrow--disabled');
        }
  
        this.$imageDots.css({ 'transform': 'translateX(' + translateNav + 'px)' });
        this.$imageDot.removeClass('po-image-gallery__dot--active');
        $(this.$imageDot[imageIndex]).addClass('po-image-gallery__dot--active');
      }
    });
  
    // Adds component to polaroid module
    polaroid.ImageGallery = ImageGallery;
  
  
    // Creates jQuery component
    $.fn.imageGallery = function() {
      var opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          ret;
  
      for ( var i = 0; i < this.length; i++ ) {
        if ( this[i].imageGallery ) {
          ret = this[i].imageGallery[opt].apply(this[i].imageGallery, args);
          if (typeof ret != 'undefined') return ret;
        } else {
          this[i].imageGallery = new ImageGallery(this[i], opt);
        }
      }
  
      return this;
    };
  })(
    window.jQuery,
    polaroid.tracking
  );
  
  polaroid.Price = function( comparePrice, price ) {
    var $comparePrice = $(comparePrice);
    var $price = $(price);
  
  
    // Public methods
  
    this.updatePrice = function( price ) {
      $comparePrice.html(slate.Currency.formatMoney(price.comparePrice, polaroid.moneyFormat));
      $price.html(slate.Currency.formatMoney(price.price, polaroid.moneyFormat));
  
      if ( price.comparePrice <= price.price ) {
        $comparePrice.addClass('hidden');
        $price.removeClass('tomato');
      } else {
        $comparePrice.removeClass('hidden');
        $price.addClass('tomato');
      }
    };
  };
  
  (function(
    $,
    tracking
  ) {
    var defaults = {
      currentVariantId: null,
      quantity: null,
      updateQuantityCallback: undefined,
      selectors: {
        button: '[data-tier-set-button]',
        buttonPrices: '.po-tier-set__button-prices',
        comparePrice: '[data-compare-price-display]',
        price: '[data-price-display]',
        tierSetJson: '[data-tier-set-json]'
      },
      attributes: {
        quantity: 'data-tier-set-quantity',
        comparePrice: 'data-tier-set-compare-price',
        price: 'data-tier-set-price'
      },
      classes: {
        buttonActive: 'po-tier-set__button--active',
        buttonUnavailable: 'po-tier-set__button--unavailable'
      },
      tracking: {
        category: 'Tier Set',
        updateTierAction: 'Update Tier'
      }
    };
  
    var TierSet = function(elem, options) {
      var self = this;
      this.settings = $.extend(true, {}, defaults, options);
  
      this.$tierSet = $(elem);
      this.$tierButton = this.$tierSet.find(this.settings.selectors.button);
      this.$tierButtonPrices = this.$tierSet.find(this.settings.selectors.buttonPrices);
      this.settings.variants = JSON.parse(this.$tierSet.find(this.settings.selectors.tierSetJson).html()).variants;
  
      this.settings.currentVariantId = typeof this.settings.currentVariantId === 'string' ? parseInt(this.settings.currentVariantId) : this.settings.currentVariantId || this.settings.variants[0].id;
  
      this.price = new polaroid.Price(
        this.$tierSet.find(this.settings.selectors.comparePrice),
        this.$tierSet.find(this.settings.selectors.price)
      );
  
      // Event listeners
  
      this.$tierButton.on('click', function(e) {
        var $this = $(this);
        if ( $this.hasClass(self.settings.classes.buttonUnavailable) ) return false;
        var newQuantity = parseInt($this.attr(self.settings.attributes.quantity));
  
        self.updateQuantity(newQuantity, e.originalEvent.isTrusted);
        self.updatePrice();
  
        self.selectButton(this);
      });
  
      this._init();
    };
  
    TierSet.prototype = $.extend({}, TierSet.prototype, {
      _init: function() {
        var self = this;
        this.updateCurrentVariantId(this.settings.currentVariantId);
  
        // Inits the module with the quantity for the second option, if it's available
        if ( !this.settings.quantity ) {
          this.$tierButton[1].click();
          this.settings.quantity = parseInt(this.$tierButton.eq(1).attr(this.settings.attributes.quantity));
        } else if ( this.settings.quantity && this.settings.quantity > 1 ) {
          this.$tierButton.filter(function(index, elem) {
            return parseInt($(elem).attr(self.settings.attributes.quantity)) === self.settings.quantity;
          })[0].click();
        }
  
        this.updatePrice();
      },
  
      updatePrice: function() {
        var tier = 'tier' + this.settings.quantity;
        var currentVariant = _.findWhere(this.settings.variants, {id: this.settings.currentVariantId });
        var comparePrice = currentVariant.prices[tier].comparePrice;
        var price = currentVariant.prices[tier].price;
  
        this.price.updatePrice({
          comparePrice: comparePrice,
          price: price
        });
      },
  
      updateCurrentVariantId: function(newVariantId) {
        var self = this;
        var currentVariant = _.findWhere(this.settings.variants, { id: newVariantId });
        this.settings.currentVariantId = newVariantId;
  
        this.$tierButtonPrices.hide();
        this.$tierSet
          .find(this.settings.selectors.buttonPrices + '--' + newVariantId)
          .show();
  
  
        this.$tierButton.each(function(i) {
          var $this = $(this);
          var quantity = $this.attr(self.settings.attributes.quantity);
          var tier = currentVariant.prices['tier' + quantity];
  
          if ( tier.available ) {
            $this.removeClass(self.settings.classes.buttonUnavailable);
          } else {
            $this.addClass(self.settings.classes.buttonUnavailable);
          }
        });
      },
  
      updateQuantity: function(newQuantity, trackEvent) {
        this.settings.quantity = newQuantity;
  
        if ( this.settings.updateQuantityCallback ) {
          this.settings.updateQuantityCallback(newQuantity);
        }
  
        if ( trackEvent ) {
          tracking.general(
            this.settings.tracking.category,
            this.settings.tracking.updateTierAction,
            this.settings.tracking.label,
            newQuantity
          );
        }
      },
  
      getQuantity: function() {
        return this.settings.quantity;
      },
  
      selectButton: function(button) {
        this.$tierButton.removeClass(this.settings.classes.buttonActive);
        $(button).addClass(this.settings.classes.buttonActive);
      }
    });
  
    // Creates jQuery component
    $.fn.tierSet = function() {
      var opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          ret;
  
      for ( var i = 0; i < this.length; i++ ) {
        if ( this[i].tierSet ) {
          ret = this[i].tierSet[opt].apply(this[i].tierSet, args);
          if (typeof ret != 'undefined') return ret;
        } else {
          this[i].tierSet = new TierSet(this[i], opt);
        }
      }
  
      return this;
    };
  })(
    window.jQuery,
    polaroid.tracking
  );
  
  (function(
    $,
    tracking
  ) {
    var defaults = {
      selectors: {
      },
      attributes: {
        productId: 'data-variant-product-id',
        productHandle: 'data-variant-product-handle',
        comparePrice: 'data-variant-compare-price',
        price: 'data-variant-price',
        image: 'data-variant-image',
        imageIndex: 'data-variant-img-index',
        available: 'data-variant-available'
      },
      classes: {
      },
      tracking: {
        category: 'Variant Select',
        changeVariantAction: 'Change Variant'
      }
    };
  
    var VariantSelect = function(elem, options) {
      var self = this;
  
      this.settings = $.extend(true, {}, defaults, options);
      this.$variantSelect = $(elem);
  
      // Event listeners
      this.$variantSelect.on('change', function(e, data) {
        var $option = $('option:selected', this);
        var variant = self.getVariantDataFromOption($option);
        var trackingLabel;
  
        if ( self.settings.variantChangedCallback ) {
          self.settings.variantChangedCallback(variant);
        }
  
        if ( typeof data === 'undefined' || ( data && data.trackEvent ) ) {
          trackingLabel = variant.productHandle + '|' + variant.title;
  
          tracking.general(
            self.settings.tracking.category,
            self.settings.tracking.changeVariantAction,
            trackingLabel
          );
        }
      });
    };
  
    VariantSelect.prototype = $.extend({}, VariantSelect.prototype, {
      getSelectedVariant: function() {
        return this.getVariantDataFromOption($('option:selected', this.$variantSelect));
      },
  
      getVariantDataFromOption: function($option) {
        var variant = {};
  
        variant.id = parseInt($option.val());
        variant.title = $option.text().trim();
        variant.productId = parseInt($option.attr(this.settings.attributes.productId));
        variant.productHandle = $option.attr(this.settings.attributes.productHandle);
        variant.comparePrice = parseInt($option.attr(this.settings.attributes.comparePrice));
        variant.price = parseInt($option.attr(this.settings.attributes.price));
        variant.image = $option.attr(this.settings.attributes.image);
        variant.imageIndex = parseInt($option.attr(this.settings.attributes.imageIndex));
        variant.available = JSON.parse($option.attr(this.settings.attributes.available));
  
        return variant;
      },
  
      updateVariantById: function(variantId, trackEvent) {
        this.$variantSelect
          .val(variantId)
          .trigger('change', { trackEvent: trackEvent });
      }
    });
  
    // Adds component to polaroid module
    polaroid.VariantSelect = VariantSelect;
  
  
    // Creates jQuery component
    $.fn.variantSelect = function() {
      var opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          ret;
  
      for ( var i = 0; i < this.length; i++ ) {
        if ( this[i].variantSelect ) {
          ret = this[i].variantSelect[opt].apply(this[i].variantSelect, args);
          if (typeof ret != 'undefined') return ret;
        } else {
          this[i].variantSelect = new VariantSelect(this[i], opt);
        }
      }
  
      return this;
    };
  })(
    window.jQuery,
    polaroid.tracking
  );
  
  (function(
    $,
    tracking
  ) {
    var defaults = {
      isOpened: false,
      selectors: {
        close: '[data-popup-close]',
        trigger: '.po-popup__trigger'
      },
      attributes: {
      },
      classes: {
        show: 'po-popup--show'
      },
      tracking: {
      }
    };
  
    var PopUp = function(elem, options) {
      var self = this;
      this.settings = $.extend(true, {}, defaults, options);
  
      this.$popup = $(elem);
      this.$popupTrigger = this.$popup.parents(this.settings.selectors.trigger);
      this.$popupClose = this.$popup.find(this.settings.selectors.close);
  
  
      // Event listeners
      this.$popupTrigger.on('click', function(e) {
        if ( polaroid.state.currentScreenSizeMatches('xs') ) {
          self.toggle();
        }
      });
  
      this.$popupClose.on('click', function(e) {
        e.stopImmediatePropagation();
  
        if ( polaroid.state.currentScreenSizeMatches('xs') ) {
          self.close();
        }
      });
    };
  
    PopUp.prototype = $.extend({}, PopUp.prototype, {
      toggle: function() {
        if ( this.settings.isOpened ) {
          this.close();
        } else {
          this.open();
        }
  
        this.settings.isOpened = !this.settings.isOpened;
      },
  
      open: function() {
        this.$popup.addClass(this.settings.classes.show);
      },
  
      close: function() {
        this.$popup.removeClass(this.settings.classes.show);
      }
    });
  
  
    // Adds component to polaroid module
    polaroid.PopUp = PopUp;
  
  
    // Creates jQuery component
    $.fn.popup = function() {
      var options = arguments[0];
  
      for ( var i = 0; i < this.length; i++ ) {
        if ( this[i].popup ) {
  
        } else {
          this[i].popup = new PopUp(this[i], options);
        }
      }
  
      return this;
    };
  })(
    window.jQuery,
    polaroid.tracking
  );
  
  polaroid.modalVideo = (function() {
    function init() {
      var urlParams;
  
      $('[data-modal-video]').modalVideo(
        {
          youtube: {
            autoplay: 0,
            rel: 0
          },
          onOpen: function() {
            $('video').hide();
            polaroid.state.lockScreen();
          },
          onClose: function() {
            $('video').show();
            polaroid.state.unlockScreen();
          }
        }
      );
  
      try {
        urlParams = new URLSearchParams(window.location.search);
        
        if ( urlParams.has('modal-video') ) {
          $('[data-video-id=' + urlParams.get('modal-video')+ ']').first().click();
        }
      } catch (e) {
  
      }
    }
  
    return {
      init: init
    };
  })();
  

  /*================ Modules ================*/
  /*
    TODO:
    - Add tracking events
    - Add breakpoints
  
  */
  polaroid.carousel = function(carousel) {
    var $carousel = $(carousel);
    var trackingCategory = $carousel.attr('data-carousel-tracking-category') || 'Carousel';
    var lazyload = $carousel[0].hasAttribute('data-carousel-lazyload');
    
    $carousel.flickity({
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 45,
        x3: 20
      },
      cellAlign: 'left',
      cellSelector: '[data-carousel-item]',
      contain: true,
      draggable: Modernizr.touchevents,
      dragThreshold: 10,
      groupCells: true,
      imagesLoaded: true,
      pageDots: true,
      prevNextButtons: !Modernizr.touchevents,
      lazyLoad: lazyload
    });
  
    $carousel.on('change.flickity', function(event, index) {
      polaroid.tracking.general( trackingCategory, 'Scroll' );
    });
  
    // Track product view
    $carousel.find('[data-po-track-view-product]').on('click', function(e) {
      var eventLabel = polaroid.tracking.getProductEventLabel(this);
  
      polaroid.tracking.general( trackingCategory, 'View Product', eventLabel );
    });
  
    return $carousel;
  };
  
  polaroid.carouselsInit = function( index ) {
    $('[data-carousel]').each(function () {
      polaroid.carousel(this);
    });
  };
  
  (function(
    $,
    cartMethods,
    tracking
  ) {
    var defaults = {
      quantity: null,
      variantId: null,
      properties: {},
      selectors: {
        propertiesJson: '[data-product-properties]',
        variantSelect: '[data-variant-select]',
        addToCartButton: '[data-add-to-cart]',
        buyNowButton: '[data-buy-now]',
        seeDetailsLink: '[data-see-details]',
        imageGallery: '[data-image-gallery]',
        quantityAdjust: '[data-quantity-adjust]',
        tierSet: '[data-tier-set]',
        comparePrice: '[data-compare-price-display]',
        price: '[data-price-display]'
      },
      attributes: {
  
      },
      classes: {
  
      },
      tracking: {
        category: 'Product Module'
      }
    };
  
    var ProductStandalone = function(elem, options) {
      var self = this;
      this.settings = $.extend(true, {}, defaults, options);
  
      this.$module = $(elem);
      this.settings.properties = $.extend(true, this.settings.properties, JSON.parse(this.$module.find(this.settings.selectors.propertiesJson).html()));
  
      this.$atcButton = $(this.$module.find(this.settings.selectors.addToCartButton))
        .button(
          {
            onClick: function() {
              self.disableButtons();
              self.addToCart()
                .catch(function(reason) {
                  console.log(reason);
                })
                .finally(function() {
                  self.enableButtons();
                });
            },
            tracking: {}
          }
        );
  
      this.$bnButton = $(this.$module.find(this.settings.selectors.buyNowButton))
        .button(
          {
            loader: true,
            loadingText: 'Going to Checkout...',
            onClick: function() {
              self.disableButtons();
              self.addToCart(true);
            },
            tracking: {
              category: this.settings.tracking.category,
              clickAction: 'Buy Now'
            }
          }
        );
  
      this.$mainButton = !!this.$atcButton.length ? this.$atcButton : this.$bnButton;
      this.$seeDetails = this.$module.find(this.settings.selectors.seeDetailsLink);
  
      this.settings.variantId = this.settings.variantId || this.$module.attr('data-variant-id');
      this.settings.productHandle = this.$module.attr('data-product-handle');
      this.settings.productUrl = '/products/' + this.settings.productHandle;
      this.settings.variantTitle = this.$module.attr('data-variant-title');
  
      this.settings.tracking.category = this.$module.attr('data-event-category') || this.settings.tracking.category;
      this.settings.tracking.label = this.settings.productHandle;
  
      var trackingData = {
        category: this.settings.tracking.category,
        label: this.settings.tracking.label
      };
  
      this.$variantSelect = $(this.$module.find(this.settings.selectors.variantSelect)).variantSelect({
        variantChangedCallback: function(variant) {
          self.updateVariant(variant);
        },
        tracking: trackingData
      });
  
      this.$imageGallery = new polaroid.ImageGallery(this.$module.find(this.settings.selectors.imageGallery), { tracking: trackingData });
  
      this.$quantityAdjust = new polaroid.QuantityAdjust(this.$module.find(this.settings.selectors.quantityAdjust), {
        tracking: trackingData
      });
  
      this.$tierSet = $(this.$module.find(this.settings.selectors.tierSet)).tierSet({
        currentVariantId: this.settings.variantId,
        quantity: this.settings.quantity,
        updateQuantityCallback: function(quantity) {
          var variantUrl = self.settings.productUrl + '?quantity=' + quantity;
          self.$seeDetails.attr('href', variantUrl);
        },
        tracking: {
          category: this.settings.tracking.category,
          label: this.settings.tracking.label
        }
      });
  
      this.$productPrice = new polaroid.Price(this.$module.find(this.settings.selectors.comparePrice), this.$module.find(this.settings.selectors.price));
  
      this._init();
    };
  
    ProductStandalone.prototype = $.extend({}, ProductStandalone.prototype, {
      enableButtons: function() {
        this.$atcButton.button('setState', 'enabled');
        this.$atcButton.button('setText', polaroid.strings.addToCart);
        this.$bnButton.button('setState', 'enabled');
        this.$bnButton.button('setText', polaroid.strings.buyNow);
      },
  
      disableButtons: function(soldOut) {
        this.$atcButton.button('setState', 'disabled');
        this.$bnButton.button('setState', 'disabled');
  
        if (soldOut) {
          this.$mainButton.button('setText', polaroid.strings.soldOut);
        }
      },
  
      addToCart: function( goToCheckout ) {
        polaroid.goToCheckout = goToCheckout;
        var quantity = 1;
  
        if ( this.settings.properties._tier_set ) {
          quantity = this.$tierSet.tierSet('getQuantity');
        } else {
          quantity = this.$quantityAdjust.settings.quantity;
        }
  
        return cartMethods.addToCart(
            this.settings.variantId,
            quantity,
            this.settings.properties,
            {
              tracking: {
                category: this.settings.tracking.category,
                label: this.getEventLabel()
              }
            }
          );
      },
  
      updateVariant: function( variant ) {
        var variantUrl = this.settings.productUrl + '?variant=' + variant.id;
        this.settings.variantId = variant.id;
        this.settings.variantTitle = variant.title;
  
        this.$imageGallery.updateImage(variant.imageIndex, true, true);
        this.$seeDetails.attr('href', variantUrl);
  
        if ( variant.available ) {
          this.enableButtons();
        } else {
          this.disableButtons(true);
        }
  
        if ( this.$tierSet.length ) {
          this.$tierSet.tierSet('updateCurrentVariantId', variant.id);
          this.$tierSet.tierSet('updatePrice');
        } else {
          this.$productPrice.updatePrice({
            comparePrice: variant.comparePrice,
            price: variant.price
          });
        }
      },
  
      getEventLabel: function() {
        var eventLabel = this.settings.productHandle;
  
        if ( this.variantTitle ) {
          eventLabel += '|' + this.settings.variantTitle;
        }
  
        return eventLabel;
      },
  
      _init: function() {
        this.$variantSelect.variantSelect('updateVariantById', this.settings.variantId, false);
      }
    });
  
    // Adds module to polaroid object
    polaroid.ProductStandalone = ProductStandalone;
  
    // Adds module to jQuery
    $.fn.productStandalone = function() {
      var options = arguments[0];
  
      for ( var i = 0; i < this.length; i++ ) {
        if ( this[i].productStandalone ) {
  
        } else {
          this[i].productStandalone = new ProductStandalone(this[i], options);
        }
      }
  
      return this;
    };
  })(
    window.jQuery,
    polaroid.cartMethods,
    polaroid.tracking
  );
  
  (function(
    $,
    cartMethods,
    tracking,
    images
  ) {
    var defaults = {
      variantId: null,
      selectors: {
        variantSelects: '[data-variant-select]',
        addToCartButton: '[data-add-to-cart]',
        buyNowButton: '[data-buy-now]',
        productImages: '[data-product-image]',
        imageGallery: '[data-image-gallery]',
        quantityAdjust: '[data-quantity-adjust]',
        comparePrice: '[data-bundle-compare-price]',
        price: '[data-bundle-price]',
        bundleJson: '[data-bundle-json]',
        productList: '[data-product-list]',
        upsellContainer: '[data-upsell-container]',
        upsellHeader: '[data-upsell-header]',
        upsellList: '[data-upsell-list]',
        upsellComponentToggle: '[data-upsell-component-toggle]',
        bisSubscription: '[data-bis-subscription]'
      },
      attributes: {
  
      },
      classes: {
  
      },
      tracking: {
        category: 'Bundle Module',
        toggleUpsellAction: 'Toggle Upsells',
        addUpsellAction: 'Add Upsell',
        removeUpsellAction: 'Remove Upsell'
      }
    };
  
    var BundleStandalone = function(elem, options) {
      var self = this;
      this.settings = $.extend(true, {}, defaults, options);
  
      this.$module = $(elem);
  
      this.$variantSelects = $(this.$module.find(this.settings.selectors.variantSelects)).variantSelect({
        variantChangedCallback: function(variant) {
          self.updateVariant(variant);
        },
        tracking: {
          category: this.settings.tracking.category
        }
      });
  
      this.$atcButton = $(this.$module.find(this.settings.selectors.addToCartButton))
        .button(
          {
            onClick: function() {
              self.disableButtons();
              self.addBundleToCart();
            },
            tracking: {}
          }
        );
  
      this.$bnButton = $(this.$module.find(this.settings.selectors.buyNowButton))
        .button(
          {
            loader: true,
            loadingText: 'Going to Checkout...',
            onClick: function() {
              self.disableButtons();
              self.addBundleToCart(true);
            },
            tracking: {
              category: this.settings.tracking.category,
              clickAction: 'Buy Now'
            }
          }
        );
  
      this.$mainButton = this.$atcButton.length ? this.$atcButton : this.$bnButton;
      this.$productImages = this.$module.find(this.settings.selectors.productImages);
  
      this.$productList = this.$module.find(this.settings.selectors.productList);
      this.$upsellContainer = this.$module.find(this.settings.selectors.upsellContainer);
      this.$upsellHeader = this.$module.find(this.settings.selectors.upsellHeader);
      this.$upsellList = this.$module.find(this.settings.selectors.upsellList);
      this.$upsellComponentToggle = this.$module.find(this.settings.selectors.upsellComponentToggle);
  
      this.bundle = new polaroid.BundleController(JSON.parse(this.$module.find(this.settings.selectors.bundleJson).html()));
  
      this.quantityAdjust = new polaroid.QuantityAdjust(this.$module.find(this.settings.selectors.quantityAdjust), {
        tracking: {
          category: this.settings.tracking.category
        }
      });
  
      this.bundlePrice = new polaroid.Price(
        this.$module.find(this.settings.selectors.comparePrice),
        this.$module.find(this.settings.selectors.price)
      );
  
      this.$imageGallery = this.$module.find(this.settings.selectors.imageGallery);
      $(this.$imageGallery).imageGallery({
        tracking: {
          category: this.settings.tracking.category
        }
      });
  
      this.bisSubscription = new polaroid.BisSubscription(this.$module.find(this.settings.selectors.bisSubscription), {
        tracking: {
          category: this.settings.tracking.category
        }
      });
  
  
      // Event Listeners
  
      this.$upsellHeader.on('click', this.toggleUpsell.bind(this));
  
      this.$upsellComponentToggle.on('click', function(e) {
        e.preventDefault();
        self.toggleProduct(this);
      });
  
      this.init();
    };
  
    BundleStandalone.prototype = $.extend({}, BundleStandalone.prototype, {
      init: function() {
        if ( !this.bundle.getAvailability() && this.$bnButton !== this.$mainButton ) {
          this.$bnButton.hide();
        }
  
        this.bisSubscription.updateUnavailableVariants(this.bundle.getUnavailableVariants());
      },
  
      updateVariant: function(variant) {
        var productHandle = variant.productHandle;
        var productImage;
  
        var variantIndex = _.findIndex(this.bundle.getVariants(), function(variant) {
          return variant.handle === productHandle;
        });
  
        var variantImgUrl = slate.Image.getSizedImageUrl(variant.image, '75x75@2x');
  
  
        this.$productImages.each(function(index, elem) {
          if ( elem.getAttribute('data-product-handle') === productHandle ) {
            productImage = elem;
          }
        });
  
        images.replaceImage(productImage, variantImgUrl);
  
        if ( variant.available ) {
          $(productImage).removeClass('bundle-contents__image--unavailable');
        } else {
          $(productImage).addClass('bundle-contents__image--unavailable');
        }
  
        if ( variantIndex > -1 ) {
          this.bundle
            .updateVariant(
              variantIndex,
              variant.id,
              variant.price,
              variant.comparePrice,
              variant.image,
              variant.available
            );
  
          if ( this.bundle.getAvailability() ) {
            this.enableButtons();
          } else {
            this.disableButtons( true );
          }
  
          this.bisSubscription.updateUnavailableVariants(this.bundle.getUnavailableVariants());
  
          this.bundlePrice.updatePrice(this.bundle.getPrice());
        }
      },
  
      addBundleToCart: function( goToCheckout ) {
        var enableButtons = this.enableButtons.bind(this);
  
        this.bundle
          .updateAmount(this.quantityAdjust.getQuantity())
          .addBundleToCart( goToCheckout )
          .then(function(data) {
  
          })
          .catch(function(error) {
            location.reload();
          })
          .finally(function() {
            if ( !goToCheckout ) {
              enableButtons();
            }
          });
      },
  
      toggleProduct: function(elem) {
        var $this = $(elem);
        var $upsellComponent = $this.parents('.bundle-contents__product');
        var $variantSelect = $upsellComponent.find(this.settings.selectors.variantSelects);
        var productHandle;
        var trackingAction;
        var variant;
  
        if ( !elem.hasAttribute('data-component-added') ) {
          if ( !!$variantSelect.length ) {
            variant = $variantSelect.variantSelect('getSelectedVariant');
            variant.handle = variant.productHandle;
            variant.quantity = 1;
          } else {
            variant = {
              name: $this.attr('data-po-product-name'),
              id: parseInt($this.attr('data-po-variant-id')),
              handle: $this.attr('data-po-product-handle'),
              comparePrice: parseInt($this.attr('data-po-variant-compare-price')),
              price: parseInt($this.attr('data-po-variant-price')),
              quantity: parseInt($this.attr('data-po-variant-quantity')),
              image: $this.attr('data-po-variant-image'),
              available: true
            };
          }
  
          productHandle = variant.handle;
          trackingAction = this.settings.tracking.addUpsellAction;
  
          this.bundle.addVariant(variant);
          elem.setAttribute('data-component-added', '');
          this.$productList.append($upsellComponent);
  
          if ( !this.$upsellList.children().length ) {
            this.$upsellContainer.hide();
          }
        } else {
          productHandle = $this.attr('data-po-product-handle');
          trackingAction = this.settings.tracking.removeUpsellAction;
  
          this.bundle.removeVariant(productHandle);
          elem.removeAttribute('data-component-added');
          this.$upsellList.append($upsellComponent);
          this.$upsellContainer.show();
        }
  
        this.bundlePrice.updatePrice(this.bundle.getPrice());
  
        tracking.general(
          this.settings.tracking.category,
          trackingAction,
          productHandle
        );
      },
  
      enableButtons: function() {
        this.$atcButton.button('setState', 'enabled');
        this.$bnButton
          .button('setState', 'enabled')
          .show();
      },
  
      disableButtons: function(soldOut) {
        this.$atcButton.button('setState', 'disabled');
        this.$bnButton.button('setState', 'disabled');
  
        if (soldOut) {
          this.$bnButton.hide();
          this.$mainButton
            .button('setText', polaroid.strings.soldOut)
            .show();
        }
      },
  
      toggleUpsell: function() {
        this.$upsellHeader.toggleClass('bundle-contents__upsells-header--collapsed');
        images.imgSources.setImages();
        images.imgSources.loadImages();
  
        tracking.general(
          this.settings.tracking.category,
          this.settings.tracking.toggleUpsellAction
        );
      }
    });
  
    // Adds module to polaroid object
    polaroid.BundleStandalone = BundleStandalone;
  
    // Adds module to jQuery
    $.fn.bundleStandalone = function() {
      var options = arguments[0];
  
      for ( var i = 0; i < this.length; i++ ) {
        if ( this[i].bundleStandalone ) {
  
        } else {
          this[i].bundleStandalone = new BundleStandalone(this[i], options);
        }
      }
  
      return this;
    };
  })(
    window.jQuery,
    polaroid.cartMethods,
    polaroid.tracking,
    polaroid.images
  );
  
  polaroid.newsletter = polaroid.newsletter || {};
  
  polaroid.newsletter.init = function() {
    $('.js-newsletter-signup').on('submit', function(e){
      e.preventDefault();
  
      var mailchimpUrl = 'http://polaroid-originals.us5.list-manage1.com/subscribe?u=5025d3a98d9a97240d347e846&id=b72ae6d516';
      var email = encodeURIComponent($(this).find('[name="MERGE0"]')[0].value);
  
      var win =
      window.open(mailchimpUrl + '&MERGE0=' + email, '_blank');
      win.focus();
      document.getElementById('MERGE0').value = '';
    });
  };
  
  (function(
    $
  ) {
    var defaults = {
      scrollTop: {
        xs: 0,
        sm: 0,
        md: 0,
        lg: 0,
        xl: 0
      },
      selectors: {
  
      },
      attributes: {
        distanceXs: 'data-scroll-banner-distance-xs',
        distanceSm: 'data-scroll-banner-distance-sm',
        distanceMd: 'data-scroll-banner-distance-desktop',
        distanceLg: 'data-scroll-banner-distance-desktop',
        distanceXl: 'data-scroll-banner-distance-desktop',
      },
      classes: {
        stuck: 'scroll-banner--stuck'
      }
    };
  
    var ScrollBanner = function(elem, options) {
      var self = this;
      this.settings = $.extend(true, {}, defaults, options);
  
      this.$banner = $(elem);
  
      this.settings.scrollTop = {
        xs: parseInt(this.$banner.attr(this.settings.attributes.distanceXs)),
        sm: parseInt(this.$banner.attr(this.settings.attributes.distanceSm)),
        md: parseInt(this.$banner.attr(this.settings.attributes.distanceMd)),
        lg: parseInt(this.$banner.attr(this.settings.attributes.distanceLg)),
        xl: parseInt(this.$banner.attr(this.settings.attributes.distanceXl))
      };
  
      $(window).on('po.scroll-down', function(e, data) {
        self.updateBanner( 'down', data, self.settings.scrollTop[polaroid.state.getState().currentScreenSize] );
      });
  
      $(window).on('po.scroll-up', function(e, data) {
        self.updateBanner( 'up', data, self.settings.scrollTop[polaroid.state.getState().currentScreenSize] );
      });
    };
  
    ScrollBanner.prototype = $.extend({}, ScrollBanner.prototype, {
      updateBanner: function( direction, data, distanceFromTop ) {
        if ( direction === 'down' && data.scrollTop > distanceFromTop ) {
          this.$banner.addClass(this.settings.classes.stuck);
        } else if ( direction === 'up' && data.scrollTop < distanceFromTop ) {
          this.$banner.removeClass(this.settings.classes.stuck);
        }
      }
    });
  
    $.fn.scrollBanner = function() {
      var options = arguments[0];
  
      for ( var i = 0; i < this.length; i++ ) {
        if ( this[i].scrollBanner ) {
  
        } else {
          this[i].scrollBanner = new ScrollBanner(this[i], options);
        }
      }
  
      return this;
    };
  })(
    window.jQuery
  );
  
  polaroid.oneStepFeatures = (function() {
    function init() {
      var $featuresBlock = $('.onestep-plus-features');
  
      if ( $featuresBlock.length ) {
        var $window = $(window);
        var $featuresSmContainer = $('.onestep-plus-features--mobile ul');
        var $featuresContainer = $('.onestep-plus-features__container');
        var $featuresNavItems = $('.onestep-plus-features__header');
        var $featuresBodyItems = $('.onestep-plus-features__body');
        var isAlternate = !!$featuresBlock.attr('data-features-alternate');
  
        $featuresNavItems.on('click', function() {
          var navIndex = $(this).attr('data-feature-index') - 1;
          var $featuresNav = $($featuresNavItems[navIndex]);
          var $featuresBody = $($featuresBodyItems[navIndex]);
  
  
          if ( $featuresNav.hasClass('onestep-plus-features__header--active')) {
            $featuresNav.removeClass('onestep-plus-features__header--active');
            $featuresBody.removeClass('onestep-plus-features__body--show');
  
          } else {
            var $container = $($featuresContainer[navIndex]);
            var headerHeight = 0;
  
            $featuresBodyItems.removeClass('onestep-plus-features__body--show');
            $featuresNavItems.removeClass('onestep-plus-features__header--active');
            $featuresBody.addClass('onestep-plus-features__body--show');
            $featuresNav.addClass('onestep-plus-features__header--active');
  
            window.setTimeout( function() {
              if ( $('#SiteHeader').length > 0 ) {
                headerHeight = $(window).scrollTop() < $featuresNav.offset().top ? 0 : 60;
              } else {
                headerHeight = 80;
              }
  
              $([document.documentElement, document.body]).animate({
                scrollTop: $container.offset().top - headerHeight
              }, 250);
            }, 200);
          }
  
          if ( isAlternate ) {
            // Tracks interaction with personas
            var label = $(this).attr('data-po-track-label');
            polaroid.tracking.general('Tab Block', 'Select', label);
          }
        });
  
        var $featuresFeature = $('.onestep-plus-features__feature');
        var $featuresContent = $('.onestep-plus-features__content');
        var currentItemIndex = 1;
  
        $featuresFeature.on('mouseenter', function() {
          $featuresContent
            .removeClass('onestep-plus-features__content--show');
  
          $($featuresContent[$(this).attr('data-feature-index') - 1]).addClass('onestep-plus-features__content--show');
  
          $featuresContent
            .removeClass('onestep-plus-features__background--' + currentItemIndex)
            .addClass('onestep-plus-features__background--' + ($(this).attr('data-feature-index')));
  
  
          currentItemIndex = $(this).attr('data-feature-index');
        });
      }
    }
  
    return {
      init: init
    };
  })();
  
  (function(
    $
  ){
    var defaults = {
      selectors: {
        header: '.feature-comparison__header',
        headerContent: '.feature-comparison__header-content',
        features: '.feature-comparison__features',
        galleryDesktop: '[data-feature-comparison-gallery-desktop]',
        galleryMobile: '[data-feature-comparison-gallery-mobile]'
      },
      attributes: {
      },
      classes: {
      },
      tracking: {
        category: 'Feature Comparison'
      }
    };
  
    var FeatureComparison = function(elem, options) {
      var self = this;
      this.settings = $.extend(true, {}, defaults, options);
  
      this.$featureComparison = $(elem);
      this.$header = this.$featureComparison.find('.feature-comparison__header');
      this.$headerContent = this.$featureComparison.find('.feature-comparison__header-content');
      this.$features = this.$featureComparison.find('.feature-comparison__features');
      this.$gallery = polaroid.state.currentScreenSizeMatches(['xs','sm'])
                      ? this.$featureComparison.find(this.settings.selectors.galleryMobile)
                      : this.$featureComparison.find(this.settings.selectors.galleryDesktop);
  
      $(this.$gallery).imageGallery({
        showPageDots: true,
        tracking: {
          category: this.settings.tracking.category
        }
      });
  
      // Event listeners
      $(window).on('po.scroll-down', function(e, data) {
        self.updateHeader( 'down', data );
      });
  
      $(window).on('po.scroll-up', function(e, data) {
        self.updateHeader( 'up', data );
      });
    };
  
    FeatureComparison.prototype = $.extend({}, FeatureComparison.prototype, {
      updateHeader: function( direction, data ) {
        var distanceTop = this.$header.offset().top;
        var distanceBottom = this.$features.offset().top + this.$features.height();
        var headerContentHeight = this.$headerContent.height();
  
        this.$header.css({ height: headerContentHeight });
  
        if ( direction === 'down' ) {
          if ( data.scrollTop > distanceBottom - headerContentHeight && this.$headerContent.hasClass('feature-comparison__header-content--stuck') ) {
            this.$headerContent.addClass('feature-comparison__header-content--hide');
          } else if ( data.scrollTop > distanceTop && data.scrollTop < distanceBottom - headerContentHeight ) {
            this.$headerContent.addClass('feature-comparison__header-content--stuck');
          }
        } else if ( direction === 'up' ) {
          if ( data.scrollTop < distanceBottom - headerContentHeight && data.scrollTop > distanceTop ) {
            this.$headerContent
              .addClass('feature-comparison__header-content--stuck')
              .removeClass('feature-comparison__header-content--hide');
          } else {
            this.$headerContent.removeClass('feature-comparison__header-content--stuck');
          }
        }
      }
    });
  
    // Adds component to polaroid module
    polaroid.FeatureComparison = FeatureComparison;
  
  
    // Creates jQuery component
    $.fn.featureComparison = function() {
      var opt = arguments[0];
  
      for ( var i = 0; i < this.length; i++ ) {
        if ( this[i].featureComparison ) {
  
        } else {
          this[i].featureComparison = new FeatureComparison(this[i], opt);
        }
      }
  
      return this;
    };
  })(
    window.jQuery
  );
  
  (function(
    $,
    images,
    tracking
  ) {
    var defaults = {
      expanded: false,
      imagesLoaded: false,
      collectionHandle: null,
      selectors: {
        header: '[data-collection-tease-header]',
        title: '[data-collection-tease-title]',
        collectionLink: '[data-collection-tease-link]'
      },
      attributes: {
        collectionHandle: 'data-collection-tease-collection-handle'
      },
      classes: {
        headerCollapsed: 'collection-tease__header--collapsed'
      },
      tracking: {
        category: 'Collection Tease',
        expandAction: 'Expand',
        collapseAction: 'Collapse',
        viewCollectionAction: 'View Collection'
      }
    };
  
    var CollectionTease = function(elem, options) {
      var self = this;
  
      this.settings = $.extend(true, {}, defaults, options);
  
      this.$module = $(elem);
      this.$header = this.$module.find(this.settings.selectors.header);
      this.$collectionLink = this.$module.find(this.settings.selectors.collectionLink);
  
      this.settings.collectionHandle = this.settings.collectionHandle || this.$module.attr(this.settings.attributes.collectionHandle);
  
  
      // Event listeners
  
      this.$header.on('click', function() {
        self.toggleExpand();
      });
  
      this.$collectionLink.on('click', function(e) {
        tracking.general(
          self.settings.tracking.category,
          self.settings.tracking.viewCollectionAction,
          self.settings.collectionHandle
        );
      });
    };
  
    CollectionTease.prototype = $.extend({}, CollectionTease.prototype, {
      toggleExpand: function() {
        if ( !polaroid.state.currentScreenSizeMatches(['xs', 'sm']) ) return;
  
        if ( this.settings.expanded ) {
          this.settings.expanded = false;
          this.$header.addClass(this.settings.classes.headerCollapsed);
  
          tracking.general(
            this.settings.tracking.category,
            this.settings.tracking.collapseAction,
            this.settings.tracking.label
          );
        } else {
          this.settings.expanded = true;
          this.$header.removeClass(this.settings.classes.headerCollapsed);
          this.scrollTo();
  
          tracking.general(
            this.settings.tracking.category,
            this.settings.tracking.expandAction,
            this.settings.tracking.label
          );
        }
  
        if ( this.settings.expanded && !this.settings.imagesLoaded ) {
          this.loadImages();
        }
      },
  
      loadImages: function() {
        images.imgSources.setImages();
        images.imgSources.loadImages();
        this.settings.imagesLoaded = true;
      },
  
      scrollTo: function() {
        var headerHeight;
  
        if ( $('#SiteHeader').length > 0 ) {
          headerHeight = $(window).scrollTop() < this.$module.offset().top ? 0 : 60;
        } else {
          headerHeight = 80;
        }
  
        $([document.documentElement, document.body]).animate({
          scrollTop: this.$module.offset().top - headerHeight
        }, 250);
      }
    });
  
  
    // Adds component to jQuery
    $.fn.collectionTease = function() {
      var options = arguments[0];
  
      for ( var i = 0; i < this.length; i++ ) {
        if ( this[i].collectionTease ) {
  
        } else {
          this[i].collectionTease = new CollectionTease(this[i], options);
        }
      }
  
      return this;
    };
  })(
    window.jQuery,
    polaroid.images,
    polaroid.tracking
  );
  
  (function(
    $,
    tracking,
    helpers
  ) {
    var defaults = {
      unavailableVariants: [],
      selectors: {
        bisForm: '[data-bis-form]',
        bisMessage: '[data-bis-message]'
      },
      attributes: {
      },
      classes: {
      },
      tracking: {
        category: 'BIS Form',
        subscribeBISAction: 'Subscribe BIS'
      }
    };
  
    var BisSubscription = function(elem, options) {
      var self = this;
      this.settings = $.extend(true, {}, defaults, options);
  
      this.$module = $(elem);
      this.$bisForm = this.$module.find(this.settings.selectors.bisForm);
      this.$bisMessage = this.$module.find(this.settings.selectors.bisMessage);
  
  
      // Event listeners
      this.$bisForm.on('submit', function(e) {
        e.preventDefault();
  
        self.submitForm(this);
      });
    };
  
    BisSubscription.prototype = $.extend({}, BisSubscription.prototype, {
      updateUnavailableVariants: function(newUnavailableVariants) {
        this.settings.unavailableVariants = newUnavailableVariants;
  
        if ( !!this.settings.unavailableVariants.length ) {
          this.showForm();
        } else {
          this.hideForm();
        }
      },
  
      showForm: function() {
        this.$bisForm.show();
        this.$bisMessage.hide();
      },
  
      hideForm: function(showMessage) {
        this.$bisForm.hide();
  
        if (showMessage) {
          this.$bisMessage.show();
        } else {
          this.$bisMessage.hide();
        }
      },
  
      submitForm: function(form) {
        var formData = helpers.getFormData(form);
  
        for ( var i = 0; i < this.settings.unavailableVariants.length; i++ ) {
          try {
            BIS.create(formData.email, this.settings.unavailableVariants[i].id, this.settings.unavailableVariants[i].productId);
          } catch(e) {
            console.log(e);
          }
        }
  
        tracking.general(
          this.settings.tracking.category,
          this.settings.tracking.subscribeBISAction
        );
  
        this.hideForm(true);
      }
    });
  
  
    // Adds component to polaroid module
    polaroid.BisSubscription = BisSubscription;
  
  
    // Creates jQuery component
    $.fn.bisSubscription = function() {
      var options = arguments[0];
  
      for ( var i = 0; i < this.length; i++ ) {
        if ( this[i].bisSubscription ) {
  
        } else {
          this[i].bisSubscription = new BisSubscription(this[i], options);
        }
      }
  
      return this;
    };
  })(
    window.jQuery,
    polaroid.tracking,
    polaroid.helpers
  );
  
  (function(
    $,
    tracking
  ) {
    var defaults = {
      selectors: {
        headers: '[data-accordion-header]',
        content: '[data-accordion-content]'
      },
      attributes: {
        accordionTarget: 'data-accordion-target'
      },
      classes: {
        headerActive: 'po-accordion__header--active',
        contentCollapsed: 'po-accordion__content--collapsed'
      },
      tracking: {
        category: 'Accordion',
        expandItemAction: 'Expand Item'
      }
    };
  
    var Accordion = function(elem, options) {
      var self = this;
      this.settings = $.extend(true, {}, defaults, options);
  
      this.$accordion = $(elem);
      this.$accordionHeaders = this.$accordion.find(this.settings.selectors.headers);
      this.$accordionContent = this.$accordion.find(this.settings.selectors.content);
  
      // Event listeners
      this.$accordionHeaders.on('click', function() {
        self.toggleHeader($(this));
      });
    };
  
    Accordion.prototype = $.extend({}, Accordion.prototype, {
      toggleHeader: function($header) {
        var headerActive = $header.hasClass(this.settings.classes.headerActive);
  
        this.$accordionHeaders.removeClass(this.settings.classes.headerActive);
        this.$accordionContent.addClass(this.settings.classes.contentCollapsed);
  
        if ( !headerActive ) {
          $header.addClass(this.settings.classes.headerActive);
          $($header.attr(this.settings.attributes.accordionTarget)).removeClass(this.settings.classes.contentCollapsed);
  
          tracking.general(
            this.settings.tracking.category,
            this.settings.tracking.expandItemAction
          );
        }
      }
    });
  
  
    // Adds component to polaroid module
    polaroid.Accordion = Accordion;
  
  
    // Creates jQuery component
    $.fn.accordion = function() {
      var options = arguments[0];
  
      for ( var i = 0; i < this.length; i++ ) {
        if ( this[i].accordion ) {
  
        } else {
          this[i].accordion = new Accordion(this[i], options);
        }
      }
  
      return this;
    };
  })(
    window.jQuery,
    polaroid.tracking
  );
  
  // TODO:
  // Add tracking events
  
  (function(
    $,
    tracking
  ) {
    var defaults = {
      navList: [],
      state: 'static',
      selectors: {
        navSticky: '.page-nav__sticky',
        header: '.page-nav__header',
        headerCurrent: '.page-nav__header-current',
        list: '.page-nav__item-list',
        navItem: '.page-nav__item'
      },
      attributes: {
        scrollTo: 'data-page-nav-scroll-to'
      },
      classes: {
        belowHeader: 'page-nav__sticky--below-header',
        stuck: 'page-nav__sticky--stuck',
        showList: 'page-nav__sticky--show-list',
        itemActive: 'page-nav__item--active'
      },
      tracking: {
        category: 'Navigation',
        scrollToAction: 'Scroll To',
        toggleListAction: 'Toggle List'
      }
    };
  
    var PageNav = function(elem, options) {
      var self = this;
      this.settings = $.extend(true, {}, defaults, options);
  
      this.$pageNav = $(elem);
      this.$pageNavSticky = this.$pageNav.find(this.settings.selectors.navSticky);
      this.$header = this.$pageNav.find(this.settings.selectors.header);
      this.$headerCurrent = this.$pageNav.find(this.settings.selectors.headerCurrent);
      this.$list = this.$pageNav.find(this.settings.selectors.list);
      this.$navItem = this.$pageNav.find(this.settings.selectors.navItem);
  
      this.settings.siteHeaderSize = polaroid.state.currentScreenSizeMatches(['xs','sm']) ? 60 : 72;
      this.settings.distanceFromTop = this.$pageNav.offset().top;
  
      this.$navItem.each(function(i, elem) {
        var $elem = $(elem);
  
        var item = {
          $elem: $elem,
          distanceFromTop: $(elem.getAttribute('data-page-nav-scroll-to')).offset().top
        };
  
        self.settings.navList.push(item);
      });
  
      this.settings.navList.reverse();
  
      // Event listeners
      this.$header.on('click', function(e) {
        e.preventDefault();
  
        self.toggleList();
      });
  
      this.$navItem.on('click', function(e) {
        e.preventDefault();
  
        self.hideList();
        self.scrollTo(this.getAttribute('data-page-nav-scroll-to'));
        tracking.general(
          self.settings.tracking.category,
          self.settings.tracking.scrollToAction,
          this.getAttribute('data-page-nav-item-title')
        );
      });
  
      $(window).on('po.scroll-down', function(e, data) {
        if ( data.scrollTop > self.settings.distanceFromTop ) {
          if ( self.settings.state !== 'stuck' ) {
            self.setState('stuck');
          }
        }
  
        self.updateNav(data.scrollTop);
      });
  
      $(window).on('po.scroll-up', function(e, data) {
        if ( data.scrollTop + self.settings.siteHeaderSize < self.settings.distanceFromTop ) {
          self.setState('static');
        } else if ( self.settings.state === 'stuck' ) {
          self.setState('below-header');
        }
  
        self.updateNav(data.scrollTop);
      });
    };
  
    PageNav.prototype = $.extend({}, PageNav.prototype, {
      updateNav: function(scrollTop) {
        for ( var i = 0; i < this.settings.navList.length; i++ ) {
          if ( scrollTop >= this.settings.navList[i].distanceFromTop - 140 ) {
            this.updateHeader(this.settings.navList[i].$elem);
            break;
          }
        }
      },
  
      updateHeader: function($elem) {
        this.$navItem.removeClass(this.settings.classes.itemActive);
        $elem.addClass(this.settings.classes.itemActive);
  
        this.$headerCurrent
          .empty()
          .append($elem.contents().clone().off());
      },
  
      setState: function(newState) {
        switch(newState) {
          case 'below-header':
            this.$pageNavSticky
              .addClass(this.settings.classes.stuck)
              .addClass(this.settings.classes.belowHeader);
            break;
          case 'stuck':
            this.$pageNavSticky
              .removeClass(this.settings.classes.belowHeader)
              .addClass(this.settings.classes.stuck);
            break;
          case 'static':
            this.$pageNavSticky
              .removeClass(this.settings.classes.stuck)
              .removeClass(this.settings.classes.belowHeader);
            break;
        }
  
        this.settings.state = newState;
      },
  
      showList: function() {
        this.$pageNavSticky.addClass(this.settings.classes.showList);
      },
  
      hideList: function() {
        this.$pageNavSticky.removeClass(this.settings.classes.showList);
      },
  
      toggleList: function() {
        this.$pageNavSticky.toggleClass(this.settings.classes.showList);
  
        tracking.general(
          this.settings.tracking.category,
          this.settings.tracking.toggleListAction
        );
      },
  
      scrollTo: function(elem) {
        var windowScrollTop = $(window).scrollTop();
        var elemScrollTop = $(elem).offset().top;
        var scrollOffset = polaroid.state.currentScreenSizeMatches(['xs','sm']) ? 60 : 72;
  
        if ( windowScrollTop > elemScrollTop || !polaroid.state.currentScreenSizeMatches(['xs','sm']) ) {
          elemScrollTop -= scrollOffset;
        }
  
        $([document.documentElement, document.body]).animate({
          scrollTop: elemScrollTop
        }, this.settings.scrollSpeed);
  
        window.setTimeout(function() {
          $(window).trigger('po.smooth-scroll-finished');
        }, this.settings.scrollSpeed + 50);
      }
    });
  
  
    // Adds component to polaroid module
    polaroid.PageNav = PageNav;
  
  
    // Creates jQuery component
    $.fn.pageNav = function() {
      var options = arguments[0];
  
      for ( var i = 0; i < this.length; i++ ) {
        if ( this[i].pageNav ) {
  
        } else {
          this[i].pageNav = new PageNav(this[i], options);
        }
      }
  
      return this;
    };
  })(
    window.jQuery,
    polaroid.tracking
  );
  

  /*================ UI ================*/
  polaroid.header = (function() {
    var animateHeight = 40;
    var subNavHeight = 96;
    var $topBanner, headerHeight, $mainHeader,
        $siteHeader, $subNav,
        topBannerHeight, $headerSearchInput,
        $toggleMenu, $toggleCart,
        $toggleAccount, $toggleSearch,
        totalHeaderHeight, $upsellOverlay,
        $panelCart, $panelAccount,
        $panelSearch, $panelMenu,
        $mobileMenu, $accountButton;
  
    function init() {
      $mainHeader = $('#SiteHeader');
      $siteHeader = $mainHeader.find('.site-header');
      $topBanner = $('#TopBanner');
      headerHeight = polaroid.state.currentScreenSizeMatches(['xs','sm']) ? 60 : 72;
      $subNav = $('.sticky-nav');
      topBannerHeight = $topBanner.outerHeight(true) || 0;
      $headerSearchInput = $('#HeaderSearchInput');
      totalHeaderHeight = headerHeight + topBannerHeight;
      $upsellOverlay = $mainHeader.find('.upsell-overlay');
  
      $toggleSearch = $mainHeader.find('.toggle-search');
      $toggleAccount = $mainHeader.find('.toggle-account');
      $toggleCart = $mainHeader.find('.toggle-cart');
      $toggleMenu = $mainHeader.find('.toggle-menu');
  
      $panelCart = $mainHeader.find('#NavPanelCart');
      $panelAccount = $mainHeader.find('#NavPanelAccount');
      $panelSearch = $mainHeader.find('#NavPanelSearch');
      $panelMenu = $mainHeader.find('#NavPanelMenu');
      $mobileMenu = $mainHeader.find('.site-menu');
  
      $accountButton = $mainHeader.find('.show-account-page');
  
      _initEventListeners();
    }
  
    function stickTop() {
      $siteHeader.addClass('site-header--stuck');
      $siteHeader.css({'top': _getTopBannerVisibleHeight() });
    }
  
    function unstickTop() {
      $siteHeader.removeClass('site-header--stuck');
    }
  
    function toggleMenu() {
      if ( !$('html').hasClass('menu-open') ) {
        showMenu();
      } else {
        hideMenu();
      }
    }
  
    function showMenu() {
      hideAll('menu');
  
      setRelatedValues();
      if ( polaroid.state.currentScreenSizeMatches('xs') ) {
        $mobileMenu.css({'top': headerHeight + _getTopBannerVisibleHeight() });
      }
      $panelMenu.addClass('site-header__panel--show');
      $('html').addClass('menu-open');
      polaroid.state.lockScreen();
      setRelatedValues();
    }
  
    function hideMenu() {
      $('html').removeClass('menu-open');
      polaroid.state.unlockScreen();
      $panelMenu.removeClass('site-header__panel--show');
    }
  
    function toggleSearch() {
      if ( !$('html').hasClass('search-open') ) {
        showSearch();
      } else {
        hideSearch();
      }
    }
  
    function showSearch() {
      hideAll('search');
  
      setRelatedValues();
      if ( polaroid.state.currentScreenSizeMatches('xs') ) { // Shows header when hiding
        $siteHeader.addClass('stuck');
      }
      $toggleSearch.addClass('site-header__icon--active');
      $panelSearch.addClass('site-header__panel--show');
      $('html').addClass('search-open');
      polaroid.state.lockScreen();
      setRelatedValues();
    }
  
    function hideSearch() {
      $('html').removeClass('search-open');
      polaroid.state.unlockScreen();
      $toggleSearch.removeClass('site-header__icon--active');
      $panelSearch.removeClass('site-header__panel--show');
    }
  
    function toggleAccount() {
      if ( !$('html').hasClass('account-open') ) {
        showAccount(true);
      } else {
        hideAccount(true);
      }
    }
  
    function showAccount() {
      hideAll('account');
  
      setRelatedValues();
      $toggleAccount.addClass('site-header__icon--active');
      $panelAccount.addClass('site-header__panel--show');
      $('html').addClass('account-open');
      polaroid.state.lockScreen();
      setRelatedValues();
    }
  
    function hideAccount() {
      $('html').removeClass('account-open');
      polaroid.state.unlockScreen();
      $toggleAccount.removeClass('site-header__icon--active');
      $panelAccount.removeClass('site-header__panel--show');
  
      $('#HeaderAccountPageLoggedOut').show();
      $('#HeaderAccountPageRecover').hide();
      $('#HeaderAccountPageLogin').hide();
    }
  
    function toggleCart() {
      if ( !$('html').hasClass('cart-open') ) {
        showCart(true);
      } else {
        hideCart(true);
      }
    }
  
    function showCart(trackEvent) {
      hideAll('cart');
  
      setRelatedValues();
      $toggleCart.addClass('site-header__icon--active');
      $panelCart.addClass('site-header__panel--show');
      $('html').addClass('cart-open');
      setRelatedValues();
  
      polaroid.state.lockScreen();
      polaroid.upsell.checkForUpsell();
  
      if ( trackEvent ) {
        polaroid.tracking.general('Cart', 'Open Overlay');
      }
    }
  
    function hideCart(trackEvent) {
      $('html').removeClass('cart-open');
      $toggleCart.removeClass('site-header__icon--active');
      $panelCart.removeClass('site-header__panel--show');
  
      polaroid.state.unlockScreen();
  
      if ( trackEvent ) {
        polaroid.tracking.general('Cart', 'Open Overlay');
      }
    }
  
    function hideAll(keepPanel) {
      if ( keepPanel !== 'cart' ) hideCart();
      if ( keepPanel !== 'menu' ) hideMenu();
      if ( keepPanel !== 'search' ) hideSearch();
      if ( keepPanel !== 'account' ) hideAccount();
    }
  
    function _initEventListeners() {
      if ( polaroid.page.isPerformancePage ) return false;
  
      $toggleSearch.on('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
  
        toggleSearch();
      });
  
      $toggleAccount.on('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
  
        toggleAccount();
      });
  
      $toggleCart.on('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
  
        toggleCart();
      });
  
      $toggleMenu.on('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
  
        toggleMenu();
      });
  
      $('.toggle-dropdown').on('click', function() {
        $($(this).attr('data-target')).toggleClass('site-nav-mobile__item--expand');
      });
  
      $accountButton.on('click', function() {
        var $el = $(this);
  
        $($el.attr('data-current')).hide();
        $($el.attr('data-target')).show();
      });
  
      $(window).on('po.scroll-down', function(e, data) {
        if ( polaroid.state.currentScreenSizeMatches('xs') ) {
          if ( data.scrollTop > topBannerHeight + headerHeight + animateHeight ) {
            $siteHeader.addClass('site-header--animate');
          } else {
            $siteHeader.removeClass('site-header--animate');
          }
  
          if ( data.scrollTop > topBannerHeight + headerHeight ) {
            $siteHeader.addClass('site-header--top');
          }
  
          unstickTop();
        } else {
          if ( data.scrollTop > topBannerHeight ) {
            stickTop();
          }
        }
  
        if ( $subNav.length ) {
          $subNav.removeClass('sticky-nav--stuck');
  
          if ( polaroid.state.currentScreenSizeMatches('xs') ) {
            if ( data.scrollTop > topBannerHeight + headerHeight + 96 ) {
              $subNav.addClass('sticky-nav--small');
            }
          } else {
            if ( data.scrollTop > topBannerHeight + headerHeight + 24) {
              $subNav.addClass('sticky-nav--small');
            }
          }
        }
      });
  
      $(window).on('po.scroll-up', function(e, data) {
        if ( data.scrollTop > topBannerHeight ) {
          stickTop();
        } else {
          unstickTop();
          $siteHeader.removeClass('site-header--top');
        }
  
        if ( $subNav.length ) {
          if ( data.scrollTop > topBannerHeight + headerHeight + subNavHeight) {
            $subNav.addClass('sticky-nav--stuck');
          } else if ( data.scrollTop <= topBannerHeight ) {
            $subNav.removeClass('sticky-nav--stuck');
            $subNav.removeClass('sticky-nav--small');
          }
        }
      });
  
      $(window).on('load resize', polaroid.header.setRelatedValues);
      setRelatedValues();
  
      $(document).on('cart.requestComplete', function(event, cart) {
        if ( polaroid.page.template !== 'cart' ) {
          stickTop();
          showCart();
        }
      });
    }
  
  
    function setRelatedValues() {
      var distanceFromRight = $('.site-header > .container').length
        ? $(window).outerWidth() - $('.site-header > .container').outerWidth(false) - $('.site-header > .container').offset().left + 48
        : 0;
  
      totalHeaderHeight = headerHeight + _getTopBannerVisibleHeight();
  
      switch (polaroid.state.getState().currentScreenSize) {
        case 'xs':
          $upsellOverlay.css({'top': 'auto'});
          $panelCart.css({'top': totalHeaderHeight, 'height': 'calc(100vh - ' + totalHeaderHeight + ')', right: '0px' });
          break;
  
        case 'sm':
          $upsellOverlay.css({'top': 'auto'});
          $panelCart.css({'top': totalHeaderHeight, 'height': 'calc(100vh - ' + totalHeaderHeight + ')', right: '0px' });
          break;
  
        case 'md':
        case 'lg':
        case 'xl':
          $upsellOverlay.css({'top': totalHeaderHeight });
          $panelCart.css({'top': totalHeaderHeight, 'height': 'auto', 'right': distanceFromRight + 'px'});
          break;
      }
    }
  
    function _getTopBannerVisibleHeight() {
      var topBannerVisibleHeight = 0;
  
      // ... while all overlays are relative to the view
      if (topBannerHeight > 0) {
        // there is a banner on the page, so get amount of pixels that are in view...
        var htmlTop = $('html').scrollTop(),
            bodyTop = $('body').scrollTop(),
            // different browsers, different scrollTops ...
            useTopOffset = (htmlTop > bodyTop) ? htmlTop : bodyTop;
  
        if ((topBannerVisibleHeight - useTopOffset) >= 0) {
          // banner is partly out of view
          topBannerVisibleHeight = (topBannerHeight - useTopOffset);
  
        } else {
          // banner is out of view
          topBannerVisibleHeight = 0;
        }
      }
  
      return topBannerVisibleHeight;
    }
  
    return {
      init: init,
      toggleMenu: toggleMenu,
      showMenu: showMenu,
      hideMenu: hideMenu,
      toggleCart: toggleCart,
      showCart: showCart,
      hideCart: hideCart,
      setRelatedValues: setRelatedValues,
      stickTop: stickTop,
      unstickTop: unstickTop
    };
  })();
  
  polaroid.geo = (function (
    $,
    helpers
  ) {
    var has_geo_location,
        userHasConsented,
        $modal,
        $modalHeader,
        $modalInfo,
        $modalStayButton,
        $modalGoButton;
  
    function init() {
      has_geo_location = !!polaroid.helpers.readCookie('has_geo_location_v2');
      userHasConsented = !!polaroid.helpers.readCookie('CookieConsent');
  
      if ( !has_geo_location && userHasConsented ) {
        addScript();
      }
    }
  
    function addScript() {
      var geoScript = document.createElement('script');
      geoScript.type = 'text/javascript';
      geoScript.onload = getLocation;
      geoScript.src = 'https://js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js';
  
      document.head.appendChild(geoScript);
    }
  
    function getLocation() {
      try {
        window.geoip2.country(onSuccess, onError);
      } catch (e) {
        onError(e);
      }
    }
  
    function onSuccess(locationData) {
        var admin_shop_url    = window.polaroid.shop_url.replace('http://', '').replace('https://', ''),
            raw_code          = locationData.country.iso_code.toLowerCase(),
            raw_country_en    = locationData.country.names.en,
            raw_country_fr    = locationData.country.names.fr,
            raw_country       = raw_country_en,
            geo_code          = '',
            geo_url           = '',
            current_url_code  = '',
            uk_countries      = ['gb', 'im', 'gg', 'je'],
            us_countries      = ['us', 'ca', 'pr'];
  
        switch(admin_shop_url) {
            case 'us.polaroidoriginals.com':
            case 'us.impossible-project.com':
                current_url_code = 'us';
                break;
            case 'uk.polaroidoriginals.com':
            case 'uk.impossible-project.com':
                current_url_code = 'uk';
                break;
            case 'eu.polaroidoriginals.com':
            case 'eu.impossible-project.com':
                current_url_code = 'eu';
                break;
            case 'dev.polaroidoriginals.com':
            case 'dev.impossible-project.com':
            case 'impossibleprojectdev.myshopify.com':
            case 'impossibleprojectca.myshopify.com':
            case 'ca.impossible-project.com':
                current_url_code = 'DEVELOPMENT';
                break;
            default:
                current_url_code = 'eu';
        }
  
        if (_.contains(uk_countries, raw_code)) {
            geo_url  = '//uk.polaroidoriginals.com';
            geo_code = 'uk';
  
        } else if (_.contains(us_countries, raw_code)) {
            geo_url  = '//us.polaroidoriginals.com';
            geo_code = 'us';
  
        } else {
            geo_url  = '//eu.polaroidoriginals.com';
            geo_code = 'eu';
        }
  
        if (geo_code != current_url_code) {
          initModal(current_url_code, geo_code, geo_url, raw_country);
        }
  
        else {
            // user is inside correct shop, keep info 14 days
            helpers.createCookie('has_geo_location_v2', 'true', 14);
        }
    }
  
    function onError(error) {
      // to avoid continuing queries, retry in one day
      helpers.createCookie( 'has_geo_location_v2', 'true', 1);
    }
  
    function initModal(current_url_code, geo_code, geo_url, raw_country) {
      $modal = $('#RedirectModal').modal(
        {
          closeCallback: function() {
            helpers.createCookie( 'has_geo_location_v2', 'true', 1);
          },
          tracking: {
            category: 'Geo Modal'
          }
        }
      );
  
      $modalHeader = $('#RedirectModalHeader');
      $modalInfo = $('#RedirectModalInfo');
      $modalStayButton = $modal.find('.stay');
      $modalGoButton = $modal.find('.go');
  
      $modalStayButton
        .on('click', function(e) {
            e.preventDefault();
  
            // keep info 7 days
            helpers.createCookie('has_geo_location_v2', 'true', 7);
            $modal[0].modal.close();
  
            // prevent # in URL
            return false;
        })
        .text(polaroid.strings.geo_stay.replace('%%stay_iso%%', current_url_code.toUpperCase()));
  
      $modalGoButton
        .attr('href', helpers.getRedirectPath(geo_url))
        .text(polaroid.strings.geo_go.replace('%%go_iso%%', geo_code.toUpperCase()));
  
      $modalHeader
        .text(polaroid.strings.geo_heading);
  
      $modalInfo
        .text(
          polaroid.strings.geo_info
            .replace('%%go_iso%%', geo_code.toUpperCase())
            .replace('%%local_country%%', raw_country));
  
      $modal[0].modal.open();
    }
  
    return {
      init: init
    };
  })(
    window.jQuery,
    polaroid.helpers
  );
  
  polaroid.upsell = (function() {
    var $upsellModule = $('#UpsellOverlay');
    var $upsellCarouselsContainer = $('#UpsellCarouselsContainer');
    var $upsellCarousels = $('.upsell-overlay__carousel');
    var upsellsLoaded = {
      Camera_itype: false,
      Camera_600: false,
      Camera_sx70: false,
      Camera_spectra: false,
      Film_itype: false,
      Film_600: false,
      Film_sx70: false,
      Film_spectra: false
    };
  
    function checkForUpsell() {
      $upsellCarousels.removeClass('is-active');
  
      if ( !!CartJS.cart.item_count ) {
        $.getJSON('/products/' + CartJS.cart.items[0].handle + '.js',
          function onSuccess(product) {
            var format = '';
  
            for ( var i = 0; i < product.tags.length; i++ ) {
              switch ( product.tags[i] ) {
                case 'itype':
                case '600':
                case 'sx70':
                case 'spectra':
                  format = product.tags[i];
                  break;
              }
  
              if ( format ) {
                break;
              }
            }
  
            if ( format !== '' ) {
              if ( !upsellsLoaded[product.type + '_' + format] ) {
                var data = {};
  
                $.ajax({
                  type: 'GET',
                  url: '/collections/upsells/' + format,
                  data: data,
                  dataType: 'html',
                  timeout: 2000,
                  success: function(data) {
                    var page = $.parseHTML(data);
                    $upsellCarouselsContainer.append($(_.findWhere(page, {tagName: 'DIV'})).addClass('upsell-overlay__carousel--' + product.type + '_' + format));
  
                    for ( var i = 0; i < CartJS.cart.items.length; i++ ) {
                      $upsellCarouselsContainer.find('.' + CartJS.cart.items[i].handle).hide();
                    }
  
                    initCarousels();
                    polaroid.images.imgSources.setImages();
                    polaroid.images.imgSources.loadImages();
                    upsellsLoaded[product.type + '_' + format] = true;
                  },
                  error: function() {
                  }
                });
              } else {
                $('.upsell-overlay__carousel--' + product.type + '_' + format)
                  .addClass('is-active')
                  .find('.product-upsell-carousel__item').show();
  
                  // Hides product present in cart from upsell carousel
                  for ( var j = 0; j < CartJS.cart.items.length; j++ ) {
                    $upsellCarouselsContainer.find('.' + CartJS.cart.items[j].handle).hide();
                  }
  
                  // Hides bundle present in cart from upsell carousel
                  if ( CartJS.cart.bundles ) {
                    for ( var k = 0; k < CartJS.cart.bundles.length; k++ ) {
                      $upsellCarouselsContainer.find('[data-po-bundle-handle="' + CartJS.cart.bundles[k].handle + '"].product-upsell-carousel__item').hide();
                    }
                  }
              }
  
              show();
            }
          })
          .fail( function() {
  
          });
      } else {
        hide();
      }
    }
  
    function initCarousels() {
      $upsellCarousels = $('.upsell-overlay__carousel');
  
      if ( $upsellCarousels.length ) {
        $.each($upsellCarousels, function(index, carousel) {
          var $carousel = $(carousel);
  
          if ( $carousel.hasClass('upsell-overlay__carousel--init') ) return;
  
          var itemCount = $('.product-upsell-carousel__item', carousel).length,
              $warpAround = ((itemCount > 3)? true : false),
              $cellAlign = ((itemCount > 3)? 'center' : 'left');
  
          $carousel.flickity({
            arrowShape: {
              x0: 10,
              x1: 60, y1: 50,
              x2: 65, y2: 45,
              x3: 20
            },
            cellAlign: $cellAlign,
            cellSelector: '.product-upsell-carousel__item',
            draggable: Modernizr.touchevents,
            dragThreshold: 10,
            groupCells: true,
            imagesLoaded: true,
            pageDots: false,
            wrapAround: $warpAround,
            setGallerySize: false,
            prevNextButtons: !Modernizr.touchevents
          });
  
          $carousel.on('change.flickity', function( event, index ) {
            polaroid.tracking.general('Upsell', 'Scroll');
          });
  
          $carousel.addClass('upsell-overlay__carousel--init');
        });
  
        $(window).on('resize', updateCarousels);
        updateCarousels();
        $upsellCarousels.flickity('resize');
      }
    }
  
    function updateCarousels() {
      $upsellCarousels.flickity('reloadCells');
    }
  
    function show() {
      polaroid.header.setRelatedValues();
      $upsellModule.addClass('upsell-overlay--show');
      polaroid.header.setRelatedValues();
  
      setTimeout(function() {
        $upsellCarousels.flickity('resize');
      }, 450);
    }
  
    function hide() {
      $upsellModule.removeClass('upsell-overlay--show');
    }
  
    return {
      show: show,
      hide: hide,
      checkForUpsell: checkForUpsell
    };
  })();
  
  polaroid.bundleQuickViewModal = (function(
    $,
    images
  ) {
    var $quickViewModal;
    var isOpen = false;
    var isLoading = false;
    var collectionHandle;
  
    // Adds event listener when a bundle gets added to the cart
    $(document).on('polaroid.bundleAdded', function(event, cart) {
      if ( $quickViewModal ) {
        $quickViewModal.close(true);
      }
    });
  
    // Fetches the markup from the collection page using the /quickview endpoint
    function setup( aCollectionHandle, callback ) {
      if ( !$quickViewModal ) {
        $quickViewModal = new polaroid.Modal('#QuickViewModal', {
          closeCallback: close,
          tracking: {
            category: 'QuickView Modal'
          }
        });
      }
  
      collectionHandle = aCollectionHandle;
  
      $.get('/collections/' + collectionHandle + '/quickview',
        function(data) {
          if ( callback ) callback();
          load($.parseHTML($.trim(data)));
          isLoading = false;
        })
        .fail(function() {
          console.log('Error');
        });
    }
  
    function load(module) {
      $quickViewModal.appendContent(module);
      open();
  
      $(module).bundleStandalone({
        tracking: {
          category: 'QuickView Modal'
        }
      });
  
      // Loads lazy loading images
      images.imgSources.setImages();
      images.imgSources.loadImages();
    }
  
    function open() {
      if ( !isOpen ) {
        $quickViewModal.open(true);
        isOpen = true;
      }
    }
  
    function close() {
      if ( isOpen ) {
        isOpen = false;
        reset();
      }
    }
  
    function toggle() {
      if ( isOpen ) {
        close(true);
      } else {
        open();
      }
    }
  
    function reset() {
      collectionHandle = '';
      $quickViewModal.removeContent();
    }
  
    // Adds event listeners to buttons to open up and close the modal
    function initButtons() {
      $('[data-po-quickview-bundle]').on('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
  
        if ( isLoading ) return false;
  
        isLoading = true;
        var $this = $(this);
        collectionHandle = $this.attr('data-po-collection-handle');
        var $loadingSpinner = $('#LoadingSpinner_bundle' + $this.attr('data-po-collection-handle'));
  
        $loadingSpinner.show();
  
        setup(collectionHandle, function() {
          $loadingSpinner.hide();
        });
      });
  
      // $('.product-list-item__main-anchor').on('click', function(e) {
      //   if ( polaroid.screenSize !== 'xs' && polaroid.screenSize !== 'sm' ) return;
      //
      //   e.preventDefault();
      //   e.stopImmediatePropagation();
      //
      //   $(this).find('[data-po-quickview-bundle]').trigger('click');
      // });
    }
  
    return {
      close: close,
      initButtons: initButtons
    };
  })(
    window.jQuery,
    polaroid.images
  );
  
  polaroid.quickViewModal = (function(
    $,
    images
  ) {
    var $quickViewModal;
    var isOpen = false;
    var productHandle;
    var variantId;
    var options = {};
  
    // Adds event listener when product gets added to the cart
    $(document).on('cart.requestComplete', function(event, cart) {
      if ( $quickViewModal ) {
        $quickViewModal.close(true);
      }
    });
  
    // Fetches the markup from the collection page using the /quickview endpoint
    function setup( callback ) {
      if ( !$quickViewModal ) {
        $quickViewModal = new polaroid.Modal('#QuickViewModal', {
          closeCallback: close,
          tracking: {
            category: 'QuickView Modal'
          }
        });
      }
  
      $.get('/products/' + productHandle + '/quickview',
        function(data) {
          if ( callback ) callback();
          load($.parseHTML($.trim(data)));
        })
        .fail(function() {
          console.log('Error');
        });
    }
  
    function load( module ) {
      $quickViewModal.appendContent(module);
      open();
      var settings = {
        variantId: variantId,
        tracking: {
          category: 'QuickView Modal'
        }
      };
  
      settings = $.extend(settings, options);
  
      $(module).productStandalone(settings);
  
      // Loads lazy loading images
      images.imgSources.setImages();
      images.imgSources.loadImages();
    }
  
    function open() {
      if ( !isOpen ) {
        $quickViewModal.open(true);
        isOpen = true;
      }
    }
  
    function close() {
      if ( isOpen ) {
        isOpen = false;
        reset();
      }
    }
  
    function toggle() {
      if ( isOpen ) {
        close(true);
      } else {
        open();
      }
    }
  
    function reset() {
      updateProductHandle('');
      updateVariantId(undefined);
      updateOptions({});
      $quickViewModal.removeContent();
    }
  
    function updateProductHandle(newProductHandle) {
      productHandle = newProductHandle;
    }
  
    function updateVariantId(newVariantId) {
      variantId = newVariantId;
    }
  
    function updateOptions(newOptions) {
      options = newOptions;
    }
  
    // Adds event listeners to buttons to open up and close the modal
    function initButtons() {
      // Initializes normal buttons
      $('[data-po-quick-view]').on('click', function(e) {
        e.preventDefault();
        var $this = $(this);
        var $loadingSpinner;
        var lodingSpinnerId;
  
        var settings = {};
        if ( $this.attr('data-po-quantity') ) {
          settings.quantity = parseInt($this.attr('data-po-quantity'));
        }
  
        updateProductHandle($this.attr('data-po-product-handle'));
        updateVariantId($this.attr('data-po-variant-id'));
        updateOptions(settings);
  
        lodingSpinnerId = '#LoadingSpinner_card' + variantId;
  
        if ( settings.quantity ) {
          lodingSpinnerId = lodingSpinnerId + settings.quantity;
        }
  
        $loadingSpinner = $(lodingSpinnerId);
        $loadingSpinner.show();
  
        setup(function() {
          $loadingSpinner.hide();
        });
      });
  
      // Initializes buttons that add added to the DOM after page load
      $(document).on('click', '[data-po-quick-view-alt]', function(e) {
        e.preventDefault();
        var $this = $(this);
  
        updateProductHandle($this.attr('data-po-product-handle'));
        updateVariantId($this.attr('data-po-variant-id'));
        updateOptions(settings);
  
        var $loadingSpinner = $('#LoadingSpinner_card' + variantId);
  
        var settings = {};
        if ( $this.attr('data-po-quantity') ) {
          settings.quantity = parseInt($this.attr('data-po-quantity'));
        }
  
        $loadingSpinner.show();
  
  
  
        setup(function() {
          $loadingSpinner.hide();
        });
      });
  
      // $('.product-list-item__main-anchor').on('click', function(e) {
      //   if ( !polaroid.state.currentScreenSizeMatches(['xs', 'sm']) ) return;
      //
      //   e.preventDefault();
      //
      //   $(this).parent().find('[data-po-quick-view]').trigger('click');
      // });
    }
  
    return {
      close: close,
      initButtons: initButtons
    };
  })(
    window.jQuery,
    polaroid.images
  );
  

  /*================ Templates ================*/
  /**
   * Product Template Script
   * ------------------------------------------------------------------------------
   * A file that contains scripts highly coupled to the Product template.
   *
   */
  
  polaroid.Product = (function() {
    $(_init);
  
    var $gallery;
  
    function _init() {
      var flkty,
          $galleryNav     = $('.gallery-nav'),
          $cellContainer  = $('.sub_nav_wrap', $galleryNav),
          $translateX     = 0,
          $navCells       = $galleryNav.find('.nav-cell'),
          $navPrev        = $galleryNav.find('.nav-cell-prev'),
          $navNext        = $galleryNav.find('.nav-cell-next'),
          $activeCell,
  
      /**
       * Gives back an object with information about current, prev and next
       * navCell index. Prev and next can be "-1" to define not available.
       *
       * @param flkty
       * @returns { current, prevCell, nextCell }
       * @private
       */
          _getFlktyIndex = function(flkty) {
            var $index = flkty.selectedIndex,
                $max   = flkty.cells.length - 1,
                fIndex = {
                  'current': $index
                };
            fIndex.prevCell = (($index - 1) <= -1) ? -1 : ($index - 1);
            fIndex.nextCell = (($index + 1) >= ($max + 1)) ? -1 : ($index + 1);
            return fIndex;
          },
  
      /**
       * Gives back a string to use as margin-left value, that moves the navCells
       * into the center of the navigation bar.
       *
       * @param flkty
       * @param cellWidth
       * @returns {string}
       * @private
       */
          _getTranslateX = function(flkty, cellWidth) {
            var amountOfCells = flkty.cells.length,
                minLeft       = 2 * cellWidth + (cellWidth / 2),
                minRight      = (amountOfCells * cellWidth) - minLeft,
            // careful! index starts with 0, so we add half a cell instead of removing it ...
                activeElementCenterPos = flkty.selectedIndex * cellWidth + (cellWidth / 2);
  
            if (amountOfCells <= 5) {
              return '-' + (amountOfCells * cellWidth / 2) + 'px';
  
            } else if (activeElementCenterPos <= minLeft) {
              return '-' + minLeft + 'px';
  
            } else if (activeElementCenterPos >= minRight) {
              return '-' + minRight + 'px';
            }
            return (activeElementCenterPos > 0) ? ('-' + activeElementCenterPos + 'px') : (activeElementCenterPos + 'px');
          },
  
      /**
       * Gives back an array with all indexes of NavCells that are out of sight.
       *
       * @param flkty
       * @returns {Array}
       * @private
       */
          _getOutIndexes = function(flkty) {
            var amountOfCells = flkty.cells.length,
                currentIndex  = flkty.selectedIndex,
                displayAmount = 5,
                offIndexes    = [];
  
            if (amountOfCells <= displayAmount) {
              return offIndexes;
            }
  
            for(var i = 0; i < amountOfCells; i++) {
              if (currentIndex < (displayAmount/2) && i < displayAmount) {
                continue;
              }
              else if (currentIndex > (amountOfCells - (displayAmount/2)) && i >= (amountOfCells - displayAmount)) {
                continue;
              }
              else if ((currentIndex < (i - (displayAmount/2))) || (currentIndex > (i + (displayAmount/2)))) {
                offIndexes.push(i);
              }
  
            }
            return offIndexes;
          };
  
      $('.product-hero-actions__qty-minus, .product-hero-actions__qty-plus').on('click', function(e) {
        e.preventDefault();
  
        var qty = $(this).siblings('.product-hero-actions__qty').val();
  
        if ($(this).is('.product-hero-actions__qty-minus')) {
          qty--;
        } else {
          qty++;
        }
  
        if (qty < 1) {
          qty = 1;
        }
  
        $('.product-hero-actions__qty').val(qty);
      });
  
      $gallery = $('.product-hero-gallery').flickity({
        cellAlign: 'left',
        cellSelector: '.product-hero-gallery__item',
        contain: true,
        draggable: Modernizr.touchevents,
        dragThreshold: 10,
        imagesLoaded: true,
        pageDots: false,
        prevNextButtons: false,
        lazyLoad: true,
        initialIndex: $('[data-product-featured-image]').closest('.product-hero-gallery__item').index()
      });
  
      flkty = $gallery.data('flickity');
  
      if (typeof flkty != 'undefined') {
        var _rePositionNav = function() {
          if (Modernizr.mq('(min-width: 940px)')) {
            $('.gallery-nav-container').css({'top': $('.product-hero-gallery .flickity-viewport').css('height')});
          } else {
            $('.gallery-nav-container').css({'top': 'auto'});
  
          }
        };
        $(window).on('resize', _rePositionNav);
        _rePositionNav();
  
        // script can be on pages without gallery, so direct call of flkty would fail ...
        if (flkty.cells.length <= 5) {
          $navPrev.addClass('out');
          $navNext.addClass('out');
        }
  
        $gallery.on('change.flickity', function(event, index) {
          polaroid.tracking.general('Product Page', 'Change Image');
        });
  
        $navCells.on( 'click', function() {
          var index = $navCells.index(this);
          $gallery.flickity('select', index);
        });
  
        $navPrev.on('click', function() {
          if ($(this).hasClass('off')) {
            return;
          }
          $gallery.flickity('previous');
        });
  
        $navNext.on('click', function() {
          if ($(this).hasClass('off')) {
            return;
          }
          $gallery.flickity('next');
        });
      }
  
      $gallery.on('lazyLoad.flickity', function(event, cellElement ) {
        var img = event.originalEvent.target;
        var imgUrl = img.getAttribute('data-image-src');
        var sizedImgUrl = '';
  
        if ( imgUrl.indexOf('.png') > -1 ) {
          if ( polaroid.state.currentScreenSizeMatches('xs') ) {
            sizedImgUrl = slate.Image.getSizedImageUrl( imgUrl, '200x200@2x');
          } else {
            sizedImgUrl = slate.Image.getSizedImageUrl( imgUrl, '600x600');
          }
        } else {
          if ( polaroid.state.currentScreenSizeMatches('xs') ) {
            sizedImgUrl = slate.Image.getSizedImageUrl( imgUrl, '300x300@2x');
          } else {
            sizedImgUrl = slate.Image.getSizedImageUrl( imgUrl, '1024x1024');
          }
        }
  
        img.src = sizedImgUrl;
      });
  
      $gallery.on('select.flickity', function() {
        var fIndex = _getFlktyIndex(flkty),
            outIndexes = _getOutIndexes(flkty);
  
        $('.product-hero-gallery__item-button').removeAttr('data-reactive-cursor-disabled');
  
        if ($('.product-hero-gallery__item.is-selected').is(':first-child')) {
          $('.product-hero-gallery__item-button.prev').attr('data-reactive-cursor-disabled', true);
  
          polaroid.cursor.update($('.product-hero-gallery__item-button.prev'));
        }
  
        if ($('.product-hero-gallery__item.is-selected').is(':last-child')) {
          $('.product-hero-gallery__item-button.next').attr('data-reactive-cursor-disabled', true);
  
          polaroid.cursor.update($('.product-hero-gallery__item-button.next'));
        }
  
        $('div', $cellContainer).each(function(index, el) {
          if (outIndexes.indexOf(index) == -1) {
            $(el).removeClass('out');
          } else {
            $(el).addClass('out');
          }
        });
        $activeCell = $navCells.filter('.is-selected');
        $activeCell.removeClass('is-selected');
        $navCells.filter('.is-prev').removeClass('is-prev');
        $navCells.filter('.is-next').removeClass('is-next');
  
        $navCells.eq(fIndex.current).addClass('is-selected');
        if (fIndex.prevCell == -1) {
          $navPrev.addClass('off');
        } else {
          $navPrev.removeClass('off');
          $navCells.eq(fIndex.prevCell).addClass('is-prev');
        }
        if (fIndex.nextCell == -1) {
          $navNext.addClass('off');
        } else {
          $navNext.removeClass('off');
          $navCells.eq(fIndex.nextCell).addClass('is-next');
        }
  
        $translateX = _getTranslateX(flkty, $navCells.eq(fIndex.current).outerWidth(true));
        $cellContainer.css({'transform': 'translateX(' + $translateX + ')', 'opacity': '1'});
      });
  
      $('.product-hero-gallery__item-button').on('click', function(e) {
        e.preventDefault();
  
        if ($(this).hasClass('prev')) {
          $gallery.flickity('previous');
        } else if ($(this).hasClass('next')) {
          $gallery.flickity('next');
        } else {
          $('.product-hero').toggleClass('gallery-active');
  
          if ($(this).attr('data-reactive-cursor') === 'zoom-in') {
            $('.product-hero-gallery__item-button.zoom').attr('data-reactive-cursor', 'zoom-out');
          } else {
            $('.product-hero-gallery__item-button.zoom').attr('data-reactive-cursor', 'zoom-in');
          }
  
          polaroid.cursor.update($(this));
        }
      });
  
      $('#po-rc_block__type__autodeliver__wrapper').on('click', function() {
        var $checkbox = $('#po-rc_block__type__autodeliver__checkbox');
  
        if ( $checkbox[0].checked ) {
          $('.rc_block__type__onetime label').click();
          $('#ProductOriginalPrice').addClass('hidden');
          $('[data-product-price]').removeClass('tomato');
          $('.product-hero-actions__dynamic-buttons').removeClass('product-hero-actions__dynamic-buttons--disabled');
          $checkbox.prop('checked', false);
        } else {
          $('.rc_block__type__autodeliver label').click();
          $('#ProductOriginalPrice').removeClass('hidden');
          $('[data-product-price]').addClass('tomato');
          $('.product-hero-actions__dynamic-buttons').addClass('product-hero-actions__dynamic-buttons--disabled');
          $checkbox.prop('checked', true);
        }
      });
    }
  
      var selectors = {
        addToCart: '[data-productpage-add-to-cart]',
        addToCartText: '[data-productpage-add-to-cart-text]',
        comparePrice: '[data-compare-price]',
        comparePriceText: '[data-compare-text]',
        originalSelectorId: '[data-product-select]',
        priceWrapper: '[data-price-wrapper]',
        productFeaturedImage: '[data-product-featured-image]',
        productJson: '[data-product-json]',
        productPrice: '[data-product-price]',
        productThumbs: '[data-product-single-thumbnail]',
        singleOptionSelector: '[data-single-option-selector]'
      };
  
      /**
       * Product section constructor. Runs on page load as well as Theme Editor
       * `section:load` events.
       * @param {string} container - selector for the section container DOM element
       */
      function Product(container) {
        this.$container = $(container);
        var sectionId = this.$container.attr('data-section-id');
  
        this.settings = {};
        this.namespace = '.product';
  
        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!$(selectors.productJson, this.$container).html()) {
          return;
        }
  
        this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
        //this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));
        // we stay with this size for the moment and don't need to preload 2048x2048 (which was default here
        // for an unknown reason)
        this.settings.imageSize = '1024x1024';
  
        this.initVariants();
        this.initTierSet();
      }
  
      Product.prototype = $.extend({}, Product.prototype, {
  
        /**
         * Handles change events from the variant inputs
         */
        initVariants: function() {
          var options = {
            $container: this.$container,
            enableHistoryState: this.$container.data('enable-history-state') || false,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: this.productSingleObject
          };
  
          this.variants = new slate.Variants(options);
  
          this.updateProductPriceDifference(this.variants);
  
          this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
          this.$container.on('variantChange' + this.namespace, this.updateProductPriceDifference.bind(this));
          this.$container.on('variantChange' + this.namespace, function(e) {
            $('#ProductPageTier').tierSet('updateCurrentVariantId', e.variant.id);
            $('#ProductPageTier').tierSet('updatePrice');
            polaroid.tracking.general('Product Page', 'Change Variant', e.variant.title);
          });
          this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
          this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
  
        },
  
        initTierSet: function() {
          var quantity = polaroid.helpers.getUrlParamValue(window.location.search, 'quantity')
            ? parseInt(polaroid.helpers.getUrlParamValue(window.location.search, 'quantity'))
            : null;
  
          // If there is a Tier Set UI element, then init the element
          $('#ProductPageTier').tierSet({
            currentVariantId: this.variants.currentVariant.id,
            quantity: quantity,
            updateQuantityCallback: function(quantity) {
              $('.product-hero-actions__qty').val(quantity);
            },
            tracking: {
              category: 'Product Page',
              label: this.productSingleObject.handle
            }
          });
        },
  
        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState: function(evt) {
          var variant = evt.variant,
              variants = window.polaroid.pre_order_variants;
  
          if (variant) {
            $(selectors.priceWrapper, this.$container).removeClass('hide');
          } else {
            $(selectors.addToCart, this.$container).prop('disabled', true);
            $(selectors.addToCartText, this.$container).html(polaroid.strings.unavailable);
            $(selectors.priceWrapper, this.$container).addClass('hide');
            return;
          }
  
          this.updatePreOrderData(variant, this.$container);
  
          if (variant.available) {
            $(selectors.addToCart, this.$container).prop('disabled', false);
  
            if (variants[variant.id] !== undefined) {
              $(selectors.addToCartText, this.$container).html(polaroid.strings.preOrderNow);
              return;
            }
  
            $(selectors.addToCartText, this.$container).html(polaroid.strings.addToCart);
  
          } else {
            $(selectors.addToCart, this.$container).prop('disabled', true);
            $(selectors.addToCartText, this.$container).html(polaroid.strings.soldOut);
          }
        },
  
        updatePreOrderData: function(variant, container) {
          var $msg                      = ((variant.available) ? this.getPreOrderMsg(variant.id) : ''),
              $preOrderDates            = ((variant.available) ? polaroid.helpers.getPreOrderPropertyDates(variant.id) : null),
              $inputPreOrder_timestamp  = $('#pre-order_property_tmstmp', container),
              $inputPreOrder_formated   = $('#pre-order_property', container),
              $form                     = $('form.product-hero-actions', container),
              $newProperty1,
              $newProperty2;
  
          $('.product-hero__pre_order_note', container).html($msg);
          if ($preOrderDates === null) {
            // if it is there, remove it...
            $inputPreOrder_timestamp.remove();
            $inputPreOrder_formated.remove();
  
          } else if (_.isObject($preOrderDates)) {
            // we got dates to display!
  
            $newProperty1 = $('<input>', {
              type:  "hidden",
              id:    "pre-order_property_tmstmp",
              name:  "properties[_shipping_date_timestamp]",
              value: $preOrderDates.timestamp
            });
  
            $newProperty2 = $('<input>', {
              type:  "hidden",
              id:    "pre-order_property",
              name:  "properties[Shipping_Date]",
              value: $preOrderDates.formatted
            });
  
            // replace or add...
            if ($inputPreOrder_timestamp.length) {
              $inputPreOrder_timestamp.replaceWith($newProperty1);
            } else {
              $form.append($newProperty1);
            }
            if ($inputPreOrder_formated.length) {
              $inputPreOrder_formated.replaceWith($newProperty2);
            } else {
              $form.append($newProperty2);
            }
          }
        },
  
        getPreOrderMsg: function(variantId) {
          var $variants = window.polaroid.pre_order_variants,
              $msg = '';
  
          if ($variants[variantId] != undefined) {
            $msg = window.polaroid.strings.preOrder_product_page + ' ';
            if (!$variants[variantId].date_expired) {
              $msg = $msg + window.polaroid.strings.preOrder_product_page_date.replace('%%sh_date%%', $variants[variantId].date_formatted);
            }
          }
          return $msg;
        },
  
        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices: function(evt) {
          var variant = evt.variant;
          var $price = $(selectors.productPrice, this.$container);
          var $comparePrice = $(selectors.comparePrice, this.$container);
          var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
  
          $price.html(slate.Currency.formatMoney(variant.price, polaroid.moneyFormat));
  
          if (variant.compare_at_price > variant.price) {
            $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, polaroid.moneyFormat));
            $compareEls.removeClass('hide');
            $price.addClass('tomato');
          } else {
            $comparePrice.html('');
            $compareEls.addClass('hide');
            $price.removeClass('tomato');
          }
        },
  
        /**
         * Updates the DOM select options with price differences
         *
         * @param {string} singleOptionSelector - The variants select
         */
        updateProductPriceDifference: function(evt) {
          var variant = evt.variant || evt.currentVariant;
          var $variantSelects = $(selectors.singleOptionSelector);
  
          // TODO: Add support for more than one select
          if ($variantSelects.length === 1) {
            for ( var i = 0; i < $variantSelects[0].length; i++ ) {
              if ( variant.id === this.variants.product.variants[i].id ) {
                $variantSelects[0][i].text = $variantSelects[0][i].value;
              } else {
                var priceDifference = this.variants.product.variants[i].price - variant.price;
  
                if ( priceDifference !== 0 ) {
                  var priceDifferenceSign = priceDifference > 0 ? '+' : '-';
  
                  $variantSelects[0][i].text = $variantSelects[0][i].value + ' (' + priceDifferenceSign +  slate.Currency.formatMoney(Math.abs(priceDifference), polaroid.moneyFormat) + ')';
                } else {
                  $variantSelects[0][i].text = $variantSelects[0][i].value;
                }
              }
            }
          }
        },
  
        /**
         * Updates the DOM with the specified image URL
         *
         * @param {string} src - Image src URL
         */
        updateProductImage: function(evt) {
          var variant = evt.variant;
          var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
          var $imgTag = $('img[data-variant-id="' + variant.id + '"]', $gallery);
  
          if ($imgTag.length) {
            $gallery.flickity('select', $imgTag.closest('.product-hero-gallery__item').index(), false, true);
          }
        },
  
        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function() {
          this.$container.off(this.namespace);
        }
      });
  
      return Product;
  
  })();
  
  /**
   * Collection Template Script
   * ------------------------------------------------------------------------------
   * A file that contains scripts highly coupled to the Collection template.
   *
   * @namespace collection
   */
  
  polaroid.collection = (function() {
    function init() {
      $('#search-input-collection').keypress(function(e) {
        if (e.which === 13) {
          doSearch();
        }
      });
  
      $('[data-po-do-search-collection]').on('click', function() {
        doSearch();
      });
  
      function doSearch() {
        var q = $('#search-input-collection').val().toLowerCase();
  
        if (q === '') {
          $('.product-grid__products, .product-grid__col').removeClass('hidden');
          $('.collection-no-results').removeClass('is-visible');
        } else {
          $('.product-grid__products').each(function() {
            var found = false;
  
            $('.product-grid__col', this).each(function() {
              if ($('.product-list-item__title', this).text().toLowerCase().indexOf(q) > -1) {
                found = true;
  
                $(this).removeClass('hidden');
              } else {
                $(this).addClass('hidden');
              }
            });
  
            if (found) {
              $(this).removeClass('hidden');
            } else {
              $(this).addClass('hidden');
            }
          });
  
          if ($('.product-grid__products:visible').length) {
            $('.collection-no-results').removeClass('is-visible');
          } else {
            var $collectionNoResults = $('.collection-no-results');
  
            if ($collectionNoResults.length) {
              var text = $collectionNoResults.data('text').replace('{{ terms }}', q);
  
              $collectionNoResults
                .text(text)
                .addClass('is-visible');
            }
          }
        }
      }
    }
  
    return {
      init: init
    };
  })();
  
  /**
   * Customer Account Script
   * ------------------------------------------------------------------------------
   * A file that contains scripts highly coupled to the Customer Addresses
   * template.
   *
   * @namespace customerAccount
   */
  
  polaroid.customerAccount = (function() {
    var $loyaltyWrapper = $('#LoyaltyWrapper');
  
    if ( $loyaltyWrapper.length ) {
      if ( !document.queryCommandSupported ) {
        $('#LoyaltyCopy').hide();
      }
  
      $(window).on('po.smile-ready', function(e, SmileUI) {
  
        $('#LoyaltyInput').val(SmileUI.smile.customer.referral_url);
  
        $('#LoyaltyCopy').on('click', function() {
          var loyaltyCode = document.getElementById('LoyaltyInput');
  
          loyaltyCode.select();
  
          try {
            document.execCommand('copy');
          } catch (err) {
            console.log('Unable to copy text');
          }
        });
  
        $('#LoyaltyHeaderLink').on('click', function() {
          SmileUI.openPanel({deep_link: 'home'});
        });
      });
    }
  
    // Since we don't really have a URL for some of the account pages this works as simple routing
    switch (location.pathname) {
      case '/account':
        if ( location.hash === '#information' ) {
          $('#AccountOverview').hide();
          $('#AccountInfo').show();
        } else if ( location.hash === '#orders' ) {
          $('#AccountOverview').hide();
          $('#AccountOrders').show();
        } else if ( location.hash === '#loyalty' ) {
          $(window).on('po.smile-ready', function(e, SmileUI) {
            SmileUI.openPanel({deep_link: 'home'});
          });
        }
        break;
    }
  
    $('.accounts-trigger').on('click', function() {
      if ( polaroid.state.currentScreenSizeMatches(['xs','sm']) ) {
        $('html').removeClass('menu-open');
      }
  
      $('.accounts-view').each( function() {
        $(this).hide();
      });
  
      $($(this).attr('data-target')).show();
    });
  
    function showLoyaltyPoints() {
      var loyaltyCode = document.getElementById('LoyaltyInput');
  
      loyaltyCode.select();
  
      try {
        document.execCommand('copy');
      } catch (err) {
        console.log('Unable to copy text');
      }
    }
  })();
  
  /**
   * Customer Addresses Script
   * ------------------------------------------------------------------------------
   * A file that contains scripts highly coupled to the Customer Addresses
   * template.
   *
   * @namespace customerAddresses
   */
  
  polaroid.customerAddresses = (function() {
    var $newAddressForm = $('#AddressNewForm');
  
    if (!$newAddressForm.length) {
      return;
    }
  
    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }
  
    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;
  
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });
  
    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });
  
    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  
    $('.address-default').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var $checkbox = $('#address_default_address_' + formId);
      var $submitButton = $('#address_submit_' + formId);
      var $spinner = $('#address_spinner_' + formId);
  
      $spinner.show();
      $checkbox.prop('checked', true);
      $submitButton.click();
    });
  })();
  
  /**
   * Password Template Script
   * ------------------------------------------------------------------------------
   * A file that contains scripts highly coupled to the Password template.
   *
   * @namespace password
   */
  
  polaroid.customerLogin = (function() {
    var config = {
      recoverPasswordForm: '#RecoverPassword',
      hideRecoverPasswordLink: '#HideRecoverPasswordLink'
    };
  
    if (!$(config.recoverPasswordForm).length) {
      return;
    }
  
    checkUrlHash();
    resetPasswordSuccess();
  
    $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
    $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);
  
    function onShowHidePasswordForm(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    }
  
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    /**
     *  Show/Hide recover password form
     */
    function toggleRecoverPasswordForm() {
      $('#RecoverPasswordForm').toggleClass('hide');
      $('#CustomerLoginForm').toggleClass('hide');
    }
  
    /**
     *  Show reset password success message
     */
    function resetPasswordSuccess() {
      var $formState = $('.reset-password-success');
  
      // check if reset password form was successfully submited.
      if (!$formState.length) {
        return;
      }
  
      // show success message
      $('#ResetSuccess').removeClass('hide');
    }
  })();
  
  /**
   * Additional code for Sweettooth / smile.io
   * ------------------------------------------------------------------------------
   */
  
  document.addEventListener('smile-ui-loaded', function() {
    SmileUI.customerReady().then( function( customer ) {
      $(window).trigger('po.smile-customer-ready', customer);
    });
  
    SmileUI.ready().then( function( SmileUI ) {
      var $smilePopLinks = $('.smileIoJs');
  
      if (!$smilePopLinks.length) {
        return;
      }
  
      $smilePopLinks.each(function(index, el) {
        var $el = $(el);
  
        $el.attr('href', '#');
        $el.removeClass('smileInactive').addClass('smileActive');
        $el.on('click', function(event) {
          event.preventDefault();
          SmileUI.openPanel({deep_link: 'home'});
        });
      });
  
      $(window).trigger('po.smile-ready', SmileUI);
    });
  });
  
  /**
   * Index Script
   * ------------------------------------------------------------------------------
   * A file that contains scripts highly coupled to the Index
   * template.
   *
   * @namespace homepage
   */
  
  polaroid.homepage = (function() {
  
    function init() {
      if (!$('body').hasClass('template-index')) {
        return;
      }
  
      var $magazineContainer = $('#IndexMag');
  
      $(window).on('po.scroll-down', _checkMagazine);
  
      function _checkMagazine(e, data) {
        if ( data.scrollTop + data.windowHeight > $magazineContainer.offset().top ) {
          _getMagazine();
          $(window).off('po.scroll-down', _checkMagazine);
        }
      }
    }
  
    function _getMagazine() {
      $.ajax({
        type: 'GET',
        url: polaroid.magazine_url,
        data: {'posts-json-v3': 1},
        dataType: 'jsonp',
        timeout: 10000,
        success: _initMagazine,
        error: function() {
          $('#IndexMag').hide();
          console.log('Error retrieving Magazine articles');
        }
      });
    }
  
    function _initMagazine(data) {
      $.each(data, function(index) {
        var $article = $($('#index-mag-article-template').html());
        var replacedCategories = [];
  
        $article
          .attr('href', this.permalink)
          .attr('data-bg-color', this.image_color);
  
        for (var i = 0; i < this.categories.length; i++) {
          replacedCategories.push(this.categories[i].replace(/&amp;/g, '&'));
        }
  
        $('.index-mag-article__img', $article).attr('src', this.image_url.medium);
        $('.index-mag-article__category', $article).text(replacedCategories);
        $('.index-mag-article__title', $article).text(this.title);
  
        $article.appendTo('.index-mag-articles');
      });
  
      $('.index-mag-articles').flickity({
        arrowShape: {
          x0: 10,
          x1: 60, y1: 50,
          x2: 65, y2: 45,
          x3: 20
        },
        cellSelector: '.index-mag-article',
        cellAlign: 'left',
        dragThreshold: 10,
        draggable: Modernizr.touchevents,
        prevNextButtons: !Modernizr.touchevents,
        imagesLoaded: true,
        pageDots: false,
        contain: true
      });
  
      $('.index-mag-articles').on('select.flickity', function() {
        var flkty = $('.index-mag-articles').data('flickity');
        var color = $('.index-mag-article').eq(flkty.selectedIndex).data('bg-color');
  
        $('.index-mag').css('background-color', _shadeColor(color, -0.2));
      });
  
      $('.index-mag-article').on('mouseenter', function() {
        $('.index-mag').css('background-color', _shadeColor($(this).data('bg-color'), -0.2));
      });
    }
  
    function _shadeColor(color, percent) {
        var f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
        return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
    }
  
    return {
      init: init
    };
  })();
  
  /**
   * Instant Film Script
   * ------------------------------------------------------------------------------
   * A file that contains scripts highly coupled to the Instant Film
   * template.
   *
   * @namespace instantFilm
   */
  
  polaroid.instantFilm = (function() {
    function init() {
      if (!$('body').is('.template-page-instant-film')) {
        return;
      }
  
      $('.template-instant-film-format-link').on('mouseenter', function() {
        if (Modernizr.touchevents) return;
  
        $('.template-instant-film-formats').addClass('has-bg-color bg-' + $(this).data('color'));
      }).on('mouseleave', function() {
        $('.template-instant-film-formats').attr('class', 'template-instant-film-formats');
      });
  
      var $inFocusElem;
  
      $(window).on('scroll', function() {
        if (polaroid.state.currentScreenSizeMatches('xs') || !Modernizr.touchevents) return;
  
        var scrollTop = $(window).scrollTop();
        var $nextInFocusElem;
  
        $('.template-instant-film-format-link').each(function() {
          var top = $(this).offset().top;
          var height = $(this).height();
          var buffer = 100;
  
          if (scrollTop + polaroid.state.getState().windowHeight > top + height - buffer && scrollTop < top + buffer) {
            $nextInFocusElem = $(this);
  
            return false;
          }
        });
  
        if ($inFocusElem !== $nextInFocusElem) {
          $('.template-instant-film-format-link').removeClass('is-in-focus');
          $('.template-instant-film-formats').attr('class', 'template-instant-film-formats');
  
          $inFocusElem = $nextInFocusElem;
  
          if ($inFocusElem !== undefined) {
            $inFocusElem.addClass('is-in-focus');
            $('.template-instant-film-formats').addClass('has-bg-color bg-' + $inFocusElem.data('color'));
          }
        }
      });
    }
  
    return {
      init: init
    };
  })();
  
  /**
   * Script related to search functionality
   * ------------------------------------------------------------------------------
   *
   * @namespace customSearch
   */
  
  polaroid.customSearch = (function() {
    if (!$('body').is('.template-search, .template-404, .template-page-404-test')) {
      return;
    }
  
    var query = '';
  
    $(_init);
  
    function _init() {
      var $shop_apiKey = '',
          $indexName = '';
  
      switch (polaroid.shop_url) {
        case 'https://us.polaroidoriginals.com':
        case 'https://us.impossible-project.com':
          $shop_apiKey = '5fb716aed2b1aaac0a27592c2dd71be0';
          $indexName   = 'shopify_us_products';
          break;
        case 'https://eu.polaroidoriginals.com':
        case 'https://eu.impossible-project.com':
          $shop_apiKey = '5fb716aed2b1aaac0a27592c2dd71be0';
          $indexName   = 'shopify_eu_products';
          break;
        case 'https://uk.polaroidoriginals.com':
        case 'https://uk.impossible-project.com':
          $shop_apiKey = '5fb716aed2b1aaac0a27592c2dd71be0';
          $indexName   = 'shopify_uk_products';
          break;
        case 'https://fr.polaroidoriginals.com':
        case 'https://fr.impossible-project.com':
          $shop_apiKey = '5fb716aed2b1aaac0a27592c2dd71be0';
          $indexName   = 'shopify_fr_products';
          break;
        case 'https://dev.polaroidoriginals.com':
        case 'https://dev.impossible-project.com':
        case 'https://impossibleprojectdev.myshopify.com':
          $shop_apiKey = '5fb716aed2b1aaac0a27592c2dd71be0';
          $indexName   = 'shopify_dev_products';
          break;
        case 'https://ca.polaroidoriginals.com':
        case 'https://ca.impossible-project.com':
        case 'https://impossibleprojectca.myshopify.com':
        case '//localhost:3000':
          $shop_apiKey = '5fb716aed2b1aaac0a27592c2dd71be0';
          $indexName   = 'shopify_ca_products';
          break;
      }
  
      // this is the way algolia suggests handling multiple indexes
      // https://github.com/algolia/instantsearch.js/issues/1056
      var products = instantsearch({
        appId: '97UG6YM7JK',
        apiKey: $shop_apiKey,
        indexName: $indexName,
        urlSync: true,
        searchFunction: function(helper) {
          var searchResults = $('.global-search__results');
          query = products.helper.state.query;
  
          if (helper.state.query === '') {
            searchResults.hide();
            return;
          } else {
            searchResults.show();
  
            faqs.helper.setQuery(query);
            faqs.helper.search();
            articles.helper.setQuery(query);
            articles.helper.search();
            helper.search();
          }
          document.getElementById('search-input').blur();
        }
      });
  
      $('[data-po-do-search]').on('click', function() {
        var query = $('#search-input').val().trim();
  
        products.helper.setQuery(query).search();
      });
  
      var faqs = instantsearch({
        appId: '97UG6YM7JK',
        apiKey: '5fb716aed2b1aaac0a27592c2dd71be0',
        indexName: 'zendesk_impossible_articles',
        searchFunction: function(helper) {
          if (helper.state.query === '') {
            return;
          } else {
            helper.search();
          }
        }
      });
  
      var articles = instantsearch({
        appId: '97UG6YM7JK',
        apiKey: '5fb716aed2b1aaac0a27592c2dd71be0',
        indexName: 'wp_magazine_searchable_posts',
        searchFunction: function(helper) {
          if (helper.state.query === '') {
            return;
          } else {
            helper.search();
          }
        }
      });
  
      // haven't been able to find a way to get access to the actual results
      // from instantsearch. so here we just count the html elements after
      // render
      var onRenderHandler = function() {
        var productHitsCount = $('.ais-hits--item', '#products').length;
        var faqHitsCount = $('.ais-hits--item', '#faqs').length;
        var articleHitsCount = $('.ais-hits--item', '#articles').length;
  
        if (productHitsCount === 0) {
          $('.global-search__products').hide();
        } else {
          $('.global-search__products').show();
        }
  
        if (faqHitsCount === 0) {
          $('.global-search__faqs').hide();
        } else {
          $('.global-search__faqs').show();
        }
  
        if (articleHitsCount === 0) {
          $('.global-search__articles').hide();
        } else {
          $('.global-search__articles').show();
        }
  
        if (productHitsCount === 0 && faqHitsCount === 0 && articleHitsCount === 0) {
          var text = $('.global-search__no-results').data('text').replace('{{ terms }}', query);
          $('.global-search__no-results').text(text);
  
          $('.global-search__no-results').show();
        } else {
          $('.global-search__no-results').hide();
        }
  
        $('.global-search__result--faq').each(function() {
          var $text = $('.global-search__result-text-data', this);
          var $p = $('.global-search__result-text', this);
  
          $p.text($text.text().slice(0, 252) + '...');
        });
      };
  
      products.on('render', onRenderHandler);
      faqs.on('render', onRenderHandler);
      articles.on('render', onRenderHandler);
  
      var productHits = instantsearch.widgets.hits({
        container: '#products',
        hitsPerPage: 12,
        templates: {
          item: document.getElementById('product-template').innerHTML
        },
        transformData: function(item) {
          item.classes = '';
          item.isBundle = false;
  
          item.url = '/products/' + item.handle;
          // Algolia does not return cent prices that Shopify uses (5000 cent), it formats with 2 digits (50 dollar)
          item.price_str = slate.Currency.formatMoney((item.price * 100), polaroid.moneyFormat);
  
          if ( item.compare_at_price && item.compare_at_price > 0 ) {
            item.compare_at_price_str = slate.Currency.formatMoney((item.compare_at_price * 100), polaroid.moneyFormat);
            item.price_classes = 'tomato';
          }
  
          if (item.image != null && typeof item.image == 'string') {
            item.image = item.image.replace('.jpg', '_grande.jpg');
          }
  
          if (item.image == null) {
            item.image = polaroid.no_image_url;
          }
  
          if (item.variant_title !== 'Default Title' && item.variant_title !== '') {
            item.title += ' - ' + item.variant_title;
            item.url += '?variant=' + item.objectID;
          }
  
          if ( item.inventory_policy !== 'continue' && item.inventory_quantity <= 0 ) {
            item.classes += ' product-list-item--sold-out';
            item.button_classes = 'hidden';
          } else {
            item.button_soldout_classes = 'hidden';
          }
  
          if ( item.meta && item.meta.c_f && item.meta.c_f.feature_custom_title ) {
            item.feature_icon = 'icon-features-' + item.meta.c_f.feature_custom_icon;
          }
  
          // Check if product is bundle
          if ( item.handle.indexOf('bundle') > -1 || item.handle.indexOf('starter') > -1 || item.handle.indexOf('triple') > -1 ) {
            item.isBundle = true;
          }
  
          return item;
        }
      });
  
      var faqHits = instantsearch.widgets.hits({
        container: '#faqs',
        hitsPerPage: 4,
        templates: {
          item: document.getElementById('faq-template').innerHTML
        },
        transformData: function(item) {
          var $url = polaroid.support_url + '/hc/articles/' + item.id;
          $url = polaroid.helpers.addShopParams($url);
          item.url = $url;
          return item;
        }
      });
  
      var articleHits = instantsearch.widgets.hits({
        container: document.querySelector('#articles'),
        hitsPerPage: 6,
        templates: {
          item: document.getElementById('article-template').innerHTML
        },
        transformData: function(item) {
          if (item.images && item.images.thumbnail && item.images.thumbnail.url && typeof item.images.thumbnail.url == 'string') {
            // Algolia can only return the thumb 150x150, so we hack this to get the bigger image. It will only work as
            // long as the images are saved as a square and the dimension is not changed on WordPress.
            item.images.thumbnail.url = item.images.thumbnail.url.replace(/-150x150/gi, '-832x832');
          }
          item.permalink = polaroid.helpers.addShopParams(item.permalink);
          return item;
        }
      });
  
      var searchBox = instantsearch.widgets.searchBox({
        container: document.querySelector('#search-input'),
        searchOnEnterKeyPressOnly: true
      });
  
      products.addWidget(productHits);
      products.addWidget(searchBox);
      faqs.addWidget(faqHits);
      faqs.start();
      articles.addWidget(articleHits);
      articles.start();
      products.start();
  
      $('.global-search__input').on('input', function() {
        if ($(this).val() === '') {
          $(this).removeClass('has-text');
        } else {
          $(this).addClass('has-text');
        }
      });
    }
  })();
  

  /*=================== App ====================*/
  polaroid.init = function() {
    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));
  
    $('.in-page-link').on('click', function(evt) {
      slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });
  
    // Wrap videos in div to force responsive layout.
    slate.rte.wrapTable();
    slate.rte.iframeReset();
  
    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
      document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }
  
    // Initializes the state of the app
    polaroid.state.init();
  
    initModules();
    initPages();
  
    // Initializes all the modules needed
    function initModules() {
      polaroid.helpers.init();
      polaroid.carouselsInit();
  
      if ( polaroid.stacks ) polaroid.stacks.init();
      if ( polaroid.cursor ) polaroid.cursor.init();
  
      /**
       * Initializes lazy loading images and background images
       */
      polaroid.images.init();
  
      /**
       * Initializes lazy loading videos
       */
      if ( polaroid.videos ) {
        polaroid.videos.init();
      }
  
      /**
       * Checks for user location and suggests changing shops to the one best suited
       */
      polaroid.geo.init();
  
      /**
       * Initializes image galleries
       */
      $('[data-image-gallery-init]').imageGallery();
  
      /**
       * Initializes buttons to open up the Quickview Modal and Bundle QuickView Modal
       */
      if ( polaroid.quickViewModal ) {
        polaroid.quickViewModal.initButtons();
      }
  
      if ( polaroid.bundleQuickViewModal ) {
        polaroid.bundleQuickViewModal.initButtons();
      }
  
      /**
       * Initializes product standalone modules
       */
      $('[data-product-standalone]').productStandalone();
  
      /**
       * Initializes bundle standalone modules
       */
      $('[data-bundle-standalone]').bundleStandalone();
  
      /**
       * Initializes scroll banners
       */
      $('[data-scroll-banner]').scrollBanner();
  
      /**
       * Initializes collection tease modules
       */
      $('[data-collection-tease]').collectionTease();
  
      /**
       * Initializes modals and buttons to open them
       */
      $('[data-modal-init]').modal();
  
      /**
       * Initializes modals for YouTube videos using jQuery modal-videos plugin
       *
       * Custom forked version here: https://github.com/holgadosebastian/modal-video
       */
      polaroid.modalVideo.init();
  
      /**
       * Initializes newsletter subscription form
       */
      if ( polaroid.newsletter ) {
        polaroid.newsletter.init();
      }
  
      /**
       * Initializes feature comparison module
       */
      $('[data-feature-comparison]').featureComparison();
  
      /**
       * Initializes custom cart view
       */
      polaroid.cartController.init();
  
      /**
       * Initializes go to checkout loading buttons
       */
      $('[data-go-to-checkout-button]').button({
        loader: true,
        loadingText: 'Going to Checkout...',
        preventDefault: false,
        onClick: function() {
          $('.back-from-checkout').val(1);
        },
        tracking: {
          clickAction: 'Go to Checkout'
        }
      });
  
      /**
       * Initializes popup components
       */
      $('.po-popup').popup();
  
      /**
       * Initializes smooth scrolling buttons
       */
      $('[data-smooth-scroll]').smoothScroll();
  
      /**
       * Initializes javascript href parent interactivity
       */
      polaroid.helpers.setupClickAreas($('.js_clickable'));
  
      /**
       * Initializes collapsable elements
       */
      polaroid.helpers.setupCollapseElements('.collapser', {});
  
      /**
       * Initializes page header
       */
      if ( polaroid.header ) {
        polaroid.header.init();
      }
  
      /**
       * Initializes page sub navigation module
       */
      $('[data-page-nav]').pageNav();
  
      /**
       * Initializes document scroll event
       */
      polaroid.documentScroll.init();
  
      /**
       * Disables iOS scrolling rubber effect
       */
      polaroid.disableScrolling();
  
      /**
       * Initializes accordion modules
       */
      $('[data-faq]').accordion({
        tracking: {
          category: 'FAQ Module'
        }
      });
  
      /**
       * Initializes features module
       */
      polaroid.oneStepFeatures.init();
    }
  
    // Initializes template related scripts
    function initPages() {
  
      /**
       * Initializes homepage
       */
      if ( polaroid.homepage ) {
        polaroid.homepage.init();
      }
  
      /**
       * Initializes instant film page
       */
      if ( polaroid.instantFilm ) {
        polaroid.instantFilm.init();
      }
  
      /**
       * Initializes product page
       */
      if ( polaroid.page.isProductPage ) {
        var sections = new slate.Sections();
        sections.register('product', polaroid.Product);
      }
  
      /**
       * Initializes collection template search functionality
       */
      if ( polaroid.collection ) {
        polaroid.collection.init();
      }
  
      /**
       * Initializes performance landing pages
       */
      if ( polaroid.initLandingPages ) {
        polaroid.initLandingPages();
      }
    }
  };
  
  $(document).ready(function() {
    polaroid.init();
  });
  
}());
